export const ru = {
  app: {
    home: 'Главная',
    playerScout: 'Скаут игроков',
    playerComparison: 'Сравнение игроков',
    playerRecruitment: 'Радар',
    collections: 'Коллекции',
    favoritePlayers: 'Избранные игроки',
    teamAnalytics: 'Аналитика команды',
    gameAnalysis: 'Анализ матча',
    seasonStats: 'Статистика сезона',
    leagueTable: 'Турнирная таблица',
    scoresAndFixtures: 'Результаты и расписание',
    notifications: 'Уведомления',
    administration: 'Администрирование',
    inbox: 'Входящие',
    teamStats: 'Статистика команды',
    blog: 'Блог',
    leagues: 'Лиги',
    squadBuilder: 'Конструктор состава',
    playerAlerts: 'Уведомления об игроках',
    searchAlerts: 'Уведомления поиска',
    videoUploadTool: 'Инструмент загрузки видео',
    videoPlaylists: 'Плейлисты',
    uploadedGames: 'Загруженные игры',
    favoriteTeams: 'Избранные команды',
    arrigo: 'Arrigo',
    validateEvents: 'Проверка событий'
  },
  playerRecruitment: {
    title: 'Карточка игрока',
    subtitle: 'Углубитесь в характеристики и статистику игрока',
    league: 'Лига',
    selectedSeason: 'Выбранный сезон',
    year: 'Год',
    radar: 'Радар',
    positions: 'Позиции',
    numberOfPlayers: 'Количество игроков',
    template: 'Шаблон',
    compareWith: 'Сравнить с',
    previousPerformance: 'Предыдущие выступления',
    xGames: '{0} игр',
    average: 'Среднее',
    leagueAverage: 'Среднее по лиге',
    selectSeason: 'Выберите сезон',
    positionsPlayed: 'Сыгранные позиции',
    minMax: 'Мин и Макс',
    top5Leagues: 'Топ-5 лиг',
    infoMessage: 'Отметьте только один сезон, чтобы включить Мин и Макс сезона',
    infoMessage2: 'Выберите один и тот же сезон для обоих игроков',
    dataPer90MinText: 'Данные за 90 минут',
    adjustToPossessionText: '* Скорректировано с учетом владения мячом',
    text: 'Текст',
    lollipop: 'Леденец',
    polar: 'Полярный',
    noGamesBetweenDates: 'Не найдено матчей между выбранными датами',
    radarTemplates: {
      Goalkeeper: 'Вратарь',
      GoalkeeperCustom: 'Вратарь (Пользовательский)',
      GoalkeeperCustom1: 'Вратарь (Пользовательский 1)',
      GoalkeeperCustom2: 'Вратарь (Пользовательский 2)',
      GoalkeeperCustom3: 'Вратарь (Пользовательский 3)',
      GoalkeeperCustom4: 'Вратарь (Пользовательский 4)',
      GoalkeeperCustom5: 'Вратарь (Пользовательский 5)',
      GoalkeeperCustom6: 'Вратарь (Пользовательский 6)',
      Defender: 'Защитник',
      DefenderCustom: 'Защитник (Пользовательский)',
      DefenderCustom1: 'Защитник (Пользовательский 1)',
      DefenderCustom2: 'Защитник (Пользовательский 2)',
      DefenderCustom3: 'Защитник (Пользовательский 3)',
      DefenderCustom4: 'Защитник (Пользовательский 4)',
      DefenderCustom5: 'Защитник (Пользовательский 5)',
      DefenderCustom6: 'Защитник (Пользовательский 6)',
      FullBack: 'Крайний защитник',
      FullBackCustom: 'Крайний защитник (Пользовательский)',
      FullBackCustom1: 'Крайний защитник (Пользовательский 1)',
      FullBackCustom2: 'Крайний защитник (Пользовательский 2)',
      FullBackCustom3: 'Крайний защитник (Пользовательский 3)',
      FullBackCustom4: 'Крайний защитник (Пользовательский 4)',
      FullBackCustom5: 'Крайний защитник (Пользовательский 5)',
      FullBackCustom6: 'Крайний защитник (Пользовательский 6)',
      FullBackPredictive: 'Крайний защитник',
      Midfielder: 'Полузащитник',
      MidfielderCustom: 'Полузащитник (Пользовательский)',
      MidfielderCustom1: 'Полузащитник (Пользовательский 1)',
      MidfielderCustom2: 'Полузащитник (Пользовательский 2)',
      MidfielderCustom3: 'Полузащитник (Пользовательский 3)',
      MidfielderCustom4: 'Полузащитник (Пользовательский 4)',
      MidfielderCustom5: 'Полузащитник (Пользовательский 5)',
      MidfielderCustom6: 'Полузащитник (Пользовательский 6)',
      MidfielderPredictive: 'Полузащитник',
      MidfielderDefensive: 'Опорный полузащитник',
      MidfielderOffensive: 'Атакующий полузащитник',
      AttackingMidfielder: 'Атакующий полузащитник',
      MidfielderWing: 'Крайний полузащитник',
      Winger: 'Вингер',
      WingerCustom: 'Вингер (Пользовательский)',
      WingerCustom1: 'Вингер (Пользовательский 1)',
      WingerCustom2: 'Вингер (Пользовательский 2)',
      WingerCustom3: 'Вингер (Пользовательский 3)',
      WingerCustom4: 'Вингер (Пользовательский 4)',
      WingerCustom5: 'Вингер (Пользовательский 5)',
      WingerCustom6: 'Вингер (Пользовательский 6)',
      WingerOffensive: 'Атакующий вингер',
      Forward: 'Нападающий',
      ForwardCustom: 'Нападающий (Пользовательский)',
      ForwardCustom1: 'Нападающий (Пользовательский 1)',
      ForwardCustom2: 'Нападающий (Пользовательский 2)',
      ForwardCustom3: 'Нападающий (Пользовательский 3)',
      ForwardCustom4: 'Нападающий (Пользовательский 4)',
      ForwardCustom5: 'Нападающий (Пользовательский 5)',
      ForwardCustom6: 'Нападающий (Пользовательский 6)',
      ForwardPredictive: 'Нападающий',
      WingBack: 'Крайний защитник (винг-бек)',
      WingBackCustom: 'Крайний защитник (винг-бек) (Пользовательский)',
      WingBackCustom1: 'Крайний защитник (винг-бек) (Пользовательский 1)',
      WingBackCustom2: 'Крайний защитник (винг-бек) (Пользовательский 2)',
      WingBackCustom3: 'Крайний защитник (винг-бек) (Пользовательский 3)',
      WingBackCustom4: 'Крайний защитник (винг-бек) (Пользовательский 4)',
      WingBackCustom5: 'Крайний защитник (винг-бек) (Пользовательский 5)',
      WingBackCustom6: 'Крайний защитник (винг-бек) (Пользовательский 6)',
      WingBackMedia: 'Крайний защитник (винг-бек) (Соцсети)',
      FullBackMedia: 'Крайний защитник (Соцсети)',
      MidfielderMedia: 'Полузащитник (Соцсети)',
      WingerMedia: 'Вингер (Соцсети)',
      ForwardMedia: 'Нападающий (Соцсети)',
      PhysicalWingBack: 'Крайний защитник (винг-бек) (Физика)',
      PhysicalForward: 'Нападающий (Физика)',
      PhysicalWinger: 'Вингер (Физика)',
      PhysicalMidfielder: 'Полузащитник (Физика)',
      PhysicalFullBack: 'Крайний защитник (Физика)',
      PhysicalDefender: 'Защитник (Физика)',
      PhysicalWingBackLMO: 'Крайний защитник (винг-бек) (Физика)',
      PhysicalForwardLMO: 'Нападающий (Физика)',
      PhysicalWingerLMO: 'Вингер (Физика)',
      PhysicalMidfielderLMO: 'Полузащитник (Физика)',
      PhysicalFullBackLMO: 'Крайний защитник (Физика)',
      PhysicalDefenderLMO: 'Защитник (Физика)'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Вратарь',
      Defender: 'Защитник',
      FullBack: 'Крайний защитник',
      FullBackPredictive: 'Крайний защитник',
      Midfielder: 'Полузащитник',
      MidfielderPredictive: 'Полузащитник',
      MidfielderDefensive: 'Опорный полузащитник',
      MidfielderOffensive: 'Атакующий полузащитник',
      AttackingMidfielder: 'Атакующий полузащитник',
      MidfielderWing: 'Крайний полузащитник',
      Winger: 'Вингер',
      WingerOffensive: 'Атакующий вингер',
      Forward: 'Нападающий',
      ForwardPredictive: 'Нападающий',
      WingBack: 'Крайний защитник (винг-бек)',
      WingBackMedia: 'Крайний защитник (винг-бек) (Соцсети)',
      FullBackMedia: 'Крайний защитник (Соцсети)',
      MidfielderMedia: 'Полузащитник (Соцсети)',
      WingerMedia: 'Вингер (Соцсети)',
      ForwardMedia: 'Нападающий (Соцсети)',
      PhysicalWingBack: 'Крайний защитник (винг-бек) (Физика)',
      PhysicalForward: 'Нападающий (Физика)',
      PhysicalWinger: 'Вингер (Физика)',
      PhysicalMidfielder: 'Полузащитник (Физика)',
      PhysicalFullBack: 'Крайний защитник (Физика)',
      PhysicalDefender: 'Защитник (Физика)',
      PhysicalWingBackLMO: 'Крайний защитник (винг-бек) (Физика)',
      PhysicalForwardLMO: 'Нападающий (Физика)',
      PhysicalWingerLMO: 'Вингер (Физика)',
      PhysicalMidfielderLMO: 'Полузащитник (Физика)',
      PhysicalFullBackLMO: 'Крайний защитник (Физика)',
      PhysicalDefenderLMO: 'Защитник (Физика)'
    },
    radarDescription: {
      basicStatistics: {
        title: 'ОСНОВНАЯ СТАТИСТИКА',
        minutes: 'минуты',
        goals: 'голы',
        assists: 'голевые передачи',
        redCards: 'красные карточки',
        yellowCards: 'желтые карточки',
        games: 'игры',
        goalsReceived: 'голы без пенальти',
        xGFaced: 'ожидаемые голы (xG) пропущенные'
      },
      profiles: {
        3: {
          1: 'Техничный вратарь с хорошей игрой ногами, эффективен как в коротких, так и в длинных передачах.',
          2: 'Умение играть ногами и играть важную роль в начале игры, с хорошим процентом пасов как на короткие, так и на длинные дистанции.',
          3: 'Хорошая работа ног, которая делает этот профиль интересным вариантом из-за его показателей прохождения.',
          4: 'Профиль, который выделяется своими передачами как на своем поле, так и на поле соперника.',
          5: 'Отличная безопасность с мячом у ног и высокие навыки передачи.',
          6: 'Хорошая работа ног, обеспечивающая безопасность при запуске мяча и выполнении большого количества коротких и длинных передач.',
          7: 'Высокий процент выполненных проходов, как коротких, так и длинных, что обеспечивает качество в обращении.'
        },
        5: {
          1: 'Защитник, отличающийся хорошей игрой один в один и большим количеством отборов и перехватов.',
          2: 'Очень эффективный центральный защитник в индивидуальных поединках, как сверху, так и в подкате, с хорошим прогнозированием.',
          3: 'Центральная защита с хорошими показателями в индивидуальных защитных поединках, что приводит к большому объему подборов.',
          4: 'Профиль с высоким уровнем защиты, способный отбирать большой объем мячей благодаря отборам и перехватам.',
          5: 'Очень эффективная защита в отборе и с большим количеством перехватов, выделяющаяся в индивидуальном противостоянии.',
          6: 'Центральный защитник с большим количеством подборов за игру, умеет читать игру соперника и подрезать мяч, обладает высокой точностью и частотой отборов мяча.',
          7: 'Оборонительный профиль с большим количеством подборов благодаря эффективности и частоте отборов, а также хорошему чтению для прогнозирования.'
        },
        6: {
          1: 'Защитник с большим вкладом в создание моментов и хорошим видением игры.'
        },
        7: {
          1: 'Игрок со сбалансированной игрой между атакой (большой вклад в "xG Buildup") и защитой (большой объем отборов).'
        },
        8: {
          1: 'Надежен в защитных единоборствах и имеет большой объем отборов, как в отборах, так и в перехватах.'
        },
        9: {
          1: 'Игрок с большим атакующим вкладом, создающий опасные моменты и голевые возможности.'
        },
        10: {
          1: 'Универсальный игрок, способный покрывать много пространства, внося вклад как в отборах, так и имея значительный процент "xG Buildup" относительно общего количества того, что создает команда.'
        },
        11: {
          1: 'Полузащитник с высокой защитной эффективностью и отличной точностью передач, несмотря на ограниченное влияние в атаке.'
        },
        12: {
          1: 'Универсальный полузащитник с большим вкладом в создание моментов и хорошей эффективностью в воздухе, а также большим количеством перехватов и отборов.'
        },
        15: {
          1: 'Вингер с навыками один в один и хорошим уровнем точных навесов, создающий больше ожидаемых передач, чем ударов.'
        },
        16: {
          1: 'Игрок с большим объемом передач за спину и продвижений с мячом, также создающий моменты и имеющий большее влияние на владение мячом в центре, чем обычный вингер.'
        },
        17: {
          1: 'Игрок с хорошими навыками дриблинга, часто режется внутрь, чтобы создавать больше ударов (xG), чем ключевых передач (xA).'
        },
        18: {
          1: 'Нападающий, отлично работающий без мяча, демонстрирующий хорошее принятие решений о том, когда завершить атаку ударом, а когда отдать пас.'
        },
        22: {
          1: 'Нападающий с отличной мобильностью для приема передач за спину, отходом на фланг и высоким уровнем созданных моментов. Высокий процент касаний вне штрафной площади относительно общего количества касаний за игру.'
        }
      },
      description: 'ОПИСАНИЕ',
      conjuction: ' и ',
      conjuction2: ' и ',
      over: 'выше',
      under: 'ниже',
      respectively: ', соответственно',
      Defending1: {
        1: 'Защитная эффективность находится среди худших в топ-5 лигах'
      },
      Defending2: {
        1: 'Игрок плохо играет в защите, так как эффективность ниже среднего'
      },
      Defending3: {
        1: 'Игрок показывает средний уровень, немного выше_ниже_среднего среднего'
      },
      Defending4: {
        1: 'Выдающаяся работа в защитных задачах с эффективностью выше среднего'
      },
      Defending5: {
        1: 'Выдающийся в защитных задачах, с эффективностью, аналогичной лучшим player_positions топ-5 лиг'
      },
      Saving1: {
        1: 'Вратарь с очень низкой эффективностью, с большими трудностями в отражении мяча'
      },
      Saving2: {
        1: 'Не показывает хорошей игры как вратарь, так как уровень ниже среднего'
      },
      Saving3: {
        1: 'Вратарь с приемлемой эффективностью, находится в среднем показателе 5 лучших лиг, необходимо улучшить metric_name'
      },
      Saving4: {
        1: 'Вратарь с хорошим уровнем выше среднего 5 лучших лиг, особенно выделяясь в metric_name'
      },
      Saving5: {
        1: 'Очень универсальный игрок в отражении, с метриками, которые помещают этот профиль в топ-20% по сравнению с вратарями топ-5 лиг Европы.'
      },
      Passing1: {
        1: 'С мячом уровень находится среди худших игроков'
      },
      Passing2: {
        1: 'Что касается передач, эффективность ниже среднего'
      },
      Passing3: {
        1: 'Уровень передач приемлемый, немного выше_ниже_среднего среднего'
      },
      Passing4: {
        1: 'Очень хороший уровень передач, значительно выше среднего'
      },
      Passing5: {
        1: 'Отличная эффективность передач с результативностью выше, чем у большинства игроков'
      },
      Aerial1: {
        1: 'Очень слабый игрок в игре в воздухе, среди худших на позиции в этом аспекте'
      },
      Aerial2: {
        1: 'Что касается выигрыша верховых мячей, игрок не показывает хороших результатов, ниже среднего'
      },
      Aerial3: {
        1: 'Приемлемый уровень в игре в воздухе, немного выше_ниже_среднего среднего'
      },
      Aerial4: {
        1: 'Отличная эффективность в игре в воздухе, с высокой результативностью в этом отношении'
      },
      Aerial5: {
        1: 'Метрики в игре в воздухе помещают этот профиль в число лучших'
      },
      Shooting1: {
        1: 'Очень слабая статистика перед воротами, среди худших игроков в этом отношении'
      },
      Shooting2: {
        1: 'Очень улучшаемый уровень ударов, ниже среднего'
      },
      Shooting3: {
        1: 'Приемлемая эффективность в атакующей работе, немного выше_ниже_среднего среднего'
      },
      Shooting4: {
        1: 'Очень хорошо играет в штрафной, с эффективностью выше 60% игроков'
      },
      Shooting5: {
        1: 'Отличные навыки в атакующих задачах, со впечатляющей эффективностью, помещая этого игрока среди лучших в этом отношении'
      },
      Association1: {
        1: 'Эффективность ассоциативной игры с мячом очень низкая, среди худших топ-5 лиг'
      },
      Association2: {
        1: 'Есть много что улучшить с мячом в ногах, так как эффективность ниже среднего в этом аспекте'
      },
      Association3: {
        1: 'Хорошо ассоциируется с мячом, немного выше_ниже_среднего среднего'
      },
      Association4: {
        1: 'Очень хорошо ассоциируется с мячом, демонстрируя очень заметный уровень'
      },
      Association5: {
        1: 'Необычайная способность к ассоциативной игре с мячом в ногах, среди лучших игроков'
      },
      BallHandling1: {
        1: 'Ужасная эффективность владения мячом, среди худших по сравнению с 5 топ-лигами'
      },
      BallHandling2: {
        1: 'Что касается владения мячом, уровни ниже среднего'
      },
      BallHandling3: {
        1: 'Приемлемый уровень владения мячом, немного выше_ниже_среднего среднего'
      },
      BallHandling4: {
        1: 'Высокий уровень в плане владения мячом, с показателями, близкими к лучшим в этом аспекте'
      },
      BallHandling5: {
        1: 'Исключительная способность владения мячом, среди лучших в 5 топ-лигах'
      },
      Crosses1: {
        1: 'Низкая эффективность навесов в штрафную. Среди худших игроков по метрикам навесов'
      },
      Crosses2: {
        1: 'Эффективность ниже среднего в создании опасности навесами'
      },
      Crosses3: {
        1: 'Приемлемый уровень навесов в штрафную, немного выше_ниже_среднего'
      },
      Crosses4: {
        1: 'Хорошая статистика навесов, значительно выше среднего'
      },
      Crosses5: {
        1: 'Очень высокая эффективность навесов в штрафную, конкретно, среди топ-20% наиболее эффективных профилей в этой категории'
      },
      Carries1: {
        1: 'Среди 20% игроков с худшими показателями в плане ведения мяча'
      },
      Carries2: {
        1: 'Эффективность ведения мяча далека от среднего для игроков на этой позиции'
      },
      Carries3: {
        1: 'Близко к среднему показателю, немного выше_ниже_среднего, в плане ведения мяча'
      },
      Carries4: {
        1: 'Выдающийся игрок с очень хорошими показателями глубины и ведения мяча'
      },
      Carries5: {
        1: 'Очень талантлив в ведении мяча, с высокой эффективностью в метриках категории ведения'
      },
      Turnovers1: {
        1: 'Эффективность очень негативная с большим объемом потерь мяча, которые облегчают соперникам создание опасности. Среди худших в этой метрике'
      },
      Turnovers2: {
        1: 'Игрок помогает соперникам многочисленными опасными потерями мяча; требуется много улучшений для их сокращения'
      },
      Turnovers3: {
        1: 'Этот игрок немного выше_ниже_среднего в плане потерь мяча, поэтому все еще есть возможности для улучшения эффективности'
      },
      Turnovers4: {
        1: 'Замечательная эффективность в потерях мяча, выше 60% игроков, которые теряют меньше всего мячей'
      },
      Turnovers5: {
        1: 'Стоит отметить малое количество потерь мяча, что помещает этого игрока в число лучших игроков во владении для команды'
      },
      SequenceInvolvement1: {
        1: 'В плане владения мячом цифры говорят плохо об этом игроке, который очень редко завершает действия ударом'
      },
      SequenceInvolvement2: {
        1: 'Завершение владений довольно улучшаемо; они почти никогда не завершаются ударом, и это помещает эффективность значительно ниже среднего'
      },
      SequenceInvolvement3: {
        1: 'Приемлемый уровень в завершении владений перед воротами, с процентилем немного выше_ниже_среднего среднего, имея большие возможности для улучшения'
      },
      SequenceInvolvement4: {
        1: 'Хорошая способность завершать владения команды ударами, некоторые из которых заканчиваются голами, таким образом имея замечательную эффективность в этой категории'
      },
      SequenceInvolvement5: {
        1: 'Среди лучших в завершении владений команды, последовательно завершая их ударами, которые создают опасность'
      },
      OutPlay1: {
        1: 'Можно определить, что игрок имеет минимальное влияние на разрушение защитных структур'
      },
      OutPlay2: {
        1: 'Вклад в продвижение и разрушение обороны ниже стандартов позиции'
      },
      OutPlay3: {
        1: 'Способен создавать преимущества время от времени, играя около среднего для этой позиции'
      },
      OutPlay4: {
        1: 'Часто вносит вклад в прорыв защитных линий и создание дисбаланса'
      },
      OutPlay5: {
        1: 'Помещен среди лучших исполнителей на позиции в устранении соперников и создании продвижений'
      },
      LineBreakingPasses1: {
        1: 'Редко пытается или выполняет передачи, которые прорывают защитные линии, с очень скудным вкладом в эти действия'
      },
      LineBreakingPasses2: {
        1: 'Испытывает трудности в постоянном поиске партнеров между линиями или за спиной защиты, с вкладом, который помещает этого игрока ниже стандартов для этой позиции'
      },
      LineBreakingPasses3: {
        1: 'Игрок предоставляет случайные передачи, прорывающие линии, находясь около среднего для этой позиции в этих терминах'
      },
      LineBreakingPasses4: {
        1: 'Можно определить, что игрок часто прорывает линии передачами и помогает разбалансировать блоки соперников'
      },
      LineBreakingPasses5: {
        1: 'Среди наиболее эффективных пасующих в лиге в прорыве линий и разблокировке давления; это одна из главных сильных сторон в игре'
      },
      PassUnderPressure1: {
        1: 'Видно, что хладнокровие и эффективность снижаются, когда соперники закрывают'
      },
      PassUnderPressure2: {
        1: 'Игрок испытывает трудности в поддержании точности передач в ситуациях высокого давления'
      },
      PassUnderPressure3: {
        1: 'Игрок находится около среднего в плане передач под давлением; давление обрабатывается разумно хорошо, хотя без последовательно чистого исполнения'
      },
      PassUnderPressure4: {
        1: 'Есть частый успех в поиске партнеров, несмотря на давление, показывая эффективность выше среднего в таких передачах'
      },
      PassUnderPressure5: {
        1: 'Выдающееся хладнокровие и точность при передачах под интенсивным давлением, помещая эффективность среди лучших на позиции в этом аспекте'
      },
      BallReceived1: {
        1: 'Получает очень мало передач в продвинутых зонах; не игрок, который регулярно действует между линиями'
      },
      BallReceived2: {
        1: 'Собирает некоторые незакрытые приемы в половине соперника, но без особой последовательности'
      },
      BallReceived3: {
        1: 'Записывает средний объем беспрепятственных приемов в атакующих зонах'
      },
      BallReceived4: {
        1: 'Часто получает между линиями и в зонах, свободных от давления'
      },
      BallReceived5: {
        1: 'Накопляет много приемов между линиями, свободных от защитников и в вероятных ключевых зонах'
      },
      OnBallPressure1: {
        1: 'Редко прессингует и почти никогда не делает это рядом с игроком с мячом. Не интенсивный игрок'
      },
      OnBallPressure2: {
        1: 'Участвует в некоторых сильных прессингах, но не часто. Общая интенсивность довольно низкая'
      },
      OnBallPressure3: {
        1: 'Записывает средний объем прессингов близко к сопернику во владении'
      },
      OnBallPressure4: {
        1: 'Дисциплинированный прессингующий, который регулярно приближается к игроку с мячом'
      },
      OnBallPressure5: {
        1: 'Очень интенсивен без мяча, высоко дисциплинирован и усердно работает, чтобы прессинговать соперника'
      },
      SpatialCoverage1: {
        1: 'Игрок показывает очень ограниченный вклад в занятие и контроль пространства, с минимальным участием в построении и тактической структуре команды. Пространственное покрытие плохое как во владении, так и без него, отражая малое влияние на коллективную организацию и компактность'
      },
      SpatialCoverage2: {
        1: 'Игрок предоставляет ниже среднего пространственное покрытие, показывая некоторое участие в занятии поля, но с пробелами в позиционной непрерывности и сплоченности с остальной командой. Влияние на тактическую структуру прерывистое и менее последовательное, чем у игроков более высокого ранга'
      },
      SpatialCoverage3: {
        1: 'Игрок демонстрирует среднее пространственное покрытие, стабильно внося вклад в занятие и контроль пространства. Позиционирование в целом правильное и функциональное, участвуя в тактической структуре команды с умеренным влиянием как в атакующей, так и в защитной фазах'
      },
      SpatialCoverage4: {
        1: 'Игрок предлагает выше среднего пространственное покрытие, показывая высокое участие в занятии поля и позиционной структуре команды. Способность поддерживать форму и адаптироваться к переходам значительно способствует компактности и контролю ключевых пространств'
      },
      SpatialCoverage5: {
        1: 'Игрок достигает отличного уровня пространственного покрытия, оптимизируя позиционирование для решающего влияния на построение и тактическую структуру команды. Понимание игры и синхронизация с остальным блоком позволяют максимизировать занятие стратегических пространств, как в атаке, так и в защите'
      },
      OffBallPressure1: {
        1: 'Игрок применяет очень ограниченное защитное давление без мяча, редко вступая в контакт с соперниками, чтобы нарушить их действия или заставить ошибиться. Вклад в прессинг и защитную структуру минимален'
      },
      OffBallPressure2: {
        1: 'Игрок предоставляет ниже среднего защитное давление без мяча, иногда вступая в контакт с соперниками, но с непоследовательным таймингом или позиционированием. Усилия имеют ограниченное влияние на возврат владения или нарушение построения соперников'
      },
      OffBallPressure3: {
        1: 'Игрок демонстрирует средний уровень давления без мяча, стабильно внося вклад в защитные усилия команды. Позиционирование и тайминг в целом эффективны, применяя адекватное давление, чтобы замедлить или ограничить варианты соперников'
      },
      OffBallPressure4: {
        1: 'Игрок предлагает выше среднего защитное давление без мяча, часто нарушая действия соперников и уменьшая их время и пространство. Усилия хорошо рассчитаны и скоординированы, помогая команде поддерживать сильную защитную структуру'
      },
      OffBallPressure5: {
        1: 'Игрок превосходен в применении защитного давления без мяча, последовательно беспокоя соперников, заставляя терять мяч и ограничивая коридоры передач. Интенсивность, позиционирование и предвидение значительно повышают защитную эффективность команды'
      },
      Distance1: {
        1: 'Игрок покрывает значительно меньше пространства, чем в среднем (движение на поле очень ограничено)'
      },
      Distance2: {
        1: 'Пройденное расстояние за матч ниже того, что обычно видно в топ-уровневом футболе (не так активен, как в среднем)'
      },
      Distance3: {
        1: 'Игрок покрывает разумное количество пространства, с цифрами около среднего по лиге (физическое участие сбалансировано)'
      },
      Distance4: {
        1: 'Игрок последовательно покрывает большие расстояния, с цифрами, отражающими сильную выносливость (показывая солидную физическую отдачу)'
      },
      Distance5: {
        1: 'Физический объем выдающийся, среди наиболее активных в топ-5 лигах в плане пройденного пространства'
      },
      Sprint1: {
        1: 'Делает очень мало скоростных рывков по сравнению со средним (игра включает минимальные усилия спринта в матчах)'
      },
      Sprint2: {
        1: 'Частота спринтов ниже среднего для позиции (ограниченная взрывная сила в плане скоростных движений)'
      },
      Sprint3: {
        1: 'Выполняет умеренное количество спринтов за игру, в пределах ожидаемого среднего (значения около среднего по лиге)'
      },
      Sprint4: {
        1: 'Выделяется частотой спринтов, значительно выше среднего. Показывает последовательную взрывную силу, внося вклад скоростными рывками на протяжении матча'
      },
      Sprint5: {
        1: 'Помещен в топ-20% игроков с наибольшим объемом спринтов за 90 минут. Топовая физическая эффективность в плане повторяющихся скоростных усилий'
      },
      Acceleration1: {
        1: 'Способность менять темп явно ниже среднего, с очень малым количеством взрывных ускорений во время матча'
      },
      Acceleration2: {
        1: 'Результат ускорения ниже среднего по сравнению с похожими игроками, потому что есть ограниченная частота коротких рывков'
      },
      Acceleration3: {
        1: 'Записывает справедливое количество ускорений, близко к среднему по лиге. Изменения темпа не выделяются, но цифры правильные в рамках этой метрики'
      },
      Acceleration4: {
        1: 'Демонстрирует сильную способность быстро и повторно ускоряться, с темпом ускорения явно выше среднего и частыми короткими рывками'
      },
      Acceleration5: {
        1: 'Среди топ-20% наиболее взрывных игроков в плане повторяющихся ускорений, поддерживая значительно выше среднего цифры в быстрых стартах и изменениях темпа'
      },
      Speed1: {
        1: 'Вероятно, физически медленный игрок или тот, кто экономит высокоинтенсивные усилия во время игр'
      },
      Speed2: {
        1: 'Записывает максимальные скорости немного ниже конкурентного среднего'
      },
      Speed3: {
        1: 'Поддерживает средние значения максимальной скорости на протяжении матча'
      },
      Speed4: {
        1: 'Часто достигает высоких скоростей, предполагая быстрый и мощный профиль'
      },
      Speed5: {
        1: 'Достигает очень высоких максимальных скоростей. Вероятно, игрок, создающий разницу в плане скорости'
      },
      LineBreakingCarries1: {
        1: 'Редко прорывает линии через ведение мяча. Не хватает инициативы, когда дело доходит до продвижения с мячом'
      },
      LineBreakingCarries2: {
        1: 'Выполняет некоторые ведения, которые прорывают линии, но без особой регулярности'
      },
      LineBreakingCarries3: {
        1: 'В среднем умеренное количество успешных ведений, прорывающих линии'
      },
      LineBreakingCarries4: {
        1: 'Вносит вклад в построение, часто ведя мяч мимо линий и поддерживая продвижение'
      },
      LineBreakingCarries5: {
        1: 'Настоящий специалист в ведении. Последовательно прорывает линии с мячом и в большом объеме'
      },
      LineBreakingActions1: {
        1: 'Записывает очень мало действий, прорывающих линии (передачи и ведения). Редко рискует'
      },
      LineBreakingActions2: {
        1: 'Производит некоторые прогрессивные действия (передачи и ведения), но редко. Склонен играть более горизонтально'
      },
      LineBreakingActions3: {
        1: 'Комбинирует передачи и ведения, которые регулярно прорывают линии. Вносит вклад в продвижение'
      },
      LineBreakingActions4: {
        1: 'Технически умелый и умный, чтобы производить много действий (передачи и ведения), которые прорывают линии соперников'
      },
      LineBreakingActions5: {
        1: 'Настоящий специалист по продвижению. Имеет большое влияние в команде, постоянно прорывая линии с мячом через передачи и ведения'
      },
      OffBallRuns1: {
        1: 'Игрок делает очень мало целенаправленных движений без мяча, предлагая ограниченную поддержку атакующей фазе. Забеги без мяча редко способствуют созданию пространства, нарушению защитных линий или улучшению координации команды во владении'
      },
      OffBallRuns2: {
        1: 'Игрок предоставляет ниже среднего движение без мяча, иногда поддерживая атаку, но не хватает последовательности в тайминге, направлении или тактическом намерении. Забеги имеют ограниченное влияние на открытие пространств или улучшение атакующей структуры'
      },
      OffBallRuns3: {
        1: 'Игрок демонстрирует средний уровень целенаправленных забегов без мяча, стабильно внося вклад в атакующую фазу. Движения в целом хорошо рассчитаны и функциональны, создавая пространство и поддерживая командную игру с умеренным влиянием'
      },
      OffBallRuns4: {
        1: 'Игрок показывает выше среднего активность без мяча, часто делая целенаправленные забеги, которые нарушают защитные структуры, создают варианты передач и открывают атакующие пространства. Паттерны движений значительно способствуют координации команды во владении'
      },
      OffBallRuns5: {
        1: 'Игрок превосходен в целенаправленных движениях без мяча, последовательно предвидя игру и делая умные забеги, которые максимизируют атакующие возможности. Тайминг, позиционирование и пространственное осознание создают постоянные угрозы и улучшают текучесть команды во владении'
      },
      OverMaxValue: {
        1: 'Есть экстремальная способность в over_max_metric_name, с эффективностью выше максимального значения, что помещает этого игрока в этом аспекте в топ-10% топ-5 лиг'
      },
      OverAverageSeason: {
        1: 'Что касается эффективности в over_average_metric_name, уровень выше среднего лиги league_name (over_average_metric_value против average_metric_value)',
        2: 'Сравнивая цифры с цифрами лиги league_name в over_average_metric_name, эффективность выше среднего (over_average_metric_value против average_metric_value)'
      },
      UnderMinValue: {
        1: 'Что касается under_min_metric_name, следует значительно улучшить эффективность, так как это помещает его в самый низкий percent_metric_name топ-5 лиг'
      },
      Over70Percent: {
        1: ', особенно выделяясь в over_70_metric_name с over_70_metric_value за 90 минут, соответственно',
        2: ', выше 70% в over_70_metric_name с over_70_metric_value за 90 минут, соответственно',
        3: ', выполняя более чем замечательную работу в over_70_metric_name с over_70_metric_value за 90 минут, соответственно'
      },
      Under30Percent: {
        1: ', необходимо работать усерднее в under_30_metric_name, потому что с under_30_metric_value за 90 минут, соответственно, эффективность низкая',
        2: ', необходимо значительно улучшить в under_30_metric_name, так как с under_30_metric_value за 90 минут, соответственно, эффективность ниже ожидаемой',
        3: ', что касается under_30_metric_name с under_30_metric_value за 90 минут соответственно, необходимо приложить больше усилий, чтобы получить лучшие цифры'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Хорошо выделить эффективность, превышающую среднее лиги league_name в '
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value против average_metric_value в среднем)'
      },
      Over70PercentIndividualPressure: {
        1: ', делая очень хороший индивидуальный прессинг для возврата мяча',
        2: ', высокий прессинг на соперника для возврата мяча'
      },
      Under30PercentIndividualPressure: {
        1: ', необходимо усилить прессинг больше, чтобы вернуть мяч',
        2: ', необходимо приложить больше усилий в плане прессинга соперника'
      }
    },
    himSelf: 'сам',
    ownSeason: 'Свой сезон',
    minMaxTooltip: 'Подогнать минимальные и максимальные значения радара',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Вход',
    latestBlogPosts: 'Последние записи блога',
    signIn: 'Войти',
    username: 'Имя пользователя',
    password: 'Пароль',
    passwordForgotten: 'Забыли пароль',
    signUp: 'Регистрация',
    enter: 'Войти',
    forceTitle: 'Аккаунт используется',
    forceMessage: 'Аккаунт уже подключен на другом устройстве. Вы хотите отключить его и подключить на этом устройстве?',
    forgotMyPassword: 'Забыл пароль',
    firstLogin: 'Первый вход',
    firstLoginMessage: 'По соображениям безопасности вы должны установить новый пароль при первом входе. Кроме того, предпочитаемый язык для просмотра приложения',
    firstLoginOverview: 'Вот обзор вашего аккаунта, лиг и продуктов, к которым у вас есть доступ.',
    passwordConfirmation: 'Подтверждение пароля',
    forgotPasswordMessage: 'Введите ваш email, если есть действительный аккаунт, связанный с этим email, вы получите в вашей почте следующие шаги для сброса пароля',
    resetPassword: 'Сбросить пароль',
    resetPasswordLinkInvalid: 'Эта ссылка недействительна или срок её действия истёк. Запросите новое восстановление пароля на странице входа.',
    skipSettings: 'Пропустить настройки',
    contact: 'Контакты',
    cookiesText: 'Этот сайт использует файлы cookie Google для предоставления своих услуг и анализа вашего трафика для обеспечения качества обслуживания, генерации статистики использования и обнаружения и устранения злоупотреблений.',
    contactUs: 'Связаться с нами',
    newsTitle: 'Новое: физические оценки!',
    newsText: 'Мы добавили две новые оценки физической эффективности к нашей исходной оценке на основе событийных данных: Оценку выносливости и Оценку скорости и мощности. Выносливость выделяет игроков, которые стабильно покрывают большие расстояния и выдерживают высокую нагрузку, а Скорость и мощность фокусируется на максимальной скорости, спринтах и взрывных ускорениях. Обе оценки варьируются от 0 до 100 и включают процентили по лиге и позиции для прямого сравнения с аналогичными игроками.'
  },
  settings: {
    pageSubtitle: 'Настройте свой опыт использования приложения',
    language: 'Язык',
    availableLeagues: 'Доступные лиги',
    availableSeasons: 'Доступные сезоны',
    availableProducts: 'Доступные продукты',
    organization: 'Компания',
    changePassword: 'Изменить пароль',
    seasonTemplates: 'Шаблоны сезона',
    seasonTemplatesSubtitle: 'Создайте свои собственные шаблоны сезона, которые позже будут доступны для выбора в Рейтинге игроков и Скауте игроков',
    templateName: 'Название шаблона',
    selectTemplate: 'Выберите существующий шаблон для редактирования',
    radarDefault: 'Радар по умолчанию',
    default: 'По умолчанию',
    tabs: {
      options: 'Опции',
      templates: 'Шаблоны',
      availableLeagues: 'Доступные лиги',
      contactData: 'Контактные данные GBE'
    },
    contactData: {
      userDetails: 'Данные пользователя',
      firstName: 'Имя',
      lastName: 'Фамилия',
      contactDetails: 'Контактные данные для GBE',
      name: 'Имя',
      phone: 'Телефон',
      mobile: 'Мобильный',
      email: 'Email',
      representativeDetails: 'Данные представителя для GBE'
    },
    currency: 'Валюта',
    fieldPreferences: 'Настройки поля',
    visualizationsPreferences: 'Настройки визуализаций',
    fieldColor: 'Цвет поля',
    fieldColors: {
      green: 'Зеленый',
      blue: 'Синий',
      white: 'Белый',
      black: 'Черный',
      grey: 'Серый'
    },
    defaultPlayerVisualization: 'Визуализация игрока по умолчанию',
    appPreferences: 'Настройки приложения',
    darkMode: 'Темный режим',
    showTour: 'Показать экскурсию',
    customStats: 'Пользовательская статистика',
    radarTemplates: 'Шаблоны радара',
    radarTemplatesSubtitle: 'Создайте свои собственные шаблоны метрик, которые позже будут доступны для выбора в Радарах и Рейтинге',
    radarCategories: {
      Custom1: 'Пользовательский 1',
      Custom2: 'Пользовательский 2',
      Custom3: 'Пользовательский 3',
      Custom4: 'Пользовательский 4',
      Custom5: 'Пользовательский 5',
      Custom6: 'Пользовательский 6',
      Physical: 'Физика',
      CustomPhysical1: 'Пользовательский Физика 1',
      CustomPhysical2: 'Пользовательский Физика 2',
      CustomPhysical3: 'Пользовательский Физика 3',
      CustomPhysical4: 'Пользовательский Физика 4',
      CustomPhysical5: 'Пользовательский Физика 5',
      CustomPhysical6: 'Пользовательский Физика 6'
    },
    templateRemoveTitle: 'Удалить шаблон',
    templateRemoveMsg: 'Вы хотите удалить этот шаблон?',
    templateEditTitle: 'Сохранить шаблон',
    templateEditMsg: 'Есть несохраненный шаблон, вы хотите сохранить его перед загрузкой другого шаблона?',
    category: 'Категория',
    playerRadar: 'Радар игрока',
    teamRadar: 'Радар команды',
    statsAlert: 'Вставьте хотя бы одну статистику для сохранения',
    recommended: 'Рекомендуется',
    warning: 'Есть позиции, которые достигли максимального количества разрешенных радаров. Пожалуйста, удалите или отредактируйте любой шаблон',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Испанский',
      numeric: 'Числовой'
    },
    showMediaMode: 'Показать режим медиа',
    statTemplates: 'Шаблоны статистики',
    statTemplatesSubtitle: 'Создайте свой собственный шаблон статистики, выбрав из нескольких метрик',
    ratingFormat: {
      ratingFormat: 'Формат рейтинга',
      numbers: 'Числа',
      letters: 'Буквы A-F'
    }
  },
  playerDetail: {
    passport: 'Паспорт',
    secondPassport: 'Второй паспорт',
    age: 'Возраст',
    dateOfBirth: 'Дата рождения',
    height: 'Рост',
    weight: 'Вес',
    wage: 'Зарплата',
    history: 'История',
    positions: 'Позиции',
    injuries: 'Травмы',
    transfers: 'Трансферы',
    nationalTeam: 'Сборная',
    addFavorite: 'Добавить в избранное',
    removeFavorite: 'Удалить из избранного',
    contractEnd: 'Окончание контракта',
    yearsOld: ' лет',
    playerAvailability: 'Доступность',
    playerUsage: 'Сыграно минут',
    usage: 'Использование',
    addToCollection: 'Добавить в коллекцию',
    performance: 'Выступления',
    info: 'Информация',
    career: 'Карьера',
    playerStyle: 'Стиль игрока',
    radar: 'Радар',
    finishingMap: 'Карта завершений',
    threatMap: 'Карта угроз',
    keyPassMap: 'Карта ключевых передач',
    beeswarm: 'Рейтинг',
    allGames: 'Все игры',
    eventsMap: 'Карта событий',
    lbpMap: 'Проходы с разрывом линии',
    obpMap: 'О давлении на мяч',
    pupMap: 'Проходит под давлением',
    obrMap: 'Квитанции о мячах',
    fullName: 'Полное имя',
    academy: 'Академия',
    name: 'Имя',
    lastName: 'Фамилия',
    playerAvailabilityLong: '% сезона без травм или дисквалификаций',
    playerUsageLong: 'Сыграно минут',
    playerAvailability1: 'игр без травм или дисквалификаций',
    playerAvailability2: 'игр в этом сезоне',
    playerUsage1: 'сыграно минут',
    playerUsage2: 'общее количество минут команды',
    notMinutesThisSeason: 'Не сыграл минут в этом сезоне',
    seasonPlaceholder: 'Нет активного сезона',
    inactivePlayer: 'Неактивный игрок',
    inactivePlayerMessage: 'Если вам нужна дополнительная информация, вы можете запросить отчет',
    goRequest: 'Перейти к запросу',
    warningMinutes: 'Внимание: Сыграно менее 450 минут, анализ может быть нерепрезентативным',
    scoreWarningMinutes: 'Игроки с минимум 450 общими сыгранными минутами',
    pdScoreWarningMinutes: 'Игроки с минимум 450 общими сыгранными минутами (минимум 60 минут за игру)',
    warningSeasonGames: 'В сезоне сыграно менее 5 игр, поэтому Мин и Макс - это \'Топ-5 лиг\'',
    warningStatsRemoved: 'Некоторые статистики не отображаются, так как они недоступны для выбранного сезона',
    warningBeeswarm: 'Игрок не показан, так как нет данных для этой статистики в выбранном сезоне',
    warningPlayersZeroValue: 'Не показываем {x} игроков с 0 ',
    onlyPlayersThatFit: 'Только игроки, которые подходят в шаблон радара',
    gamesPlayedNotEnough: 'Опции отключены из-за недостаточного количества сыгранных игр',
    gbe: 'GBE',
    analysis: 'Анализ',
    documents: 'Документы',
    rankDefensive: 'Защита',
    rankBallHandling: 'Владение мячом',
    rankGoal: 'Голевой вклад',
    rankXt: 'Угроза',
    rankIndex: 'Индекс',
    visitHistory: 'История посещений',
    placer: 'Поле',
    touchesMap: 'Карта касаний',
    heatMap: 'Тепловая карта',
    ageProfile: 'Возрастной профиль',
    strongFoot: 'Сильная нога',
    player: 'Игрок',
    outOf: 'из',
    in: 'в',
    radius: 'Радиус',
    blur: 'Размытие',
    careerTable: {
      nationalTeamCareer: 'Карьера в сборной',
      nationalTeamCompetitions: 'Соревнования сборной'
    },
    physicalProgression: 'Физическое развитие',
    gpi: 'Глобальный индекс игрока',
    warningGPI: 'Доступно только для игроков, активных в лигах ELO за последние 30 дней',
    diffGPI: 'Изменение с последней игры',
    rankingInTheWorld: '#{0} в мире',
    rankingInTheLeague: '#{0} в {1}',
    max: 'Макс',
    gpiChart: 'График на основе значения Глобального индекса игрока за последние {0} игр',
    percentileRange: 'Процентили от {0} до {1}',
    months: 'месяцы',
    month: 'месяц',
    contractExpOver4Years: 'Контракт истекает через',
    contractExpSoon: 'Контракт скоро истечет',
    contractFinalYear: 'Последний год контракта',
    freeAgent: 'Свободный агент',
    gpiDescription: 'Глобальный индекс игроков (GPI) — это стандартизированная система рейтингов игроков, которая оценивает футболистов на основе силы их команды, силы соперника, результатов матчей и доступности. Вдохновленный рейтинговой системой Эло, он гарантирует, что рейтинги игроков отражают реальную конкурентную среду, а не произвольные базовые показатели.',
    turnoversMap: 'Карта оборотов и возмещений',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    }
  },
  finishingMap: {
    typesOfShot: 'Типы ударов',
    shotStrategy: 'Стратегия',
    strategiesCount: '{count} стратегий',
    areas: 'Зоны',
    bodyPart: 'Часть тела',
    more: 'больше',
    selectAll: 'Выбрать все',
    minutes: 'Минуты',
    circles: 'Круги',
    boxes: 'Тепловая карта штрафной площади',
    lines: 'Линии',
    games: 'Игры',
    perShot: 'за удар',
    goal: 'Гол',
    missedShot: 'Неточный удар',
    savedShot: 'Отраженный удар',
    shotOnPost: 'Удар в штангу',
    missedChance: 'Упущенный момент',
    openPlay: 'Игра в открытую',
    regularPlay: 'Обычная игра',
    fastBreak: 'Быстрая атака',
    individualPlay: 'Индивидуальная игра',
    setPiece: 'Стандарт',
    fromCorner: 'С углового',
    freeKick: 'Штрафной удар',
    indirectFreeKick: 'Непрямой штрафной',
    throwInSetPiece: 'Стандарт с вбрасывания',
    inBox: 'В штрафной',
    goalArea: 'Вратарская',
    boxLeft: 'Штрафная слева',
    boxCenter: 'Штрафная центр',
    boxRight: 'Штрафная справа',
    outOfBox: 'Вне штрафной',
    outBoxDeepLeft: 'Вне штрафной глубоко слева',
    outBoxDeepRight: 'Вне штрафной глубоко справа',
    outBoxLeft: 'Вне штрафной слева',
    outBoxCentreLeft: 'Вне штрафной центр-слева',
    outBoxCentre: 'Вне штрафной центр',
    outBoxCentreRight: 'Вне штрафной центр-справа',
    outBoxRight: 'Вне штрафной справа',
    left35: '+35 Слева',
    centreLeft35: '+35 Центр-слева',
    centre35: '+35 Центр',
    centreRight35: '+35 Центр-справа',
    right35: '+35 Справа',
    head: 'Голова',
    rightFooted: 'Правой ногой',
    leftFooted: 'Левой ногой',
    otherBodyPart: 'Другая часть тела',
    chart: {
      shots: 'Удары',
      xGPerShot: 'xG за удар',
      exceptionTextPenaltyGoals: '* Пенальти = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Пенальти = 0.765 xGOT',
      exceptionTextOwnGoals: '* Автоголы не учитываются',
      og: 'АГ',
      penaltiesExcluded: 'Голы с пенальти исключены',
      ownGoalsExcluded: 'Автоголы исключены',
      sumOfxG: 'Сумма xG',
      exceptionShotsOutOfRange: '* Не показываем удары вне диапазона'
    },
    inGoal: 'В воротах',
    outOfGoal: 'Мимо ворот',
    highLeft: 'Высоко слева',
    highCenter: 'Высоко центр',
    highRight: 'Высоко справа',
    lowLeft: 'Низко слева',
    lowCenter: 'Низко центр',
    lowRight: 'Низко справа',
    outHighLeft: 'Мимо высоко слева',
    high: 'Мимо высоко центр',
    outHighRight: 'Мимо высоко справа',
    closeHighLeft: 'Близко высоко слева',
    closeHigh: 'Близко высоко центр',
    closeHighRight: 'Близко высоко справа',
    closeLeft: 'Близко низко слева',
    closeRight: 'Близко низко справа',
    finishingTable: 'Таблица завершений',
    onGoal: 'В створ',
    distributionFilters: 'Фильтры распределения',
    penalty: 'Пенальти',
    penaltyShootout: 'Серия пенальти',
    onlyPercentage: 'Показать проценты',
    showAll: 'Показать все',
    chanceMissed: 'Шанс упущен'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Ключевые передачи',
      xAPerPass: 'xA за передачу',
      xAOpenPlay: 'xA Игра в открытую',
      xASetPiece: 'xA Стандарт'
    }
  },
  beeswarm: {
    template: 'Шаблон',
    templates: {
      Goalkeeper: 'Вратарь',
      Defender: 'Защитник',
      'Full-Back': 'Крайний защитник',
      FullBack: 'Крайний защитник',
      'Wing-Back': 'Крайний защитник (винг-бек)',
      WingBack: 'Крайний защитник (винг-бек)',
      Midfielder: 'Полузащитник',
      AttackingMidfielder: 'Атакующий полузащитник',
      Winger: 'Вингер',
      Forward: 'Нападающий',
      Physical: 'Физика'
    },
    compareWith: 'Сравнить с',
    highlightPlayersOf: 'Выделить игроков',
    highlightPlayers: 'Выделить игроков',
    per90: 'Данные за 90 минут',
    highlightTeams: 'Выделить команды',
    filterTeams: 'Фильтровать команды',
    warningZeros: 'Только для необратных статистик'
  },
  collections: {
    newCollection: 'Новая коллекция',
    editCollection: 'Редактировать коллекцию',
    name: 'Название',
    visibility: 'Видимость',
    privacity: {
      publicTitle: 'Публичная',
      publicDescription: 'Видна вам и вашему клубу',
      privateTitle: 'Приватная',
      privateDescription: 'Видна только вам',
      supervisedTitle: 'Контролируемая',
      supervisedDescription: 'Видна только вам и вашему руководителю'
    },
    addSuccess: 'Успешно добавлено',
    createAddSuccess: 'Создано и успешно добавлено',
    editSuccess: 'Успешно обновлено',
    deleteSuccess: 'Успешно удалено',
    title: 'Коллекции игроков',
    publics: 'Публичные',
    privates: 'Приватные',
    supervised: 'Контролируемые',
    totalMarketValue: 'Общая рыночная стоимость',
    avgMarketValue: 'Средняя рыночная стоимость',
    avgAge: 'Средний возраст',
    searchBarPlaceholder: 'Чтобы добавить в коллекцию, найдите и выберите игроков',
    deleteCollection: 'Удалить коллекцию',
    deleteCollectionMessage: 'Коллекция будет удалена, вы уверены?',
    removePlayer: 'Удалить игрока',
    removePlayerMessage: 'Игрок будет удален из коллекции, вы уверены?',
    subtitle: 'Организуйте свой скаутинг',
    notExitingTemplate: 'Шаблонов пока нет'
  },
  searchbar: {
    placeholder: 'Введите для поиска (например, `david arsenal´)',
    players: 'Игроки',
    teams: 'Команды',
    games: 'Игры',
    leagues: 'Лиги',
    explore: 'Изучить больше результатов',
    placeholderNoResults: 'Нет результатов для шаблона',
    teamPlaceholder: 'Чтобы сравнить команду, найдите и выберите её'
  },
  favorites: {
    showOnly: 'Показать только',
    selfFavorites: 'Мои избранные',
    clubFavorites: 'Избранные клуба',
    contractExpiration: 'Окончание контракта',
    groupBy: 'Группировать по',
    noGrouped: 'Нет',
    maxSelection: 'Можно выбрать только',
    selectAtleastOne: 'Выберите хотя бы одного',
    comparePlayers: 'Сравнить игроков',
    selectedPlayers: 'игроков выбрано',
    subtitle: 'Управляйте своими избранными',
    generateXlsx: 'Создать XLSX',
    generating: 'Создание...',
    subscribed: 'Подписан',
    subscribedTooltip: 'Подписаться, чтобы получать письмо, когда игра будет сыграна',
    deleteSelected: 'Удалить выбранное'
  },
  expiration: {
    summer: 'Лето',
    winter: 'Зима'
  },
  positions: {
    noposition: 'Нет позиции',
    goalkeeper: 'Вратарь',
    goalkeepers: 'Вратари',
    defender: 'Защитник',
    defenders: 'Защитники',
    defenses: 'Защитники',
    fullback: 'Крайний защитник',
    fullbacks: 'Крайние защитники',
    midfielder: 'Полузащитник',
    midfielders: 'Полузащитники',
    winger: 'Вингер',
    wingers: 'Вингеры',
    forward: 'Нападающий',
    forwards: 'Нападающие',
    wingback: 'Крайний защитник (винг-бек)',
    wingbacks: 'Крайние защитники (винг-беки)'
  },
  dPos: {
    1: {
      name: 'Вратарь',
      alias: ''
    },
    2: {
      name: 'Правый крайний защитник',
      alias: 'RFB'
    },
    3: {
      name: 'Правый центральный защитник',
      alias: 'RCB'
    },
    4: {
      name: 'Левый центральный защитник',
      alias: 'LCB'
    },
    5: {
      name: 'Левый крайний защитник',
      alias: 'LFB'
    },
    6: {
      name: 'Опорный полузащитник',
      alias: 'DM'
    },
    7: {
      name: 'Правый вингер',
      alias: 'RW'
    },
    8: {
      name: 'Центральный полузащитник',
      alias: 'CM'
    },
    9: {
      name: 'Нападающий',
      alias: 'ST'
    },
    10: {
      name: 'Атакующий полузащитник',
      alias: 'AM'
    },
    11: {
      name: 'Левый вингер',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Сравнить с',
    lastSeasonSelectText: 'Прошлый сезон',
    lastAndCurrentSeasonSelectText: 'Прошлый + Текущий сезон',
    currentSeasonSelectText: 'Текущий сезон',
    lastNgamesSelectText: 'Последние {x} игр',
    npgVsXGTitle: 'Голы без пенальти VS xG',
    totalXGLabel: 'Всего xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Всего голов без пенальти',
    xGAgainstvsNPGAgainstTitle: 'xG пропущенные VS Голы без пенальти пропущенные',
    totalXGAgainstLabel: 'Всего xG пропущенные',
    xGAgainstLabel: 'xG пропущенные',
    totalNPGAgainstLabel: 'Всего голов без пенальти пропущенные',
    xGvsxGAgainstTitle: 'xG VS xG пропущенные',
    pointsVsXPointsTitle: 'Очки VS Ожидаемые очки',
    xTTitle: 'Поток игры',
    totalXPoints: 'Всего xPoints',
    totalPoints: 'Всего очков',
    requestedReports: 'Запрошенные отчеты',
    playersScouted: 'Игроков проскаутировано',
    performanceVSAverageChart: 'Эффективность VS Среднее',
    perPositions: 'По позициям',
    perLeagues: 'По лигам',
    perMonths: 'По месяцам',
    perClients: 'По клиентам',
    ofPreposition: 'из',
    idJChartTitle: 'Инициатива игры',
    idJChartLabel: 'Индекс GI',
    vJOChartTitle: 'Объем атакующей игры',
    vJOChartLabel: 'Индекс OGV',
    preJOChartTitle: 'Точность атакующей игры',
    preJOChartLabel: 'Индекс OGPre',
    proJOChartTitle: 'Прогрессия атакующей игры',
    proJOChartLabel: 'Индекс OGPro',
    chart: 'График',
    table: 'Таблица',
    showLeaguesWithAtLeast: 'Показать лиги, в которых есть хотя бы',
    playersScoutedSuffix: 'игроки разведаны'
  },
  table: {
    history: {
      season: 'Сезон',
      team: 'Команда',
      position: 'Позиция',
      side: 'Сторона',
      games: 'Игры',
      minutes: 'Мин',
      goals: 'Голы без пенальти (Г)',
      assists: 'П',
      yellowCards: 'ЖК',
      redCards: 'КК',
      gameLost: 'ПМ',
      gamesMissed: 'Пропущенные игры',
      goalsReceived: 'НПГЦ (ГК)'
    },
    injury: {
      season: 'Сезон',
      team: 'Команда',
      injury: 'Травма',
      dateFrom: 'Дата начала',
      dateTo: 'Дата окончания',
      daysLost: 'Дней потеряно',
      gamesLost: 'Игр потеряно',
      allInjuries: 'Все травмы'
    },
    transfers: {
      season: 'Сезон',
      date: 'Дата',
      teamFrom: 'Команда откуда',
      teamTo: 'Команда куда',
      marketValue: 'Рыночная стоимость',
      fee: 'Стоимость',
      type: 'Тип'
    },
    caps: {
      team: 'Команда',
      debut: 'Дебют',
      games: 'Игры',
      goals: 'Голы',
      coachDuringDebut: 'Тренер во время дебюта',
      debutAge: 'Возраст дебюта'
    },
    roster: {
      country: 'Страна',
      player: 'Игрок',
      positions: 'Позиции',
      minutes: 'Минуты',
      games: 'Игры',
      goals: 'Голы',
      assists: 'Голевые передачи',
      cards: 'Карточки',
      gamesExplicit: 'Сыграно игр'
    },
    league: {
      title: 'Карточка лиги',
      subtitle: 'Углубитесь в рейтинг и статистику лиги',
      team: 'Команда',
      games: 'И',
      gamesExplicit: 'Сыграно игр',
      gamesRanking: 'И',
      gamesRankingExplicit: 'Сыграно игр',
      points: 'О',
      pointsExplicit: 'Очки',
      expectedPoints: 'xО',
      expectedPointsExplicit: 'Ожидаемые очки',
      goalsScored: 'ГБП',
      goalsScoredExplicit: 'Голы без пенальти',
      xG: 'xG',
      xGExplicit: 'Ожидаемые голы',
      goalsAgainst: 'ГБПП',
      goalsAgainstExplicit: 'Голы без пенальти пропущенные',
      xGAgainst: 'xГП',
      xGAgainstExplicit: 'Ожидаемые голы пропущенные',
      xGAgainstDiff: 'Разн. xГП',
      xGAgainstDiffExplicit: 'Разница ожидаемых голов пропущенных',
      form: 'Форма',
      sos: 'SoS',
      sosExplicit: 'Сила расписания',
      sosHfa: 'SoS ДП',
      sosHfaExplicit: 'Преимущество домашнего поля',
      difficultyAboveAvg: 'Сложность выше среднего',
      differentGames: '* Разное количество сыгранных игр',
      berth: 'Место'
    },
    usersOfClient: {
      userName: 'Имя',
      userRole: 'Пользователь',
      devRole: 'Разработчик',
      adminRole: 'Администратор',
      servicesRole: 'Сервисы',
      xgRole: 'XG',
      radarRole: 'Радар',
      beeswarmRole: 'Рейтинг',
      elevenRole: 'Составы',
      similarityRole: 'Похожесть',
      gameAnalysisRole: 'Анализ игры',
      clientStatsRole: 'Статистика клиента',
      created: 'Создан',
      type: 'Тип',
      logins: 'Входы',
      lastLogin: 'Последний вход',
      trialDate: 'Дата пробного периода'
    },
    clientLeagues: {
      league: 'Лига',
      area: 'Регион',
      tier: 'Уровень',
      seasons: 'Сезоны',
      currentMatchDay: 'Игровой день',
      regular: 'Обычная',
      youthLeague: 'Молодежная',
      clientActive: 'Активна',
      visibleLeagues: 'Видимые лиги',
      male: 'Мужская лига',
      female: 'Женская лига'
    },
    connections: {
      title: 'Общие комбинации',
      playerFrom: 'От игрока',
      playerTo: 'К игроку',
      passes: 'Передачи',
      passesTooltip: 'Общее количество успешных передач',
      passesFinalThird: 'ПФ ⅓',
      passesFinalThirdTooltip: 'Передачи в финальную треть'
    },
    playerPassMapData: {
      title: 'Статистика передач',
      player: 'Игрок',
      passes: 'Передачи',
      passesPct: '% Передач',
      xA: 'xA',
      xG: 'xG',
      xT: 'xThreat',
      playerTooltip: 'Имя игрока',
      passesTooltip: 'Общее количество передач',
      passesPctTooltip: '% Успешных передач',
      xATooltip: 'Ожидаемые передачи',
      xGTooltip: 'Ожидаемые голы',
      xTTooltip: 'Ожидаемая угроза'
    },
    playerAllGames: {
      gameDate: 'Дата',
      game: 'Игра',
      team: 'Команда',
      positionsPlayed: 'Позиции',
      minsPlayed: 'Минуты',
      gameActions: 'Действия',
      gameDateTooltip: 'Дата игры',
      gameTooltip: 'Игра',
      positionsPlayedTooltip: 'Сыгранные позиции',
      minsPlayedTooltip: 'Сыграно минут',
      gameActionsTooltip: 'Голы, Передачи, Карточки',
      from: 'Начало',
      to: 'Конец',
      goalText: 'Гол на',
      assistText: 'Передача на',
      penaltyText: 'Пенальти на',
      ownGoalText: 'Автогол на',
      yellowCardText: 'Желтая карточка на',
      secondYellowCardText: 'Вторая желтая карточка на',
      redCardText: 'Красная карточка на',
      substitutionIN: 'Замена на',
      substitutionOUT: 'Заменен на',
      suspendedText: 'Дисквалификация',
      Team: 'Оборудование'
    },
    gameFlow: {
      phase: 'Фаза ',
      mins: 'Минуты',
      team: 'Команда',
      period: 'Период',
      possession: '%Влад.',
      possessionTooltip: '% Владение',
      xT: 'xThreat',
      xTTooltip: 'Ожидаемая угроза',
      pft: 'ПФ ⅓',
      pftTooltip: 'Передачи в финальную треть',
      xG: 'xG',
      xGTooltip: 'Ожидаемые голы'
    }
  },
  game: {
    title: 'Карточка матча',
    subtitle: 'Углубитесь в характеристики и статистику матча',
    header: {
      gameDetails: 'Детали',
      gameStats: 'Статистика',
      gameFinishingMap: 'Карта завершений',
      gameKeyPassMap: 'Карта ключевых передач',
      gamePassMap: 'Карта передач',
      gameThreat: 'Угроза матча',
      gameFlow: 'Поток игры',
      gameAnalysis: 'Анализ матча',
      gamePhysicalStats: 'Физическая статистика',
      possessions: 'Владения',
      bench: 'Скамейка',
      video: 'Видео-подборка',
      preGame: 'Предматчевый матч',
      postGame: 'Послематчевый',
      areaCoverage: 'Зона покрытия'
    },
    passMap: {
      typeOfPlay: 'Тип игры:',
      passes: 'Передачи:',
      team: 'Команда',
      minutes: 'Минуты:',
      select: 'Выбрать',
      all: 'Все',
      attacking: 'Атакующие',
      defending: 'Защитные',
      forwards: 'Вперед',
      backwards: 'Назад',
      sideways: 'В стороны',
      longBall: 'Длинный пас',
      successfullPasses: 'Успешные передачи',
      homeTeam: 'Дома',
      awayTeam: 'В гостях',
      passingMatrix: 'Матрица передач',
      passer: 'Пасующий',
      receiver: 'Принимающий',
      passOutcome: 'Результат Передачи',
      passDirection: 'Направление Передачи',
      half: 'Половина',
      offensive: 'Атакующая',
      defensive: 'Оборонительная',
      passingConnections: 'Пасовые связи',
      pitchView: 'Поле',
      passSingular: 'Пас',
      passPlural: 'Пасов',
      playerLocation: 'Местоположение игрока',
      passLegend: 'Средняя позиция касания',
      minuteRange: 'Минутный диапазон'
    },
    stats: {
      summary: 'Сводка',
      attacking: 'Атака',
      defending: 'Защита',
      contribution: 'Вклад',
      possession: 'Владение',
      expectedPoints: 'Ожидаемые очки',
      directness: 'Прямолинейность',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG Стандарт',
      xA: 'xA',
      xASetPiece: 'xA Стандарт',
      xT: 'xT',
      xTSetPiece: 'xT Стандарт',
      touchesInOppBox: 'Касания в штрафной соперника',
      passesFinalThird: 'Передачи в финальную треть',
      interceptions: 'Перехваты',
      recoveries: 'Отборы',
      recoveriesOppHalf: 'Отборы в половине соперника',
      tackles: 'Отборы',
      tacklesWasDribbled: 'Выигранные оборонительные единоборства 1 в 1',
      fouls: 'Фолы',
      yellowCards: 'Желтые карточки',
      redCards: 'Красные карточки',
      passes: 'Передачи',
      passing: '% Передач',
      crosses: 'Навесы',
      crossing: '% Навесов',
      shots: 'Удары',
      shotsOnTarget: 'Удары в створ',
      ppdaExplicit: 'Пропущенные передачи на защитное действие',
      xgExplicit: 'Ожидаемые голы',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Среднее по соревнованию',
      winChanceTooltip: 'Вероятность победы hа основе созданных и пропущенных xG',
      drawChance: 'Ничья',
      xgAgainst: 'xG пропущенные',
      averagePossession: 'Bладение',
      averageShots: 'Yдары',
      averagexG: 'Oжидаемые голы',
      fieldTilt: 'Наклон поля',
      fieldTiltExplicit: 'Наклон поля',
      recoveriesRate: 'Скорость восстановления',
      turnoversRate: 'Скорость оборота'
    },
    detail: {
      halfTime: 'Перерыв',
      overTime: 'Дополнительное время',
      showStats: 'Показать статистику',
      hideStats: 'Скрыть статистику',
      bench: 'Скамейка',
      showShotOptions: 'Показать опции ударов',
      hideShotOptions: 'Скрыть опции ударов',
      showPassOptions: 'Показать опции передач',
      hidePassOptions: 'Скрыть опции передач',
      endGame: 'Финальный свисток',
      penalties: 'Пенальти'
    },
    timeline: {
      events: {
        goal: 'Гол',
        goal_ownGoal: 'Автогол',
        goal_penalty: 'Гол с пенальти',
        card: 'Карточка',
        card_yellowCard: 'Желтая карточка',
        card_secondYellowCard: 'Вторая желтая карточка',
        card_redCard: 'Красная карточка',
        formationChange: 'Смена схемы',
        substitution: 'Замена',
        saveShot: 'Отраженный удар',
        saveShot_penalty: 'Отраженный пенальти',
        missedShot: 'Неточный удар',
        missedShot_penalty: 'Неточный пенальти',
        shotOnPost: 'Удар в штангу',
        shotOnPost_penalty: 'Пенальти в штангу',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'Гол ',
      redCardTo: 'Красная карточка ',
      missedPenalty: 'Незабитый пенальти'
    },
    gameThreat: {
      typeOfPlay: 'Тип действия',
      regularPlay: 'Обычная игра',
      setPiece: 'Стандарт',
      setPiecePlay: 'Стандарт',
      throwInSetPiecePlay: 'Игра с вбрасывания',
      throwInPlay: 'Игра с вбрасывания',
      gkThrow: 'Вбрасывание вратаря',
      gkKick: 'Удар вратаря',
      kickOff: 'Начало игры',
      actionEnding: 'Завершение действия',
      pass: 'Передача',
      shot: 'Удар',
      foul: 'Фол',
      other: 'Другое',
      threat: 'Угроза',
      legendSumOfXT: 'Сумма xT',
      legendPass: 'Передача',
      legendShot: 'Удар',
      legendCarryAndAction: 'Ведение и действие',
      legendCarryAndPass: 'Ведение и передача',
      legendOnlyShowing: 'Показываем только индивидуальные действия с xT > ',
      legendOnlyShowingPart1: 'Показываем только индивидуальные',
      legendOnlyShowingPart2: 'действия с xT > ',
      legendOnlyShowingSetPiece: 'Показываем только действия со стандартов с xT > ',
      legendOnlyShowingOpenPlay: 'Показываем только действия в открытую с xT > ',
      legendPlays: 'Действия',
      legendPerPlay: 'за действие',
      legendCarry: 'Ведение',
      penaltyPlay: 'Пенальти',
      freeKickTakenPlay: 'Игра со штрафного',
      cornerTakenPlay: 'Игра с углового',
      fromCornerPlay: 'Игра с углового',
      keeperThrowPlay: 'Игра с вбрасывания вратаря',
      fastBreakPlay: 'Игра быстрой атакой',
      indirectPlay: 'Непрямая игра',
      minutes: 'Минуты',
      games: 'Игры',
      xT: 'xT',
      xTPer90: 'xT за 90\''
    },
    gameAnalysis: {
      next: 'Далее',
      previous: 'Назад',
      phaseLabel: 'Фаза',
      phasesLabel: 'Фазы',
      dot: '. ',
      comma: ', ',
      from: 'С',
      to: 'По',
      and: ' и ',
      steps: {
        finishingMapFullGame: 'Карта завершений',
        keyPassMapFullGame: 'Карта ключевых передач',
        gameFlow: 'Поток игры',
        finishingMapPerPhases: 'Карта завершений по фазам',
        keyPassMapPerPhases: 'Карта ключевых передач по фазам',
        passMapPerPhases: 'Карта передач по фазам'
      },
      step1: {
        table: {
          draw: 'Ничья',
          win: 'Победа',
          lose: 'Поражение',
          possession: 'Владение',
          xP: 'Ожидаемые очки',
          directness: 'Прямолинейность',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG Игра в открытую',
          xGSetPiece: 'xG Стандарт',
          xA: 'xA',
          xAOpenPlay: 'xA Игра в открытую'
        },
        text: {
          firstParagraph: {
            1: 'Карта справа отображает ожидаемые голы, созданные home_team_name и away_team_name. Заполненные круги - это удары, которые завершились голом. Размер кругов зависит от значения xG каждого удара. '
          },
          lastParagraph: {
            1: 'Процент вероятности результата и количество ожидаемых очков рассчитываются через симуляцию ударов (проводится 100 000 симуляций ударов, и возможность результатов и получения очков оценивается предсказательным способом). '
          },
          targetHighTeamXG: {
            1: 'target_team_name, а также rival_team_name, удалось создать большой объем ожидаемых голов'
          },
          targetHighTeamOpenPlayXG: {
            1: 'В этом матче большинство моментов target_team_name пришло из игры в открытую'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'В этом матче большинство моментов target_team_name было создано в игре в открытую (в отличие от rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'В этом матче большинство моментов target_team_name пришло со стандартов'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'В этом матче большинство моментов target_team_name было создано со стандартов (в отличие от rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'В этом матче большинство моментов target_team_name пришло с угловых'
          },
          targetLowTeamGoalConversion: {
            1: ', но реализация голов была низкой'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name создал большой объем ожидаемых голов как в игре в открытую, так и со стандартов'
          },
          targetHighTeamGoalConversion: {
            1: ', также имея высокий коэффициент реализации голов. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', не сумев забить ни одного из созданных моментов'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ', но создал опасность для забития большего количества голов'
          },
          targetHighTeamXGvsGameRival: {
            1: 'В этом матче target_team_name создал больше опасности, чем rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' и мог забить больше голов. '
          },
          targetHighTeamXGZeroGoals: {
            1: ', но не сумел забить ни одного гола из созданных моментов. '
          },
          targetHighTeamXGGoalDiff: {
            1: ', что соответствует шансу на победу team_winning_chance согласно нашей пост-матчевой симуляции. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' Большинство моментов target_team_name пришло из игры в открытую. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' Большинство моментов target_team_name было создано со стандартов. '
          },
          startTargetHighTeamCornerXG: {
            1: ' Большинство моментов пришло с угловых. '
          },
          targetSimilarTeamXG: {
            1: 'В этом матче обе команды создали похожее количество опасности для соперника в плане xG, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'но target_team_name показал лучший результат в завершении моментов. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Независимо от результата, target_team_name не создал много опасности для соперника в плане ожидаемых голов. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name не создал достаточно опасности для соперника в плане ожидаемых голов, чтобы выиграть матч'
          },
          rivalHighTeamXG: {
            1: 'и позволил rival_team_name создать слишком много опасности. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' При таком создании моментов, это матч, который target_team_name выиграл бы только team_winning_chance раз согласно нашей пост-матчевой симуляции. '
          },
          targetHighTeamGoalConversion2: {
            1: ', имея высокий коэффициент реализации голов'
          },
          winningChance: {
            1: 'Учитывая количество ударов и xG обеих команд, target_team_name должен был выиграть этот матч team_winning_chance раз. '
          },
          highPlayerXGManyShots: {
            1: 'Интересно отметить, что player_name создал xg_value xG в shots_value ударах'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ', нуждаясь в xg_value xG для забития гола. '
          },
          highPlayerXGOneGoal: {
            1: ' для забития гола. '
          },
          highPlayerXGAnyGoal: {
            1: ', хотя это не привело ни к одному голу. '
          },
          highPlayerXGNotManyShots: {
            1: 'Стоит упомянуть, что player_name создал xg_value xG в нескольких ударах'
          },
          highManyPlayerXG: {
            1: 'Интересно отметить, что player_name и player_name2 создали xg_value и xg_value2 <b>xG</b> соответственно. '
          },
          highTeamXGPerShot: {
            1: 'Что касается выбора ударов target_team_name, они были очень хороши с точки зрения вероятности стать голом, со средним xG за удар xg_per_shot_value. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'Выбор ударов target_team_name был намного лучше, чем у rival_team_name, имея в среднем xg_per_shot_value xG за удар. '
          },
          xGTimesNotAfter70xG: {
            1: 'Несмотря на высокий созданный xG, target_team_name имел проблемы с созданием опасности в конце матча. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name создал много опасности особенно в начале обеих таймов. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name создал много опасности особенно в конце обеих таймов. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name создал большую часть опасности в начале первого тайма. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name создал большую часть опасности в конце первого тайма. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name создал большую часть опасности в начале второго тайма. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name создал большую часть опасности в конце второго тайма. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name начал матч очень уверенно с моментами, которые создали xg_value ожидаемых голов. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name закончил первый тайм с моментами, которые создали xg_value ожидаемых голов. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name вышел после перерыва с моментами, которые создали xg_value ожидаемых голов. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name закончил второй тайм с моментами, которые создали xg_value ожидаемых голов. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name создал много опасности в конце второго тайма. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name создал много опасности в начале второго тайма. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name создал много опасности в конце первого тайма. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name создал много опасности в начале первого тайма. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name создал большую часть своей опасности в первом тайме, в то время как rival_team_name сделал то же самое во втором тайме. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name создал большую часть своей опасности во втором тайме, в то время как rival_team_name сделал то же самое в первом тайме. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'Это матч, где большая часть опасности в плане ожидаемых голов была создана в первом тайме. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'Это матч, где большая часть опасности в плане ожидаемых голов была создана во втором тайме. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name удалось создать большую часть опасности в первом тайме. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name удалось создать большую часть опасности во втором тайме. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name позволил большую часть опасности в плане ожидаемых голов в первом тайме. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name позволил большую часть опасности в плане ожидаемых голов во втором тайме. '
          },
          highInBoxXG: {
            1: 'Карта ударов показывает, как большая часть опасности пришла от ударов внутри штрафной. '
          },
          highOutOfBoxXG: {
            1: 'Можно наблюдать на карте ударов, что в этом матче target_team_name создал много опасности из-за пределов штрафной. '
          },
          highInBoxXGRival: {
            1: 'Мы хотим отметить, что большая часть опасности, пропущенной target_team_name, пришла от ударов внутри штрафной. '
          },
          highInBoxXGRival2: {
            1: ' Также интересно выделить, что большая часть опасности, пропущенной target_team_name, пришла от ударов внутри штрафной. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name хорошо сыграл, избегая опасности внутри штрафной. '
          },
          highTeamChancesHighPPDARival: {
            1: 'Недостаток давления target_team_name, позволяя ppda_value передач на защитное действие, был одним из ключей для rival_team_name создать большое количество моментов. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name позволил только ppda_value передач на защитное действие, что стало одним из ключей к победе. '
          },
          lowPPDA: {
            1: 'target_team_name отлично справился с прерыванием игры rival_team_name, позволяя только в среднем ppda_value передач на защитное действие. '
          },
          highPossession: {
            1: 'target_team_name имел контроль мяча с possession_value владения'
          },
          highPPDARival: {
            1: ', а также плавное распределение мяча'
          },
          chancesCreated: {
            1: ', что позволило им иметь большое количество моментов в открытую (chances_value). '
          },
          chancesCreatedRival: {
            1: ', хотя rival_team_name смог создать большое количество моментов в открытую (chances_value). '
          },
          xGPerShotRival: {
            1: ', хотя rival_team_name смог создать более опасные моменты с xg_per_shot_value xG за удар. '
          },
          winGame: {
            1: ', что стало одним из ключей к победе в матче. '
          },
          notEnoughWinGame: {
            1: ', что было недостаточно для победы в матче. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'Первый гол пришел из-за ошибки player_error_name, использованной player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'Первый и единственный гол пришел из-за ошибки player_error_name, использованной player_name'
          },
          lastPhaseOfGame: {
            1: ' в последней фазе матча. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'Финальный гол для победы в матче пришел из-за ошибки player_error_name, которая привела к голу player_name. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'Финальный гол для ничьей пришел из-за ошибки player_error_name, которая привела к голу player_name. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'Ошибка player_error_name привела к моменту для ничьей для target_team_name. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name вышел вперед, воспользовавшись ошибкой player_error_name'
          },
          xGChance: {
            1: ' с моментом xg_value xG. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'Финальный гол rival_team_name для победы в матче пришел из-за ошибки player_error_name, которая привела к голу player_name. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'Ошибка player_error_name привела к моменту для ничьей для rival_team_name. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name вышел вперед, воспользовавшись ошибкой player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name удалось забить единственный большой момент, который был создан во время матча, это гол player_name, который мы видим на карте xG с xG xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name удалось забить все большие моменты, которые были созданы во время матча'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name имел единственный отличный момент target_team_name для забития с xG xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name не смог забить ни одного из chances_value моментов выше 40% вероятности стать голом. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name имел отличный момент xg_value xG, чтобы выйти вперед в счете. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name имел chances_value моментов с xG выше 40%, чтобы выйти вперед в счете. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name имел chances_value моментов с высоким xG, чтобы выйти вперед в счете. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name имел момент xg_value xG, чтобы выйти вперед в счете, который попал в штангу. '
          },
          beforeEndOfGame: {
            1: 'Перед концом матча, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name имел момент xg_value xG, чтобы выиграть матч. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name имел chances_value моментов с xG выше 40%, чтобы выиграть матч. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name имел chances_value моментов с высоким xG, чтобы выиграть матч. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name имел отличный момент xg_value xG, чтобы выйти вперед в счете. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name имел chances_value моментов с xG выше 40%, чтобы выйти вперед в счете. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name имел chances_value моментов с высоким xG, чтобы выйти вперед в счете. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name имел момент xg_value xG, чтобы выйти вперед в счете, который попал в штангу. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name имел момент xg_value xG, чтобы сравнять счет, но без удачи. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name имел chances_value моментов, чтобы сравнять счет с вероятностью забития выше 30%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name имел момент xg_value xG, чтобы сравнять счет, который закончился попаданием в штангу. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Ничья',
          win: 'Победа',
          possession: 'Владение',
          xP: 'Ожидаемые очки',
          directness: 'Прямолинейность',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA Игра в открытую',
          xASetPiece: 'xA Стандарт',
          chancesCreated: 'Созданные моменты',
          shotsOnTarget: 'Удары в створ'
        },
        text: {
          firstParagraph: {
            1: 'Это изображение показывает ожидаемые передачи <b style=\'color:home_color\'>home_team_name</b> и <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA за ключевую передачу. '
          },
          keyPassesGeneratedFrom: {
            1: ', особенно ключевые передачи, созданные из '
          },
          highTeamXAvsXG: {
            1: 'Как показывает карта xA, большая часть опасности, созданной target_team_name, приходит из комбинационной игры, а не из индивидуальных действий'
          },
          openPlay: {
            1: 'игры в открытую'
          },
          setPiece: {
            1: 'стандартов'
          },
          cornerKicks: {
            1: 'угловых'
          },
          combinationPlays: {
            1: 'комбинационной игры'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'В этом матче target_team_name создал опасность как из комбинационной игры'
          },
          individualActions: {
            1: ', так и из индивидуальных действий. '
          },
          dangerFromIndividualActions: {
            1: 'В этом матче большая часть опасности, созданной target_team_name, пришла из индивидуальных действий.'
          },
          highTeamXAvsXGRival: {
            1: ' Моменты, которые target_team_name позволил во время матча, пришли из комбинационной игры, как показывает карта xA.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name был силен в ключевых передачах, приходящих из '
          },
          manyPlayerKeyPasses: {
            1: 'Интересно отметить, что player_name создал xa_value xA в key_passes ключевых передачах'
          },
          playerAssists: {
            1: ', нуждаясь в xa_per_assist xA за передачу.'
          },
          giveAssist: {
            1: ' для передачи.'
          },
          noAssists: {
            1: ', хотя ни одна из этих передач не завершилась передачей.'
          },
          highXANotManyShots: {
            1: 'Интересно отметить, что player_name создал xa_value xA в нескольких передачах'
          },
          manyPlayersHighXA: {
            1: 'Интересно отметить, что player_name и player_name2 создали xa_value и xa_value2 xA соответственно.'
          },
          xATimes: {
            1: 'target_team_name создал большую часть своей опасности в первом тайме, в то время как rival_team_name сделал то же самое во '
          },
          firstHalf: {
            1: ' первом тайме. '
          },
          secondHalf: {
            1: ' втором тайме. '
          },
          left: {
            1: 'левой стороне '
          },
          center: {
            1: 'центре '
          },
          right: {
            1: 'правой стороне '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'Это матч, где большая часть опасности в плане ожидаемых голов была создана в '
          },
          xAFirstHalf: {
            1: 'target_team_name удалось создать большую часть опасности в '
          },
          xATimesXARival: {
            1: 'target_team_name позволил слишком много опасности в плане ожидаемых голов в '
          },
          xASides: {
            1: ' Большая часть опасности target_team_name была создана со side_name (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: ', в то время как rival_team_name создал большую часть её со side_name (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'Создание опасности rival_team_name пришло, особенно, со side_name (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name был особенно эффективен в '
          },
          xAPerChanceCreated: {
            1: ' со средним xa_value'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name был особенно эффективен в '
          }
        }
      },
      step3: {
        text: {
          chance: ' момент',
          chances: ' моментов',
          goal: ' гол',
          goals: ' голов',
          home: 'дома',
          away: 'в гостях',
          last: 'последний',
          first: 'первый',
          goalScorer: 'бомбардир',
          goalScorers: 'бомбардиры',
          lastPhase: 'В последней фазе матча, ',
          phase: {
            1: 'В этой phase_position фазе игры, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> создал больше ожидаемой угрозы (<b style=\'color:more_color\'>more_xt_team_value xT</b>), чем <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'и делал это больше минут в этом периоде (<b style=\'color:more_color\'>more_time_xt_minutes мин.</b> против <b style=\'color:less_color\'>less_time_xt_minutes мин.</b> соперника)'
          },
          rivalTeamMoreMinutes: {
            1: 'однако именно соперник создавал опасность дольше (<b style=\'color:more_color\'>more_time_xt_minutes мин.</b> против <b style=\'color:less_color\'>less_time_xt_minutes мин.</b> соперника) в этом периоде игры'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> была командой, которая создала больше всего опасности (<b style=\'color:max_color\'>max_xt_team_value xT</b>) на <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', в то время как <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> создали свою максимальную опасность (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) на <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Обе команды сумели обыграть вратаря соперника по <b>number_of_goals_each_team</b> раз. Домашняя команда через <b style=\'color:#3366FF\'>home_player_name_goals</b> и гостевая команда через <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'В плане голов, <b style=\'color:replace_color\'>goal_scored_team_name</b> превзошла соперника на <b style=\'color:replace_color\'>difference_number_of_goals</b> разницы, обыграв их вратаря с <b style=\'color:replace_color\'>home_player_name_goals</b> как goal_scorer_word'
          }
        }
      },
      step4: {
        table: {
          team: 'Команда',
          period: 'Период',
          possession: 'Влад.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG ОП',
          tooltip: {
            team: 'Команда',
            period: 'Период',
            possession: 'Владение',
            ppda: 'Пропущенные передачи на защитное действие',
            xGOpenPlay: 'xG Игра в открытую'
          }
        },
        text: {
          clearly: 'явно',
          very: 'очень ',
          haveGotText1: 'получил только',
          haveGotText2: 'должен был получить больше чем',
          gaveUpPoss: 'отдал владение',
          lostPoss: 'потерял владение мячом',
          too: 'слишком ',
          possession: {
            1: 'В течение этой фазы игры <b style=\'color:team_color\'>team_name</b> clearly_text контролировал владение мячом'
          },
          equalPossession: {
            1: 'В этой фазе матча никто не доминировал над другим, так как владение мячом было довольно сбалансированным, хотя, глядя на цифры, <b style=\'color:team_color\'>team_name</b> немного превзошел своих соперников с <b style=\'color:team_color\'>possession_value%</b> владения'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> с плохим прессингом позволил <b style=\'color:rival_team_color\'>rival_team_name</b> дать <b style=\'color:target_team_color\'>ppda_value передач на защитное действие</b>'
          },
          lowPossessionLowPPDA: {
            1: ', но <b style=\'color:target_team_color\'>target_team_name</b> хорошо справился с прессингом мяча, когда rival_team_name имел владение, с <b>PPDA</b> <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' и смог играть благодаря very_textнизкой интенсивности прессинга от rival_team_name'
          },
          highPossessionHighPPDA: {
            1: ', хотя интенсивность прессинга rival_team_name была very_textвысокой'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> захватил высокое владение, давая <b>pft_value</b> <b>передач в финальную треть</b> поля. '
          },
          highPossessionMidLowPFT: {
            1: 'Несмотря на высокое владение, <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>передач в финальную треть</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Хотя <b style=\'color:target_team_color\'>target_team_name</b> possession_text в течение этой фазы, он смог дать <b>pft_value</b> <b>передач в финальную треть</b>. '
          },
          midPossessionHighPFT: {
            1: 'Довольно равное владение в течение этой фазы не остановило <b style=\'color:target_team_color\'>target_team_name</b> от дачи <b>pft_value</b> <b>передач в финальную треть</b>. '
          },
          highPFTHighTouchesIOB: {
            1: ' Помимо контроля игры в финальной трети, <b style=\'color:target_team_color\'>target_team_name</b> также имел большое присутствие в штрафной соперника. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> контролировал мяч в финальной трети, но не смог доставить много мячей в штрафную соперника'
          },
          highPFTMidTouchesIOB: {
            1: 'Учитывая количество <b>передач в финальную треть</b>, <b style=\'color:target_team_color\'>target_team_name</b> должен был создать больше опасности в штрафной соперника'
          },
          lowPFTHighTouchesIOB: {
            1: 'Хотя <b style=\'color:target_team_color\'>target_team_name</b> не выполнил много передач в финальной трети, он смог достичь штрафной соперника много раз. '
          },
          midPFTHighTouchesIOB: {
            1: 'Учитывая количество передач, выполненных в финальной трети, <b style=\'color:target_team_color\'>target_team_name</b> достиг штрафной соперника много раз. '
          },
          maxDirectness: {
            1: 'Стоит отметить, что это фаза игры, когда <b style=\'color:max_dir_color\'>target_team_name</b> играл более атакующе с <b>Прямолинейностью</b> <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> смог создать больше xG, чем в других фазах игры '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> удалось создать большой объем ожидаемых голов'
          },
          highXG: {
            1: 'создал хороший объем ожидаемых голов'
          },
          highXGLowPossession: {
            1: ' несмотря на отсутствие контроля мяча'
          },
          highXGLowShots: {
            1: ' только в нескольких ударах, имея <b>xG за удар</b> <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ', хотя xG за удар был too_textнизким. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> не смог создать никакой опасности для соперника'
          },
          lowXGMinXG: {
            1: 'В плане создания ожидаемых голов, это была слабая стадия для <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> создал очень низкий объем ожидаемых голов'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> не смог создать хороший объем ожидаемых голов'
          },
          lowXGHighPossession: {
            1: ', даже несмотря на то, что у них был контроль мяча. '
          },
          lowXGHighShots: {
            1: ', несмотря на множество ударов'
          },
          lowXGHighPFT: {
            1: ', несмотря на выполнение <b>pft_value</b> <b>передач в финальную треть</b> поля. '
          },
          midXGQuintileMinXG: {
            1: 'Хотя создание xG не было плохим, это была самая слабая фаза игры для <b style=\'color:target_team_color\'>target_team_name</b> в этом отношении'
          },
          midXGQuintileMaxXG: {
            1: 'Это была фаза, во время которой <b style=\'color:target_team_color\'>target_team_name</b> смог создать наибольший <b>xG (xg_value)</b>'
          }
        }
      },
      step5: {
        table: {
          team: 'Команда',
          period: 'Период',
          possession: 'Влад.',
          directness: 'Прям.',
          passesFinalThird: 'ПФ ⅓',
          tooltip: {
            team: 'Команда',
            period: 'Период',
            possession: 'Владение',
            directness: 'Прямолинейность',
            passesFinalThird: 'Передачи в финальную треть'
          }
        },
        text: {
          last: 'последний',
          goal: 'гол',
          goals: 'голов',
          chance: 'момент',
          chances: 'моментов',
          first: 'первый',
          homeTeam: 'домашняя команда',
          awayTeam: 'гостевая команда',
          home: 'дома',
          away: 'в гостях',
          clearly: 'явно',
          slightly: 'немного',
          firstOrLastPhase: {
            1: 'В этой phase_position фазе игры, ',
            2: 'В phase_position периоде матча, '
          },
          phase: {
            1: 'В течение этого периода матча, '
          },
          bothZeroGoalsScored: {
            1: 'без того, чтобы какая-либо команда смогла изменить счет.'
          },
          equalGoalsScored: {
            1: 'сумев забить <b>number_goals</b>'
          },
          differentGoalsScored: {
            1: 'сумев забить <b>number_goals</b>'
          },
          equalPossesion: {
            1: 'обе команды имели мяч ровно <b>poss_value%</b> времени'
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b> имел мяч больше минут (<b style=\'color:more_color\'>more_poss_team_value%</b> времени), чем их соперник <b style=\'color:less_color\'>less_poss_team_name</b> (<b style=\'color:less_color\'>less_poss_team_value%</b> времени)'
          },
          equalDirectness: {
            1: 'обе команды играли с одинаковой прямолинейностью (<b>directness_value</b> каждая)'
          },
          moreDirectnessSameTeam: {
            1: 'они также были более вертикальными, чем их соперники, играя с прямолинейностью <b style=\'color:more_color\'>more_dir_team_value</b> против <b style=\'color:less_color\'>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: 'однако именно home_away команда играла с большей прямолинейностью (<b style=\'color:more_color\'>more_dir_team_value</b>), чем соперник (<b style=\'color:less_color\'>less_dir_team_value</b>)'
          },
          equalChancesCreated: {
            1: 'Обе команды создали одинаковое количество моментов, ровно <b>chances_created_value</b> chance_text.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b> создал только <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b> и был adverb_text превзойден соперником (<b style=\'color:more_color\'>more_cc_team_value more_chance_text создано</b>). '
          },
          equalXA: {
            1: 'Обе команды имели равные возможности, как отражено в <b>xa_value ожидаемых передач</b>, '
          },
          moreXA: {
            1: 'home_away команда создала <b>diff_xa_team_value ожидаемых передач</b> (<b style=\'color:more_color\'>more_xa_team_value</b> против <b style=\'color:less_color\'>less_xa_team_value</b>) больше, чем соперник, '
          },
          xAOpenPlay: {
            1: 'создавая, соответственно, <b style=\'color:more_color\'>more_xa_op_value</b> и <b style=\'color:less_color\'>less_xa_op_value xA Игра в открытую</b>.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' каждый ',
          respectively: ', соответственно',
          with: ' (с <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'игрок был',
          playerWere: 'игроки были',
          firstPhase: {
            1: 'В этой первой части матча, самый важный player_text ',
            2: 'Что касается первой части игры, выделился '
          },
          otherPhase: {
            1: 'Между <b style=\'color:replace_color\'>min_from\'</b> и <b style=\'color:replace_color\'>min_to\'</b> следует упомянуть '
          },
          lastPhase: {
            1: 'В последней части игры, упомянуть ',
            2: 'Что касается последней фазы матча, '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b>, так как они выполнили наибольшее количество успешных передач для своей команды, ровно <b style=\'color:replace_color\'>successfull_passes_value передач</b> '
          },
          playerMaxTotalPasses: {
            1: ', что становится еще более ценным, когда цифры показывают, что они также были'
          },
          playerMaxTotalPasses2: {
            1: 'with_text игроком с наибольшим количеством попыток передач (<b style=\'color:replace_color\'>total_passes_value передач</b>). '
          },
          playerNotMaxTotalPasses: {
            1: ', хотя этот игрок не пытался сделать больше всего передач (<b style=\'color:replace_color\'>player_name</b> с <b style=\'color:replace_color\'>total_passes_value передачами</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: ', пытаясь в течение этого периода <b style=\'color:replace_color\'>total_passes_value передач</b> каждый. '
          },
          playerMaxPctPasses: {
            1: 'В плане <b style=\'color:replace_color\'>% Выполненных передач</b>, <b style=\'color:replace_color\'>player_name</b> имеет высокий <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'В отношении процента успешных передач, стоит упомянуть <b style=\'color:replace_color\'>player_name</b> с <b style=\'color:replace_color\'>max_pct_passes_value%</b> процентом успешных передач</b>. '
          },
          playerSumTotalXG: {
            1: 'В этом временном окне команда создала всего <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'В течение этого периода, <b style=\'color:replace_color\'>team_name</b> создал <b style=\'color:replace_color\'>xG</b> <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'Несмотря на выполнение всего <b style=\'color:replace_color\'>all_team_total_passes</b> между всей командой, это было напрасно, так как они не смогли создать ни одного момента. ',
            2: '<b style=\'color:replace_color\'>all_team_total_passes</b>, выполненные в этом периоде, не создали ни одного голевого момента. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 'с <b style=\'color:replace_color\'>player_xg_name</b> с <b style=\'color:replace_color\'>xg_value xG</b> и <b style=\'color:replace_color\'>player_xa_name</b> с <b style=\'color:replace_color\'>xa_value xA</b> как наиболее опасными игроками в плане создания моментов. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: ', будучи <b style=\'color:replace_color\'>player_name</b> с <b style=\'color:replace_color\'>xg_value xG</b> и <b style=\'color:replace_color\'>xa_value xA</b> инициатором большинства моментов своей команды. '
          },
          playersMaxXGMaxXA: {
            1: 'благодаря, среди прочих, <b style=\'color:replace_color\'>players_name</b>, которые создали <b style=\'color:replace_color\'>xa_value xA</b> каждый своими ключевыми передачами. '
          },
          playerMaxXGZeroXA: {
            1: ', будучи <b style=\'color:replace_color\'>player_xg_name</b> с <b style=\'color:replace_color\'>xg_value xG</b>, который имел полный вес моментов, вынужденный создавать их самостоятельно, так как не получил ни одной ключевой передачи. '
          },
          playersMaxXGZeroXA: {
            1: ', будучи <b style=\'color:replace_color\'>player_xg_name</b> с <b style=\'color:replace_color\'>xg_value xG</b>, который имел моменты, вынужденный создавать их самостоятельно, так как не получил ни одной ключевой передачи. '
          },
          oneMaxConnections: {
            1: 'Пара, которая сделала больше всего передач между собой в течение этого отрезка матча, была <b style=\'color:replace_color\'>couple_name</b>, всего <b style=\'color:replace_color\'>connections_value передач</b>. ',
            2: 'Дуэт, образованный <b style=\'color:replace_color\'>couple_name</b>, обменялся мячом <b style=\'color:replace_color\'>connections_value</b> раз. ',
            3: 'Дуэт <b style=\'color:replace_color\'>couple_name</b> был тем, кто передавал мяч больше всего в этом отрезке матча, делая это даже на <b style=\'color:replace_color\'>connections_value</b> моментах. '
          },
          twoMaxConnections: {
            1: 'Две пары, образованные <b style=\'color:replace_color\'>couple_name</b> и <b style=\'color:replace_color\'>couple_name2</b>, были наиболее повторяющимися связями для этого периода, передавая мяч друг другу <b style=\'color:replace_color\'>connections_value</b> раз. '
          },
          moreThanTwoMaxConnections: {
            1: 'Пары игроков, такие как <b style=\'color:replace_color\'>couple_name</b>, сделали <b style=\'color:replace_color\'>connections_value передач</b> друг другу. '
          },
          oneMinConnections: {
            1: 'С другой стороны, именно <b style=\'color:replace_color\'>couple_name</b> передавали мяч друг другу меньше всего, всего <b style=\'color:replace_color\'>connections_value передач</b>. ',
            2: 'На другом конце спектра, тандем, состоящий из <b style=\'color:replace_color\'>couple_name</b>, соединился только <b style=\'color:replace_color\'>connections_value</b> раз. '
          },
          twoMinConnections: {
            1: 'С другой стороны, <b style=\'color:replace_color\'>couple_name</b> и <b style=\'color:replace_color\'>couple_name2</b> едва обменивались передачами между собой (<b style=\'color:replace_color\'>connections_value передач</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Несколько комбинаций не соединились достаточно, например, дуэт <b style=\'color:replace_color\'>couple_name</b>, который с <b style=\'color:replace_color\'>connections_value передачами</b> находится среди наименее распространенных комбинаций. '
          }
        }
      },
      step7: {
        ballPossession: 'Владение мячом',
        gamePossessionDist: 'Распределение владения мячом'
      }
    },
    gamePossessionMap: {
      of: 'от',
      to: 'до',
      and: 'и',
      endsWith: 'Заканчивается',
      time: 'Время',
      touches: 'Касания',
      passes: 'Передачи',
      threat: 'Угроза',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Минуты',
      duration: 'Длительность',
      endsGoal: 'Заканчивается голом',
      endsInBox: 'Заканчивается в штрафной',
      withShot: 'С ударом',
      withCross: 'С навесом',
      possession: 'Владение',
      events: 'События',
      filters: 'Фильтры',
      filtersWarning: 'Угроза применяется только к владениям без ударов',
      sumWarning: 'Фильтр применяется к сумме xG всех ударов в последовательности, поэтому может быть больше 1',
      show: 'Показать',
      sequenceNumbers: 'Номер последовательности',
      jerseyNumbers: 'Номер',
      pass: 'Передача',
      carryAndPass: 'Ведение и передача',
      carryAndAction: 'Ведение и действие',
      carryAndShot: 'Ведение и удар',
      shotFailed: 'Неудачный удар',
      goal: 'Гол',
      savedShot: 'Отраженный удар',
      missedShot: 'Неточный удар',
      shotOnPost: 'Удар в штангу',
      headerGoal: 'Гол головой',
      headerFailed: 'Неудачный удар головой',
      failed: 'неудачно',
      with: 'с'
    },
    report: {
      title: 'Отчет о матче',
      maps: 'Карты',
      xGRace: 'Гонка xG',
      lineups: 'Составы',
      button: 'Создать полный PDF отчет о матче',
      mobileButton: 'PDF отчет',
      most: 'Больше всего',
      topXPlayers: 'Топ {x} игроков',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Отчет о физических данных игры'
    },
    avgScoreTooltip: 'Средний балл за минуту',
    status: {
      scheduled: 'Запланировано',
      postponed: 'Перенесенный',
      cancelled: 'Отменено',
      inPlay: 'Жить',
      finished: 'Законченный',
      awarded: 'Награжден',
      dataAvailable: 'Данные будут доступны в ближайшие часы'
    },
    preGameAnalysis: {
      showExpectations: 'Показать ожидания',
      hideExpectations: 'Скрыть ожидания',
      goalsPeriods: 'Цели Периоды',
      synergyIndex: 'Индекс синергии',
      synergyIndexSubtitle: 'Общая прочность соединения пасующего и финишера'
    }
  },
  general: {
    1: 'Один',
    2: 'Два',
    3: 'Три',
    4: 'Четыре',
    5: 'Пять',
    8: 'Слева',
    9: 'Обе',
    10: 'Справа',
    create: 'Создать',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    reset: 'Перезагрузить',
    go: 'Перейти',
    formErrors: {
      required: 'Поле обязательно',
      passwordMatch: 'Пароли не совпадают',
      minLength: 'Минимальная длина',
      maxLength: 'Максимальная длина',
      emailValid: 'E-mail должен быть действительным',
      youthAge: 'Возраст должен быть от 10 до 23',
      seasonYear: 'Год должен быть от 2016 до 2050',
      integer: 'Десятичные числа не допускаются'
    },
    confirmationTitle: 'Вы уверены?',
    confirmationMessage: 'Пожалуйста, подтвердите, если вы хотите выполнить действие',
    yes: 'Да',
    no: 'Нет',
    search: 'Поиск',
    clearFilters: 'Очистить фильтры',
    minimum: 'Минимум',
    maximum: 'Максимум',
    minimumPercent: '(%)Минимальный процент',
    period: 'Период',
    exclude: 'Исключить',
    team: 'Команда',
    clear: 'Очистить',
    all: 'Все',
    ground1: 'Все',
    ground2: 'Дома',
    ground3: 'В гостях',
    filter: 'Фильтр',
    noData: 'Результаты не найдены',
    noDataGivenFilters: 'Результаты не найдены с заданными фильтрами',
    similarityMinutesWarning: 'Нет данных из-за менее 450 сыгранных минут',
    templateOnlyEditable: 'Шаблон можно редактировать только ',
    close: 'Закрыть',
    load: 'Загрузить',
    filters: 'Фильтры',
    players: 'игроков',
    teams: 'команд',
    compare: 'Сравнить',
    seeMore: 'Показать больше',
    seeLess: 'Показать меньше',
    request: 'Запрос',
    notes: 'Заметки',
    closeSession: 'Выход',
    settings: 'Настройки',
    player: 'Игрок',
    state: 'Состояние',
    updated: 'Обновлено',
    file: 'Файл',
    uploadFile: 'Загрузить файл',
    reports: 'Отчеты',
    download: 'Скачать',
    new: 'Новый',
    comparison: 'Сравнение',
    scout: 'Скаут',
    favorites: 'Избранное',
    moreOptions: 'Больше опций',
    lessOptions: 'Меньше опций',
    today: 'Сегодня',
    home: 'Дома',
    away: 'В гостях',
    until: 'до',
    firstHalf: 'Первый тайм',
    secondHalf: 'Второй тайм',
    firstPeriodOT: 'Первый тайм ДВ',
    secondPeriodOT: 'Второй тайм ДВ',
    postponed: 'Перенесено',
    stats: 'Статистика',
    yesterday: 'Вчера',
    last: 'Последний',
    startDate: 'Дата начала',
    active: 'Активный',
    playerLimit: 'Лимит игроков',
    type: 'Тип',
    successMessage: 'Операция прошла успешно',
    failMessage: 'Операция не удалась',
    by: 'От',
    checkYourInbox: 'Проверьте вашу почту',
    faq: 'Глоссарий',
    globalSearch: 'Глобальный поиск',
    gamesLost: 'Пропущенные игры',
    outOf: 'из',
    avgSeason: 'Среднее по сезону',
    leftDays: 'оставшихся дней',
    notifyError: 'Уведомить об ошибке',
    notify: 'Уведомить',
    comments: 'Комментарии',
    searches: 'Поиски',
    now: 'Сейчас',
    twoHoursAgo: 'Два часа назад',
    incomings: 'Прибытия',
    departures: 'Уходы',
    transferLoans: 'Аренды',
    transfers: 'Трансферы',
    movements: 'Движения',
    incomes: 'Доходы',
    expenditures: 'Расходы',
    action: 'Действие',
    target: 'Цель',
    uses: 'Использований',
    users: 'Пользователей',
    since: 'с',
    mediaMode: 'Режим медиа',
    white: 'Белый',
    enabled: 'Включено',
    disabled: 'Отключено',
    left: 'Слева',
    right: 'Справа',
    both: 'Обе',
    'left-both': 'Слева обе',
    'right-both': 'Справа обе',
    'left foot': 'Левая',
    'right foot': 'Правая',
    files: 'Файлы',
    confirm: 'Подтвердить',
    currentStep: 'Текущий шаг',
    phases: 'Фазы',
    entries: 'Записи',
    none: 'Нет',
    times: 'раз',
    darkMode: 'Темный режим',
    client: 'Клиент',
    visits: 'Посещения',
    lastVisit: 'Последнее посещение',
    strong: 'Сильная',
    medium: 'Средняя',
    weak: 'Слабая',
    goal: 'Гол',
    list: 'Список',
    map: 'Карта',
    copiedToClipboard: 'Скопировано в буфер обмена',
    division: 'Дивизион',
    many: 'Много',
    few: 'Мало',
    median: 'Медиана',
    topRight: 'Верх справа',
    topLeft: 'Верх слева',
    bottomRight: 'Низ справа',
    bottomLeft: 'Низ слева',
    library: 'Библиотека',
    mediaLibrary: 'Медиа библиотека',
    for: 'Для',
    stat: 'Статистика',
    position: 'Позиция',
    order: 'Порядок',
    add: 'Добавить',
    visualization: 'Визуализация',
    basic: 'Базовый',
    selectAll: 'Выбрать все',
    unselectAll: 'Снять выбор',
    distribution: 'Распределение',
    end: 'Конец',
    accuracy: 'точность',
    opponent: 'Соперник',
    ownTeam: 'Своя команда',
    center: 'Центр',
    line: 'Линия',
    live: 'В прямом эфире',
    unavailable: 'недоступно',
    calendar: 'Календарь',
    activeLeague: 'Лига в процессе',
    similarity: 'Похожесть',
    emptyForSelectAll: 'Пусто для выбора всех',
    size: 'Размер',
    selectPlayersRestriction: 'Выберите от 1 до {x} игроков',
    group: 'Группа',
    alerts: 'Уведомления',
    shortcuts: 'Горячие клавиши',
    share: 'Поделиться',
    dataAvailable: 'Данные будут доступны в ближайшее время',
    someStatsAvailableSoon: 'Некоторые статистики будут доступны в ближайшее время',
    monthGamesWarning: 'Игры выбранного месяца будут доступны в ближайшее время',
    metrics: 'Метрики',
    competition: 'Соревнование',
    code: 'Код',
    alias: 'Псевдоним',
    never: 'Никогда',
    unlimited: 'Без ограничений',
    user: 'Пользователь',
    warning: 'Предупреждение',
    requests: 'Запросы',
    contactSales: 'Связаться с продажами',
    comingSoon: 'Скоро!',
    firstPost: '1-й пост',
    secondPost: '2-й пост',
    dZone: 'Зона D',
    penaltySpot: 'Точка пенальти',
    secondPlay: '2-я игра',
    otherZone: 'Другая зона',
    baseline: 'Базовая линия',
    youth: 'Молодежная',
    male: 'Мужской',
    direct: 'Прямой',
    indirect: 'Непрямой',
    processing: 'Обработка',
    addNew: 'Добавить новый',
    createdBy: 'Создано',
    downloading: 'Загрузка',
    displayType: 'Тип отображения',
    alreadyExists: 'уже существует',
    aggregation: 'Агрегация',
    unavailableLeagues: 'У вас нет доступа ни к одной из лиг, в которых играл игрок',
    meters: 'Метры',
    quantity: 'Количество',
    allTime: 'За все время',
    games: 'Игры',
    unit: 'Единица',
    categories: 'Категории',
    maintenanceWarning: 'Идет обслуживание',
    maintenanceMessage: 'Мы вносим некоторые обновления. Изменения, которые вы делаете прямо сейчас, не будут сохранены. Спасибо за терпение!',
    seeAll: 'Показать все',
    from: 'От',
    to: 'на',
    showFilters: 'Показать фильтры',
    hideFilters: 'Скрыть фильтры',
    horizontal: 'Горизонтальный',
    vertical: 'Вертикальный',
    drop: 'Уронить',
    orientation: 'Ориентация',
    goalProbability: 'Вероятность гола',
    assistProbability: 'Ассистент Вероятность',
    attackingDirection: 'Направление атаки',
    currentTeam: 'Текущая команда',
    expectations: 'Ожидания',
    sideBySide: 'Бок о бок',
    teamValue: 'Ценность команды',
    fieldLayout: 'Макет поля',
    searchPlaceholder: 'Type {x} letters at least to search'
  },
  playerScout: {
    dlabDatabase: 'База данных Driblab',
    league: 'Лига',
    top5: 'Топ 5',
    topCountries: 'Страны',
    tier: 'Уровень',
    division1: 'Первый дивизион',
    division2: 'Второй дивизион',
    division3: 'Третий дивизион',
    division4: 'Четвертый дивизион',
    division5: 'Пятый дивизион',
    division6: 'Шестой дивизион',
    summary: 'Сводка',
    offensive: 'Атака',
    defensive: 'Защита',
    gk: 'ВР',
    all: 'Все',
    physical: 'Физ',
    arrigo: 'Arrigo',
    yearTooltip: 'Разрешен только один год',
    expectedThreat: 'xThreat',
    expectedThreatTooltip: 'Угроза, добавленная ко всем владениям',
    expectedThreatOP: 'xThreat ОП',
    expectedThreatOPTooltip: 'Угроза, добавленная к владениям в открытую',
    expectedThreatInTeam: 'xThreat в команде %',
    expectedThreatInTeamTooltip: '% угрозы, добавленной игроком в команду',
    ballProgression: 'Прогрессия мяча',
    ballProgressionTooltip: 'Прогрессии +10 метров',
    deepProgression: 'Глубокие прогрессии',
    deepProgressionTooltip: 'Прогрессии мяча до последней пятой',
    ballRetention: '% Удержание мяча',
    ballRetentionTooltip: 'Процент действий, где мяч был успешно удержан',
    ballRetentionOppHalf: '% Удержание мяча ЧП',
    ballRetentionOppHalfExplicit: 'Процент времени, когда у вас есть владение мячом и вы не теряете его в половине соперника',
    finishing: 'Завершение',
    finishingTooltip: '% ударов, заканчивающихся голом',
    scoringContribution: 'Вклад в голы',
    scoringContributionTooltip: 'Передачи + Голы',
    xgPerShot: 'xG за удар',
    xgPerGoal: 'xG за гол',
    headerPerCross: 'Удар головой за навес',
    completedCrosses: 'Выполненные навесы',
    crossingPct: '% Навесы',
    crossingEfficiency: 'Эффективность навесов',
    crossingEfficiencyTooltip: 'Эффективность навесов (измеряет качество и количество)',
    longBalls: 'Длинные передачи',
    longPassing: '% Длинная передача',
    dribblingPct: '% Дриблинг',
    throughBalls: 'Сквозные передачи',
    oppBoxTouches: 'Касания в штрафной соперника',
    oppBoxTouchesTooltip: 'Касания в штрафной соперника',
    openPlayKeyPasses: 'Ключевые передачи ОП',
    openPlayKeyPassesTooltip: 'Передачи в открытую, заканчивающиеся ударом',
    xGBuildup: 'xG Построение',
    xGBuildupTooltip: 'xG последовательностей, заканчивающихся ударом, где участвовал игрок (исключая xG удара и ключевой передачи)',
    Assists: 'Передачи',
    passPercentage: '% Передачи',
    passPerLongBall: 'Передача за ДП',
    passPerLongBallExplicit: 'Передача за длинную передачу',
    nonPenaltyGoals: 'Голы без пенальти',
    xG: 'xG',
    xGExplicit: 'Ожидаемые голы',
    shots: 'Удары',
    xGShot: 'xG за удар',
    xGChain: 'xG Цепь',
    xGChainTooltip: 'xG последовательностей, заканчивающихся ударом, где участвовал игрок',
    chancesCreated: 'Передачи, за которыми следует удар',
    chances: 'Моменты',
    dribbles: 'Дриблинги',
    dribblesSuccessfull: 'Успешные дриблинги',
    touches: 'Касания в штрафной соперника',
    xA: 'xA',
    xAExplicit: 'Ожидаемые передачи',
    xAOpenPlay: 'xA ОП',
    xAOpenPlayExplicit: 'Ожидаемые передачи в открытую',
    passesOpponentBox: 'Передачи в штрафную соперника',
    passesOB: 'Передачи в ШС',
    passesFinalThirdTooltip: 'Передачи в финальную треть',
    passesSuccessful: 'Успешные передачи',
    passesSuccessfulTooltip: 'Успешные передачи',
    ballProgressionPassing: 'ПМ передачами',
    ballProgressionPassingTooltip: 'Прогрессия мяча передачами',
    ballProgressionDribbling: 'ПМ ведением',
    ballProgressionDribblingTooltip: 'Прогрессия мяча ведением',
    passesTotal: 'Передачи',
    passesTotalTooltip: 'Всего попыток передач',
    shortPassesSuccessful: 'Успешные КП',
    shortPassesSuccessfulTooltip: 'Количество выполненных коротких передач',
    shortPassesTotal: 'Всего КП',
    shortPassesTotalTooltip: 'Количество попыток коротких передач',
    tackles: 'Отборы *',
    adjustedTackles: 'Отборы с учетом владения',
    interceptions: 'Перехваты *',
    adjustedInterceptions: 'Перехваты с учетом владения',
    aerials: 'Верховые единоборства',
    aerialsPercent: '% Верховые',
    aerialEfficiency: 'Эффективность верховых',
    aerialEfficiencyTooltip: 'Эффективность верховых (измеряет качество и количество)',
    twd: 'TwD',
    tacklesWasDribbled: 'Выигранные оборонительные единоборства 1 в 1',
    fouls: 'Фолы',
    indPressure: 'Индивидуальное давление',
    pressure: 'Давление',
    dispossessed: 'Потеря владения',
    recoveries: 'Подборы',
    primary: 'Основная',
    secondary: 'Вторичная',
    position: 'Позиция',
    nationality: 'Национальность',
    height: 'Рост (см)',
    minHeight: 'Мин. рост',
    maxHeight: 'Макс. рост',
    age: 'Возраст',
    minAge: 'Мин. возраст',
    maxAge: 'Макс. возраст',
    games: 'Игры',
    minGames: 'Мин. игры',
    maxGames: 'Макс. игры',
    minutes: 'Минуты',
    minMinutes: 'Мин. минуты',
    maxMinutes: 'Макс. минуты',
    minPercentMinutes: 'Мин. процент минут',
    dates: 'Даты',
    marketValue: '(€) Рыночная стоимость',
    teams: 'Команды',
    contractEnd: 'Окончание контракта',
    minValue: 'Мин. стоимость',
    maxValue: 'Макс. стоимость',
    excludeTeams: 'Исключить команды',
    recentSearches: 'Недавние поиски',
    saveSearch: 'Сохранить поиск',
    loadSearch: 'Загрузить поиск',
    loadCollection: 'Загрузить коллекцию',
    collection: 'Коллекция',
    search: 'Поиск',
    searchesList: 'Списки поиска',
    mySearches: 'Мои поиски',
    mySearchesDescription: 'Те, которые вы сохранили ранее',
    recentSearchesDescription: 'Последние 10 поисков, которые вы делали',
    searchToLoad: 'Поиск для загрузки',
    recentSearch: 'Недавний поиск',
    saveSearchSuccess: 'Поиск успешно сохранен',
    removeSearch: 'Удалить поиск',
    removeSearchMessage: 'Вы уверены, что хотите удалить поиск?',
    updateSearch: 'Обновить поиск',
    updateSearchMessage: 'Вы уверены, что хотите обновить поиск?',
    deleteSearchSuccess: 'Поиск был удален',
    playersFound: 'игроков найдено',
    addToCollection: 'Добавить в коллекцию',
    npg: 'NPG',
    goals: 'Голы',
    value: 'Стоимость',
    nationalTeams: 'Сборные',
    gbeScore: 'GBE',
    dlIndex: 'Оценка',
    minGbe: 'Мин. GBE',
    goalsConceded: 'Пропущенные голы',
    npgConceded: 'Пропущенные NPG',
    npgConcededTooltip: 'Пропущенные голы без пенальти',
    xGOTConceded: 'xG в створ пропущено',
    xGOTConcededTooltip: 'xG ударов, полученных в створ',
    goalsPrevented: 'Предотвращенные голы',
    xGFacedPerShotOnTarget: 'xG в створ за удар',
    xGFacedPerShotOnTargetTooltip: 'xG в створ за пропущенный удар',
    xGSavedPerxGFacedOnTarget: 'xG Отражение',
    xGSavedPerxGFacedOnTargetTooltip: 'Процент отражений с учетом xG',
    savesPct: '% Отражения',
    savesOutOfBoxPct: '% Отражения вне штрафной',
    savesInBoxPct: '% Отражения в штрафной',
    xGFacedPerGoal: 'xG в створ за гол',
    xGFacedPerGoalTooltip: 'xG необходимое для забития гола',
    catchingPct: '% Ловля',
    catchingTooltip: '% отражений, пойманных',
    passingOwnHalfPct: '% Передачи своя половина',
    passingOwnHalfPctTooltip: 'Процент успешных передач в своей половине',
    passingOppHalfPct: '% Передачи половина соперника',
    passingOppHalfPctTooltip: 'Процент успешных передач в половине соперника',
    passingContribution: '% Вклад передач',
    passingContributionTooltip: 'Вклад угрозы передачей мяча - выше среднего',
    shotsPerGoal: 'Удары за гол',
    passesFinalThird: 'Передачи в финальную треть',
    passingFinalThird: '% Передачи в финальную треть',
    claimAccuracy: 'Точность перехвата',
    claimAccuracyTooltip: 'Мячи перехвачены выше среднего',
    highTurnovers: 'Высокие потери',
    highTurnoversTooltip: 'Потери ближе 40 метров к воротам',
    shotEndingHighTurnovers: 'Удар после высоких потерь',
    shotEndingHighTurnoversTooltip: 'Удар после высоких потерь',
    goalEndingHighTurnovers: 'Гол после высоких потерь',
    goalEndingHighTurnoversTooltip: 'Гол после высоких потерь',
    avgCarriesProgress: 'Средняя прогрессия',
    avgCarriesProgressTooltip: 'Среднее расстояние перемещения мяча вертикально (метры)',
    carriesChance: 'Момент после ведения',
    carriesChanceTooltip: 'Ведения, за которыми следует ключевая передача',
    carriesAssist: 'Передача после ведения',
    carriesAssistTooltip: 'Ведения, за которыми следует передача',
    carriesShot: 'Удар после ведения',
    carriesShotTooltip: 'Ведения, за которыми следует удар',
    carriesGoal: 'Гол после ведения',
    carriesGoalTooltip: 'Ведения, за которыми следует гол',
    shotEndingSequence: 'Удар после последовательности',
    shotEndingSequenceTooltip: 'Количество последовательностей, заканчивающихся ударом, где участвовал игрок',
    goalEndingSequence: 'Гол после последовательности',
    goalEndingSequenceTooltip: 'Количество последовательностей, заканчивающихся голом, где участвовал игрок',
    gbeScoreTooltip: 'Одобрение руководящего органа футбола ФА',
    goalsPreventedTooltip: 'Голы без пенальти, спасенные вратарем (xG в створ - пропущенные NPG)',
    freePlayers: 'Свободные агенты',
    index: 'Индекс',
    playerName: 'Имя',
    teamName: 'Команда',
    secondPos: 'Вторая поз.',
    side: 'Сторона',
    onlyOnLoan: 'Только в аренде',
    dob: 'Рождение',
    countryName: 'Страна',
    secondCountryName: 'Вторая страна',
    seasonYear: 'Сезон',
    assists: 'Передачи',
    placeholder: 'Вы можете начать добавлять фильтры лиг',
    placeholder2: 'Нажмите кнопку поиска, чтобы показать результаты',
    passesPct: '% Передачи',
    passingPct: '% Передачи',
    oppBoxPasses: 'Передачи в штрафную соперника',
    adjustedClearances: 'Скорректированные выносы',
    aerialsPct: '% Верховые',
    leagueCountryCode: 'Код страны лиги',
    shooting: '% Удары в створ',
    xtPassing: 'xT Передачи',
    xtPassingTooltip: 'Угроза, добавленная передачами',
    xtDribbling: 'xT Ведение',
    xtDribblingTooltip: 'Угроза, добавленная ведением',
    foot: 'Сильная нога',
    aggressiveActions: 'Агрессивные действия',
    aggressiveActionsTooltip: 'Количество попыток отборов в следующие две секунды после потери владения',
    tacklesAttempted: 'Всего попыток отборов',
    highDefensiveActionPct: '% ВД действий',
    highDefensiveActionPctTooltip: 'Процент защитных действий, сделанных в 40 метрах от ворот соперника',
    individualPressureOppHalf: 'Давление половина соперника',
    individualPressureOppHalfTooltip: 'Метрика, измеряющая количество успешных усилий (восстановленных владений), сделанных игроком при прессинге соперника в половине соперника',
    xGBuildUp5Pass: 'xG Построение 5п',
    xGBuildUp5PassTooltip: 'Количество xG, в котором участвовал игрок, только последние 5 передач (исключая удары и передачи, ведущие к удару)',
    chancesCreatedOpenPlay: 'Созданные моменты ОП',
    chancesCreatedOpenPlayTooltip: 'Количество передач, ведущих к удару во время игры в открытую',
    fmf: {
      Defender: 'Защитник',
      aerial: 'Верховой',
      goodDefender: 'Хороший защитник',
      goodPresence: 'Хорошее присутствие',
      playmaking: 'Создание игры',
      Fullback: 'Крайний защитник',
      defensiveness: 'Защитность',
      offensiveness: 'Атакующий',
      fast: 'Быстрый',
      Forward: 'Нападающий',
      goalChances: 'Голевые моменты',
      goodDecissions: 'Хорошие решения',
      individualTechnique: 'Индивидуальная техника',
      Goalkeeper: 'Вратарь',
      footWork: 'Работа ног',
      leadership: 'Лидерство',
      Midfielder: 'Опорный полузащитник',
      balance: 'Баланс',
      ballRetention: '% Удержание мяча',
      offensivePasses: 'Атакующие передачи',
      recoveries: 'Подборы',
      shotToGoal: 'Удар в гол',
      'Attacking-Midfielder': 'Атакующий полузащитник',
      defensiveGame: 'Защитная игра',
      offensiveGame: 'Атакующая игра',
      Winger: 'Крайний нападающий',
      crossing: 'Навесы',
      deepProgressions: 'Глубокие прогрессии',
      defendingEffort: 'Защитные усилия',
      facing: 'Лицом к лицу'
    },
    yellowCards: 'Желтые карточки',
    redCards: 'Красные карточки',
    alert: 'Уведомление',
    yearOfBirth: 'Год рождения',
    minYearOfBirth: 'Мин. год рождения',
    maxYearOfBirth: 'Макс. год рождения',
    women: 'Женщины',
    continental: 'Континентальный',
    countryCup: 'Кубок страны',
    statsName: 'Название статистики',
    abbreviation: 'Сокращение',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Показаны только сыгранные в прошлом регулярном сезоне',
    gamesWith60PlusMinsTooltip: 'Минимальное количество сыгранных игр продолжительностью более 60 минут.',
    starts: 'Начинается',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Сравнить до 5 игроков',
    requestReport: 'Запросить отчет',
    searchBarPlaceholder: 'Поиск игрока или команды',
    allStats: 'Вся статистика',
    placeholder: 'Вы можете начать добавлять игроков'
  },
  reports: {
    detailedInsights: 'Получить детальную информацию',
    features: 'Особенности отчета',
    performance: 'Производительность',
    evolution: 'Эволюция',
    compareWithMyTeam: 'Сравнить с моей командой',
    similarPlayers: 'Похожие игроки',
    potentialTeams: 'Потенциальные команды',
    requestSuccess: 'Запрос успешно отправлен',
    requestAt: 'Запрошено',
    reportConversation: 'Разговор об отчете',
    writeYourMessage: 'Напишите ваше сообщение...',
    you: 'Вы'
  },
  state: {
    requested: 'Запрошено',
    inProgress: 'В процессе',
    delivered: 'Доставлено'
  },
  langs: {
    es: 'Испанский',
    en: 'Английский',
    fr: 'Французский',
    de: 'Немецкий',
    it: 'Итальянский',
    pt: 'Португальский',
    tr: 'Турецкий',
    jp: 'Японский',
    cn: 'Китайский',
    sa: 'Арабский',
    nl: 'Голландский',
    pl: 'Польский',
    sv: 'Шведский',
    cs: 'чешский',
    ko: 'корейский',
    hu: 'Венгерский',
    ru: 'Русский',
    se: 'Шведский',
    cze: 'Чешский',
    kor: 'Корейский'
  },
  langsArea: {
    europe: 'Европа',
    asia: 'Азия',
    arabic: 'Арабский'
  },
  inbox: {
    subtitle: 'Будьте в курсе',
    new_injury_alert: 'Новое уведомление о травме',
    new_contract_alert: 'Новое уведомление о контракте',
    new_team_alert: 'Новое уведомление о подписании',
    new_marketValue_alert: 'Новое уведомление о рыночной стоимости',
    new_game_alert: 'Новое уведомление об сыгранной игре',
    receive_mail: 'Получать почту',
    receive_mail_subtitle: 'Получать ежедневную почту с игроками, соответствующими фильтрам',
    receive_notifications: 'Уведомления',
    receive_notifications_subtitle: 'Получать уведомления в приложении с игроками, соответствующими фильтрам',
    changedTo: 'Изменено на',
    alerts: 'Уведомления',
    includedIn: 'Включено в',
    noContract: 'Нет контракта',
    newMessages: 'Новые сообщения',
    reply: {
      reply: 'Ответить',
      replyTitle: 'Дать обратную связь клиенту:',
      replyPlaceholder: 'Пользователь получит ответ вместе с обновлением статуса'
    }
  },
  gameAnalysis: {
    subtitle: 'Получите информацию о последних матчах',
    subtitle2: 'Показ игр в следующие семь дней',
    subtitle3: 'Получите информацию о последних матчах и изучите следующие',
    seeDetail: 'Смотреть детали'
  },
  statsNaming: {
    Possession: 'Владение',
    TimePossession: 'Время владения',
    PassesPerShots: 'Передачи за удар',
    PPDA: 'PPDA',
    ExpectedPoints: 'Ожидаемые очки',
    Points: 'Очки',
    Directness: 'Прямолинейность',
    PassesPerLongBall: 'Передачи за длинную передачу',
    CrossingPerXG: 'Навесы за xG',
    PenaltySavedPenaltyFaced: 'Пенальти отражено/Пенальти получено',
    Goals: 'Голы',
    PenaltyShots: 'Удары с пенальти',
    PenaltyGoals: 'Голы с пенальти',
    NonPenaltyGoals: 'Голы без пенальти',
    NPGOpenPlay: 'NPG Игра в открытую',
    NPGSetPiece: 'NPG Стандарт',
    Shooting: 'Удары',
    Finishing: 'Завершение',
    xGEfficiency: 'Эффективность xG',
    HeaderPerShot: 'Удар головой за удар',
    HeaderPerCross: 'Удар головой за навес',
    HeadedGoals: 'Цели во главе',
    GoalsConceded: 'Пропущенные голы',
    SavesInBox: 'Сохраняет в коробке',
    SavesOutBox: 'Сохранения из коробки',
    Assists: 'Передачи',
    ThroughBalls: 'Сквозные передачи',
    CrossEfficiency: 'Эффективность навесов',
    ScoringContribution: 'Вклад в голы',
    xAssistsOpenPlay: 'xПередачи Игра в открытую',
    xAssistsSetPiece: 'xПередачи Стандарт',
    xAssistsOpenPlayInTeam: 'xПередачи Игра в открытую в команде',
    xAssistsSetPieceInTeam: 'xПередачи Стандарт в команде',
    xGBuildupFinalThird: 'xG Построение финальная треть',
    xGChainFinalThird: 'xG Цепь финальная треть',
    BallProgressionPassing: 'Прогрессия мяча передачами',
    BallProgressionDribbling: 'Прогрессия мяча ведением',
    TacklesWasDribbled: 'Выигранные оборонительные единоборства 1 в 1',
    TacklesSuccessful: 'Успешные отборы',
    Interceptions: 'Перехваты',
    Clearances: 'Выносы',
    Fouls: 'Фолы',
    Recoveries: 'Подборы',
    Shots: 'Удары',
    ShotsPerGoal: 'Удары за гол',
    ShortPassesSuccessful: 'Успешные короткие передачи',
    PassingSuccessForwardPct: '% Успех передач вперед',
    PassingSuccessBackwardPct: '% Успех передач назад',
    PassingForwardBackwardPct: '% Передачи вперед за назад',
    LongBallPerPassesPct: '% Длинная передача за передачи',
    LongBallReceived: 'Полученные длинные передачи',
    LongBallReceivedOppHalf: 'Полученные длинные передачи половина соперника',
    OffensiveActions: 'Атакующие действия',
    DribblesAttempted: 'Попытки дриблинга',
    SuccessfulDribblesPct: '% Успешных дриблингов',
    OffensiveTouchesOutBoxPct: '% Атакующих касаний вне штрафной',
    BallRetention: '% Удержание мяча',
    PassingPct: '% Передачи',
    PassingOwnHalfPct: '% Передачи своя половина',
    PassingOppHalfPct: '% Передачи половина соперника',
    PassingFinalThird: 'Передачи в финальную треть',
    PassesFinalThirdTotal: 'Общее количество передач Финал ⅓',
    PassingFinalThirdPct: '% Передачи в финальную треть',
    LongBallSuccessful: 'Выполненные длинные передачи',
    LongBallPct: '% Длинные передачи',
    LongBallTotal: 'Всего длинных мячей',
    SavesPct: '% Отражения',
    SavesInBoxPct: '% Отражения в штрафной',
    SavesOutOfBoxPct: '% Отражения вне штрафной',
    xGSavedPerXGFacedOnTarget: 'xG Отражено/xG в створ',
    xGFacedOnTargetPerGoalReceived: 'xG в створ за гол',
    xGFacedOnTargetEfficiency: 'Предотвращенные голы',
    xGFacedOnTarget: 'xG в створ',
    IndividualPressure: 'Индивидуальное давление',
    AerialEfficiency: 'Эффективность верховых',
    AerialWins: 'Выигранные верховые',
    AerialWinsPct: '% Выигранных верховых',
    xG: 'Ожидаемые голы',
    xGDiff: 'Разница xG',
    xGOpenPlay: 'xG Игра в открытую',
    xGSetPiece: 'xG Стандарт',
    xGPerShot: 'xG за удар',
    ChancesCreated: 'Созданные моменты',
    CompletedCrosses: 'Выполненные навесы',
    Crossing: '% Навесы',
    OpenPlayKeyPasses: 'Ключевые передачи игра в открытую',
    OpenPlayKeyPassesInTeam: '% Ключевые передачи игра в открытую в команде',
    OpenPlayPassesIntoOpponentBox: 'Всего ОП передач в штрафную',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'ОП передачи в штрафную',
    xAssists: 'Ожидаемые передачи',
    xGChain: 'xG Цепь',
    xGBuildup: 'xG Построение',
    xGBuildupInTeam: 'xG Построение в команде',
    BallProgression: 'Прогрессия мяча',
    SuccessfulDribbles: 'Успешные дриблинги',
    Dispossessed: 'Потеря владения',
    TouchesInOpponentBox: 'Касания в штрафной соперника',
    xGSavedPerShot: 'xG отражено за удар',
    BallRetentionOppHalf: '% Удержание мяча половина соперника',
    DeepProgression: 'Глубокая прогрессия',
    DeepProgressionFinalThird: 'Глубокая прогрессия в финальную треть',
    FoulsTaken: 'Полученные фолы',
    PenaltiesTaken: 'Полученные пенальти',
    BlockedCrosses: 'Заблокированные навесы',
    BlockedShots: 'Заблокированные удары',
    Blocks: 'Блоки',
    NonPenaltyGoalsAgainst: 'Пропущенные голы без пенальти',
    Headers: 'Удары головой',
    AveragePassDistance: 'Средняя дистанция передачи',
    ProgressiveRuns: 'Прогрессивные ведения',
    xT: 'Ожидаемая угроза (xT)',
    xTOpenPlay: 'xT Игра в открытую',
    xTSetPiece: 'xT Стандарт',
    xGOT: 'Ожидаемые голы в створ',
    BadActions: 'Плохие действия',
    BadActionsOwnHalf: 'Плохие действия своя половина',
    AerialsWonOwnBox: 'Выигранные верховые своя штрафная',
    AerialsWonOppBox: 'Выигранные верховые штрафная соперника',
    AerialsTotalOppBox: 'Всего верховых штрафная соперника',
    AerialsTotalOwnBox: 'Всего верховых своя штрафная',
    FoulsOwnHalfPct: '% Фолы своя половина',
    RecoveriesOppHalf: 'Подборы половина соперника',
    DuelsPct: '% Успешных единоборств',
    TacklesUnsuccessful: 'Неуспешные отборы',
    TacklesWasDribbledFirstThird: 'Выигранные оборонительные единоборства 1 в 1 ⅓',
    TacklesWasDribbledSecondThird: 'Выигранные оборонительные единоборства 1 в 1 ⅔',
    TacklesWasDribbledFinalThird: 'Выигранные оборонительные единоборства 1 в 1 ⅓',
    BallProgressionFinalThird: 'Прогрессия мяча финальная треть',
    DuelsTotal: 'Единоборства',
    QuickRecoveries: 'Быстрые подборы',
    ShotsPerNPG: 'Удары за NPG',
    ShotsOutBox: 'Удары вне штрафной',
    GoalsOutBox: 'Голы вне штрафной',
    ShootingOutBox: '% Удары вне штрафной',
    HandPassing: '% Передачи рукой',
    Catching: '% Ловля',
    Caught: 'Пойманные сейвы',
    ClaimAccuracy: 'Точность перехвата',
    HighTurnovers: 'Высокие потери',
    ShotEndingHighTurnovers: 'Удар после высоких потерь',
    GoalEndingHighTurnovers: 'Гол после высоких потерь',
    AverageCarriesProgress: 'Средняя прогрессия ведений',
    ChanceEndingCarries: 'Момент после ведений',
    AssistEndingCarries: 'Передача после ведений',
    ShotEndingCarries: 'Удар после ведений',
    GoalEndingCarries: 'Гол после ведений',
    ShotEndingSequence: 'Удар после последовательности',
    GoalEndingSequence: 'Гол после последовательности',
    xGPerNPG: 'xG за NPG',
    AerialWonOffensive: 'Выигранные верховые атакующие',
    AerialWonDefensive: 'Выигранные верховые защитные',
    xGAgainst: 'Пропущенные xG',
    xGDiffAgainst: 'Разница xG пропущено',
    xGPerNPGAgainst: 'xG за NPG пропущено',
    xGSetPieceAgainst: 'xG Стандарт пропущено',
    xGOpenPlayAgainst: 'xG Игра в открытую пропущено',
    xGPerShotAgainst: 'xG за удар пропущено',
    ShotsAgainst: 'Пропущенные удары',
    ShotsOnTargetAgainst: 'Пропущенные удары в створ',
    ShotsOnTargetInBoxAgainst: 'Удары в створ в пропущенной штрафной площади',
    ShotsOnTargetOutBoxAgainst: 'Удары в створ ворот вне штрафной площади пропущены',
    RivalPossession: 'Владение соперника',
    AerialDefensivePct: '% Верховые защитные',
    HighRecoveries: 'Высокие подборы',
    HighDefensiveActions: 'Высокие защитные действия',
    HighDefensiveActionPct: '% Высокие защитные действия',
    HighDefensiveDistance: 'Высокая защитная дистанция',
    PassesPerPossession: 'Передачи за владение',
    LengthPerPossession: 'Дистанция за владение',
    xTNet: 'Чистый xT',
    AvgCarriesDistance: 'Средняя дистанция ведений',
    PassesForwardPct: '% Передачи вперед',
    PassesForwardSuccessful: 'Успешные пасы вперед',
    PassesForwardTotal: 'Всего передач вперед',
    TacklesAttempted: 'Попытки отборов',
    DuelsLost: 'Проигранные единоборства',
    Carries: 'Ведения',
    CarriesPct: '% Ведения',
    Aerials: 'Верховые единоборства',
    ProgressivePassesReceivedIntoBox: 'Полученные прогрессивные передачи в штрафную',
    PassesOppHalf: 'Передачи половина соперника',
    ShotsOnTarget: 'Удары в створ',
    AggressiveActions: 'Агрессивные действия',
    Crosses: 'Навесы',
    xGBuildup5pass: 'xG Построение 5 передач',
    SpeedSequence: 'Скорость последовательности',
    Touches: 'Касания',
    AerialsTotalOppHalf: 'Всего верховых половина соперника',
    AerialsWonOppHalf: 'Воздушные соревнования выиграли Opp. Половина',
    AerialsWonOppHalfPct: '% Выигранных верховых половина соперника',
    AerialsPctOppBox: '% Выигранных верховых штрафная соперника',
    AerialsPctOwnBox: '% Выигранных верховых своя штрафная',
    AerialDefensive: 'Верховые защитные',
    AerialOffensive: 'Верховые атакующие',
    AerialOffensivePct: '% Верховые атакующие',
    IndividualPressureOppHalf: 'Индивидуальное давление половина соперника',
    ChancesCreatedOP: 'Созданные моменты игра в открытую',
    TouchesPerShot: 'Касания за удар',
    PassesFinalThirdTotalPct: '% Передачи финальная треть',
    xACrosses: 'xA с навесов',
    Passes: 'Передачи',
    PassesSuccessful: 'Успешные передачи',
    TacklesWasDribbledFouls: '% Наземные единоборства',
    OffsidesCaught: 'Пойманные офсайды',
    ProgressivePassesReceivedFinalThird: 'Полученные прогрессивные передачи финальная треть',
    ProgressivePassesReceived: 'Полученные прогрессивные передачи',
    Breadth: 'Ширина',
    DuelsDefTotal: 'Защитные единоборства',
    DefensiveActions: 'Защитные действия',
    ProgressivePassesReceivedOppHalf: 'Полученные прог. передачи половина соперника',
    CompletedCrossesOP: 'Выполненные навесы игра в открытую',
    CrossingOP: '% Навесы игра в открытую',
    CrossesOP: 'Тотал кроссов в открытой игре',
    PassingContribution: '% Вклад передач',
    BallProgressionOppHalfInTeam: '% Прогрессия мяча половина соперника в команде',
    PassesOPIntoBoxInTeam: '% Передачи игра в открытую в штрафную в команде',
    TouchesOppBoxInTeam: '% Касания штрафная соперника в команде',
    xGOPInTeam: '% xG Игра в открытую в команде',
    DeepPasses: 'Глубокие передачи',
    DeepPassesTotal: 'Глубокие пасы',
    DefensiveDuelsPct: '% Защитные единоборства',
    DefensiveDistance: 'Защитная дистанция',
    QuickRecoveriesPct: '% Быстрые подборы',
    DiffDefensiveDistanceTeam: 'Разница защитной дистанции команды',
    xTPassing: 'xT Передачи',
    xTPassing100Passes: 'xT Передачи 100 передач',
    ProgressivePassesAccurate: 'Прогрессивные передачи',
    PassAbility: 'Способность к передачам',
    OPPassesIntoOppBoxPct: '% Передачи игра в открытую в штрафную соперника',
    EntriesOppBox: 'Входы в штрафную соперника',
    Crosses6yardBox: 'Навесы в шестиметровую',
    Cutbacks: 'Откаты',
    xTDribbling: 'xT Дриблинг',
    AvgShotDistance: 'Средняя дистанция удара',
    xGOnTarget: 'xG в створ',
    FinishingxGOT: 'Завершение xG в створ',
    DribblesWonOwnHalf: 'Выполненные дриблинги своя половина',
    DribblesOwnHalf: 'Дриблинги своя половина',
    DribblesOwnHalfPct: '% Дриблинги своя половина',
    DribblesWonOppHalf: 'Выполненные дриблинги половина соперника',
    DribblesOppHalf: 'Дриблинги половина соперника',
    DribblesOppHalfPct: '% Дриблинги половина соперника',
    DribblesWonFinalThird: 'Выполненные дриблинги финальная треть',
    DribblesFinalThird: 'Дриблинги финальная треть',
    DribblesFinalThirdPct: '% Дриблинги финальная треть',
    ShotEndingHighRecoveries: 'Удар после высоких подборов',
    PassingFinalThirdAgainst: 'Передачи финальная треть пропущено',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Всего ОП передач в штрафную пропущено',
    EntriesOppBoxAgainst: 'Входы в штрафную соперника пропущено',
    DeepProgressionAgainst: 'Глубокая прогрессия пропущено',
    TouchesInOpponentBoxAgainst: 'Касания в штрафной соперника пропущено',
    Score: 'Оценка',
    PDScore: 'Физическая оценка',
    OrlegiScore: 'Оценка Orlegi',
    SirScore: 'Оценка Sirius',
    ExcScore: 'Оценка Excelsior',
    xTOPInTeam: 'xT ОП в команде',
    YellowCards: 'Желтые карточки',
    RedCards: 'Красные карточки',
    xTOpenPlayAgainst: 'xT Игра в открытую пропущено',
    xTSetPieceAgainst: 'xT Стандарт пропущено',
    NPGOpenPlayAgainst: 'NPG Игра в открытую пропущено',
    NPGSetPieceAgainst: 'NPG Стандарт пропущено',
    PassesOppHalfPerPossession: 'Передачи половина соперника за владение',
    AverageTimeRecovery: 'Среднее время восстановления',
    ExpectedPassing: '% Ожидаемые передачи',
    NumPossession10Passes: 'Владения 10 передач',
    PassesReceived: 'Полученные передачи',
    PassesReceivedFinalThird: 'Полученные передачи финальная треть',
    ProgressivePassesTotalPct: '% Прогрессивные передачи',
    ShortPassesPct: '% Короткие передачи',
    TouchesOppBoxOppTeam: 'Касания штрафная соперника соперник команда',
    ShotsOnTargetOppTeam: 'Удары в створ соперник команда',
    NPGOppTeam: 'NPG соперник команда',
    ShotsOpenPlay: 'Удары игра в открытую',
    xGSetPiecePerxG: 'xG Стандарт за xG',
    ShotsOpenPlayAgainst: 'Удары игра в открытую пропущено',
    ShotsFromDribble: 'Удары после Обводки',
    GoalsFromDribble: 'Голы после Обводки',
    PassesIntoFinalThird: 'Передачи в Финальную Треть',
    PassesIntoFinalThirdTotal: 'Общее количество передач в финальную треть',
    PassesInsideFinalThird: 'Передачи внутри Финальной Трети',
    PassesInsideFinalThirdTotal: 'Общее количество передач в финале ⅓',
    PassesFinalThirdNoArea: 'Проходит последнюю треть (без коробки)',
    PassesIntoOppBox: 'Передачи в Штрафную Соперника',
    CarriesFinalThird: 'Продвижения в Финальную Треть',
    CarriesInsideFinalThird: 'Продвижения внутри Финальной Трети',
    CarriesFinalThirdNoBox: 'Переносит последнюю треть (без коробки)',
    CarriesIntoOppBox: 'Продвижения в Штрафную Соперника',
    TimePossessionAgainst: 'Владение Мячом Соперника',
    TimePossessionTotal: 'Общее Владение Мячом',
    PassesInBox: 'Передачи в Своей Штрафной',
    LongThrowInSuccessful: 'Успешные Дальние Вбрасывания',
    LongThrowInTotal: 'Общее Количество Дальних Вбрасываний',
    LongThrowInPct: '% Успешных Дальних Вбрасываний',
    Games: 'Сыгранные игры',
    PointsPerGame: 'Очки за игру',
    ExpectedPointsDiff: 'Ожидаемая разница в очках',
    PassesTotalOwnHalf: 'Тотал пасов на свою половину',
    PassesOwnHalf: 'Проходит свою половину',
    PassesTotalOppHalf: 'Проходит половину OPP',
    ProgressivePassesTotal: 'Всего прогрессивных передач',
    DuelsWon: 'Дуэли выиграны',
    NonPenaltySaves: 'Сейвы без штрафов',
    BadActionsOppHalf: 'Плохие действия OPP Half',
    CarriesSuccessful: 'несет успешный',
    ShotsOnTargetOutBox: 'Удары в створ из штрафной',
    TotalDistance: 'Общая дистанция',
    DistanceTIP: 'Дистанция TIP',
    DistanceOTIP: 'Дистанция OTIP',
    SprintsNumber: 'Количество спринтов',
    SprintsDistance: 'Дистанция спринтов',
    WalkingDistance: 'Дистанция ходьбы',
    JoggingDistance: 'Дистанция бега трусцой',
    RunningDistance: 'Дистанция бега',
    ExtremeAccelerations: 'Экстремальные ускорения',
    NumberOfRuns: 'Количество пробежек',
    HsrNumber: 'Количество HSR',
    HsrDistance: 'Дистанция HSR',
    SprintNumberDeclinePct: '% Снижение количества спринтов',
    SprintDistanceDeclinePct: '% Снижение дистанции спринтов',
    SprintNumberDecline: 'Снижение количества спринтов',
    SprintDistanceDecline: 'Снижение дистанции спринтов',
    HsrDistancePct: '% Дистанция HSR',
    SprintDistancePct: '% Дистанция спринтов',
    Accelerations: 'Ускорения',
    ExplosiveDistance: 'Взрывная дистанция',
    MaxSpeed: 'Макс. скорость',
    AvgMaxSpeed: 'Средняя макс. скорость',
    MaxAccelerations: 'Макс. ускорения',
    BypassedPlayersByPasses: 'Обойденные игроки передачами',
    BypassedDefendersByPasses: 'Обойденные защитники передачами',
    PassesBypassingPlayers: 'Передачи, обходящие игроков',
    PassesBypassingDefenders: 'Передачи, обходящие защитников',
    BypassedPlayersPerPass: 'Обойденные игроки за передачу',
    BypassedDefendersPerPass: 'Обойденные защитники за передачу',
    LineBreakingPasses: 'Передачи, прорывающие линии',
    LineBreakingPassesMD: 'Передачи, прорывающие линии ПЗ-З',
    LineBreakingPassesM: 'Передачи, прорывающие линии ПЗ',
    LineBreakingThroughBalls: 'Сквозные передачи, прорывающие линии',
    LineBreakingPassesPerPass: '% Передач, прорывающих линии за передачу',
    TotalPassesUnderStrongPressure: 'Всего передач под сильным давлением',
    TotalPassesUnderLightPressure: 'Всего передач под давлением',
    SuccessfulPassesUnderStrongPressure: 'Успешные передачи под сильным давлением',
    SuccessfulPassesUnderLightPressure: 'Успешные передачи под давлением',
    PassingUnderStrongPressure: '% Передачи под сильным давлением',
    PassingUnderLightPressure: '% Передачи под давлением',
    PassReceiptsInSpaceCompleted: 'Выполненные передачи в пространство',
    PassReceiptsInSpace: 'Передачи в пространство',
    PassReceiptsInSpaceCompletedFirstThird: 'Приёмы в Пространстве - Первая Треть',
    PassReceiptsInSpaceCompletedSecondThird: 'Приёмы в Пространстве - Вторая Треть',
    PassReceiptsInSpaceCompletedFinalThird: 'Приёмы в Пространстве - Финальная Треть',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Приёмы в Пространстве - Правый Фланг Соперника',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Приёмы в Пространстве - Центр Соперника',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Приёмы в Пространстве - Левый Фланг Соперника',
    PassReceiptsInSpaceFirstThird: 'Приёмы в Пространстве в Первой Трети',
    PassReceiptsInSpaceSecondThird: 'Приёмы в Пространстве во Второй Трети',
    PassReceiptsInSpaceFinalThird: 'Приёмы в Пространстве в Финальной Трети',
    PassReceiptsInSpaceOppHalfRight: 'Приёмы в Пространстве на Правом Фланге Соперника',
    PassReceiptsInSpaceOppHalfCenter: 'Приёмы в Пространстве в Центре Соперника',
    PassReceiptsInSpaceOppHalfLeft: 'Приёмы в Пространстве на Левом Фланге Соперника',
    TotalStrongOnBallPressures: 'Всего сильных давлений на мяч',
    TotalLightOnBallPressures: 'Всего давлений на мяч',
    SuccessfulStrongOnBallPressures: 'Успешные сильные давления на мяч',
    SuccessfulLightOnBallPressures: 'Успешные давления на мяч',
    StrongOnBallPressuresPct: '% Сильные давления на мяч',
    LightOnBallPressuresPct: '% Давления на мяч',
    TimesBypassedByPasses: 'Раз обойден передачами',
    TimesBypassedByCarries: 'Раз обойден ведениями',
    TimesBypassedByActions: 'Раз обойден действиями',
    BypassedPlayersByCarries: 'Обойденные игроки ведениями',
    BypassedDefendersByCarries: 'Обойденные защитники ведениями',
    BypassedPlayersByActions: 'Обойденные игроки действиями',
    BypassedDefendersByActions: 'Обойденные защитники действиями',
    CarriesBypassingPlayers: 'Ведения, обходящие игроков',
    CarriesBypassingDefenders: 'Ведения, обходящие защитников',
    BypassedPlayersPerCarry: 'Обойденные игроки за ведение',
    BypassedDefendersPerCarry: 'Обойденные защитники за ведение',
    LineBreakingCarries: 'Ведения, прорывающие линии',
    LineBreakingCarriesMD: 'Ведения, прорывающие линии ПЗ-З',
    LineBreakingCarriesM: 'Ведения, прорывающие линии ПЗ',
    LineBreakingCarriesD: 'Ведения, прорывающие линии З',
    LineBreakingCarriesPerCarry: '% Ведений, прорывающих линии за ведение',
    LineBreakingActions: 'Действия, прорывающие линии',
    LineBreakingActionsMD: 'Действия, прорывающие линии ПЗ-З',
    LineBreakingActionsM: 'Действия, прорывающие линии ПЗ',
    LineBreakingActionsD: 'Действия, прорывающие линии З',
    PassesPerLineBreakingPass: 'Передачи за передачу, прорывающую линии',
    CarriesPerLineBreakingCarry: 'Ведения за ведение, прорывающее линии',
    LinesBrokenByPasses: 'Линии прорваны передачами',
    LinesBrokenByCarries: 'Линии прорваны ведениями',
    LinesBrokenByActions: 'Линии прорваны действиями',
    LinesBrokenPerPass: 'Линии прорваны за передачу',
    LinesBrokenPerCarry: 'Линии прорваны за ведение',
    AvgLastDefenderDistanceIP: 'Дистанция последнего защитника ВВ',
    AvgLastDefenderDistanceOOP: 'Дистанция последнего защитника БВ',
    AvgDefensiveLineDistanceIP: 'Дистанция защитной линии ВВ',
    AvgDefensiveLineDistanceOOP: 'Дистанция защитной линии БВ',
    AvgRBDistanceIP: 'Дистанция правого защитника ВВ',
    AvgRBDistanceOOP: 'Дистанция правого защитника БВ',
    AvgLBDistanceIP: 'Дистанция левого защитника ВВ',
    AvgLBDistanceOOP: 'Дистанция левого защитника БВ',
    AvgBlockDistanceIP: 'Дистанция блока ВВ',
    AvgBlockDistanceOOP: 'Дистанция блока БВ',
    AvgBlockAreaIP: 'Площадь блока ВВ',
    AvgBlockAreaOOP: 'Площадь блока БВ',
    AvgDefensiveLineWidthOOP: 'Ширина защитной линии БВ',
    AvgOffensiveLineLastThirdWidthIP: 'Ширина атакующей линии финальная треть ВВ',
    AvgLByIP: 'Позиция левого защитника ВВ',
    AvgRByIP: 'Позиция правого защитника ВВ',
    AvgOffensiveLineDistanceIP: 'Дистанция атакующей линии ВВ',
    AvgOffensiveLineLastThirdDistanceIP: 'Дистанция атакующей линии финальная треть ВВ',
    AvgOffensiveLineWidthIP: 'Ширина атакующей линии ВВ',
    OffBallRuns: 'Всего безмячевых пробежек',
    OffBallRunsOverlap: 'Безмячевые пробежки оверлап',
    OffBallRunsUnderlap: 'Безмячевые пробежки андерлап',
    OffBallRunsRunAhead: 'Безмячевые пробежки вперед',
    OffBallRunsRunBehind: 'Безмячевые пробежки за спину',
    OffBallRunsCrossReceiver: 'Безмячевые пробежки на навес',
    OffBallRunsSupport: 'Безмячевые пробежки поддержка',
    OffBallRunsComingShort: 'Безмячевые пробежки на короткую',
    description: {
      Possession: 'Процент владения мячом команды',
      TimePossession: 'Время владения мячом команды',
      PassesPerShots: 'Среднее количество передач за удар',
      PPDA: 'Пропущенные передачи на защитное действие. PPDA измеряет давление, которое команда оказывает на игроков соперника, когда они владеют мячом. Значение соответствует среднему количеству передач подряд, которые соперник смог выполнить до прерывания. Чем выше значение, тем больше передач было позволено выполнить сопернику',
      Directness: 'Измеряет прямолинейность команды. Высокое значение прямолинейности связано с большим количеством передач вперед по отношению к передачам в стороны',
      ExpectedPoints: 'Количество ожидаемых очков команды, рассчитанное на основе созданных и пропущенных ожидаемых голов. Эта метрика позволяет лучше оценить производительность команды во время матча (или серии матчей) по сравнению с фактически достигнутым количеством очков',
      PassesPerLongBall: 'Процент успешных длинных передач от общего количества выполненных передач',
      CrossingPerXG: 'Процент ожидаемых голов, пришедших с навесов',
      PenaltySavedPenaltyFaced: 'Процент отраженных ударов с пенальти от всех полученных ударов с пенальти',
      Goals: 'Количество забитых голов',
      PenaltyShots: 'Общее количество ударов с пенальти',
      PenaltyGoals: 'Общее количество голов с пенальти',
      NonPenaltyGoals: 'Количество забитых голов, исключая голы с пенальти',
      NPGOpenPlay: 'Количество забитых голов действиями в открытую, исключая голы с пенальти',
      NPGSetPiece: 'Количество забитых голов со стандартов, исключая голы с пенальти',
      Shooting: 'Процент ударов в створ',
      Finishing: 'Процент ударов, заканчивающихся голом',
      xGEfficiency: 'Количество ожидаемых голов, необходимое игроку для забития гола',
      HeaderPerShot: 'Количество ударов головой',
      HeaderPerCross: 'Процент навесов, отбитых головой игроком, от общего количества выполненных навесов командой',
      Assists: 'Количество передач',
      ThroughBalls: 'Количество сквозных передач для игрока, делающего атакующий рывок для создания момента на гол',
      CrossEfficiency: 'Метрика, которая объединяет процент успешных навесов вместе с объемом выполненных успешных навесов',
      ScoringContribution: 'Количество передач и голов',
      xAssistsOpenPlay: 'Количество ожидаемых передач, созданных в открытую',
      xAssistsSetPiece: 'Количество ожидаемых передач, созданных со стандартов',
      xAssistsOpenPlayInTeam: 'Количество ожидаемых передач, созданных в открытую в команде',
      xAssistsSetPieceInTeam: 'Количество ожидаемых передач, созданных со стандартов в команде',
      xGChainFinalThird: 'Количество xG, в котором участвовал игрок в финальной трети',
      xGBuildupFinalThird: 'Количество xG, в котором участвовал игрок в финальной трети (исключая удары и передачи, ведущие к удару)',
      BallProgressionPassing: 'Количество раз, когда игрок продвигает мяч на 10 метров или более передачей',
      BallProgressionDribbling: 'Количество раз, когда игрок продвигает мяч на 10 метров или более ведением',
      TacklesWasDribbled: 'Метрика, которая учитывает процент раз, когда игрок восстанавливает мяч через отбор против раз, когда он был передан/обыгран. Чем выше показатель, тем лучше',
      TacklesSuccessful: 'Количество успешных отборов, сделанных игроком',
      Interceptions: 'Количество раз, когда игрок перехватывает передачу, чтобы предотвратить попадание мяча в цель',
      Clearances: 'Количество раз, когда игрок выносит мяч из защитной зоны',
      Fouls: 'Количество фолов, совершенных игроком',
      Recoveries: 'Количество мячей, восстановленных игроком',
      Shots: 'Количество всего ударов',
      ShotsPerGoal: 'Удары в створ, необходимые для забития гола без пенальти вратарю',
      ShortPassesSuccessful: 'Короткие передачи (менее 12 метров), выполненные',
      PassingSuccessForwardPct: 'Процент успешных передач в направлении вперед',
      PassingSuccessBackwardPct: 'Процент успешных передач назад',
      PassingForwardBackwardPct: 'Соотношение передач вперед к передачам назад',
      LongBallPerPassesPct: 'Процент выполненных длинных передач (>32 метра) от всех выполненных передач игроком.',
      LongBallReceived: 'Длинные передачи (>32 метра), полученные игроком',
      LongBallReceivedOppHalf: 'Длинные передачи (>32 метра), полученные игроком в половине соперника',
      OffensiveActions: 'Атакующие действия',
      DribblesAttempted: 'Попытки дриблинга',
      SuccessfulDribblesPct: 'Успешные дриблинги/всего попыток дриблинга',
      OffensiveTouchesOutBoxPct: '% Атакующие касания вне штрафной',
      BallRetention: 'Процент времени, когда у вас есть владение мячом и вы не теряете его',
      PassingPct: 'Процент выполненных передач от всех переданных игроком',
      PassingOwnHalfPct: 'Процент выполненных передач от всех переданных игроком (только передачи в своей половине)',
      PassingOppHalfPct: 'Процент выполненных передач от всех переданных игроком (только передачи в половину соперника)',
      PassingFinalThird: 'Успешные передачи в финальную треть',
      PassesFinalThirdTotal: 'Общее количество попыток передач, исключая навесы, стандартные положения, угловые и вбрасывания, которые заканчиваются в последней трети',
      PassingFinalThirdPct: 'Процент выполненных передач от всех переданных игроком (только передачи в финальную треть)',
      LongBallSuccessful: 'Выполненные передачи более 32 метров',
      LongBallPct: 'Выполненные передачи более 32 метров/ Всего попыток передач более 32 метров.',
      LongBallTotal: 'Общее количество проходов более 32 метров',
      SavesPct: 'Процент отражений от общего количества пропущенных ударов',
      SavesInBoxPct: 'Процент отраженных ударов, пришедших из штрафной',
      SavesOutOfBoxPct: 'Процент отраженных ударов, пришедших из-за пределов штрафной',
      xGSavedPerXGFacedOnTarget: 'Коэффициент, который указывает процент ожидаемого xG, который отражен вратарем. Значение 1 в этой метрике означало бы, что вратарь отражает все ожидаемые голы ударов, пропущенных командой, в то время как значение 0 означало бы, что все ожидаемые голы, созданные соперником, заканчиваются голом',
      xGFacedOnTargetPerGoalReceived: 'Метрика, которая указывает, сколько ожидаемых голов необходимо для забития гола определенному вратарю. Высокий балл в этой метрике означает, что для забития гола этому вратарю необходимо создать большое количество xG',
      xGFacedOnTargetEfficiency: 'Количество предотвращенных голов без пенальти вратарем. Это количество ожидаемых голов в створ, полученных вратарем, минус количество (не пенальти) пропущенных голов. Указывает количество голов, которые не были забиты соперником благодаря вратарю',
      xGFacedOnTarget: 'Всего xG (отражено и забито), полученного вратарем',
      IndividualPressure: 'Метрика, которая измеряет количество успешных усилий (восстановленных владений), сделанных игроком при прессинге соперника',
      AerialEfficiency: 'Метрика, которая объединяет процент успешных верховых единоборств вместе с объемом выигранных верховых единоборств',
      AerialWins: 'Количество верховых единоборств, выигранных игроком',
      AerialWinsPct: 'Количество верховых единоборств, выигранных игроком, от общего количества верховых единоборств, в которых участвовал игрок',
      xG: 'Ожидаемые голы, созданные. Эта метрика измеряет вероятность удара закончиться голом на основе различных переменных (дистанция, угол, тип игры, часть тела, ...) такого действия.',
      xGDiff: 'Разница между xG и голами',
      xGOpenPlay: 'Ожидаемые голы, созданные в открытую',
      xGSetPiece: 'Ожидаемые голы, созданные со стандартов',
      xGPerShot: 'Средний xG ударов, сделанных игроком. Эта метрика измеряет среднюю опасность сделанных ударов. Чем выше, тем более вероятно, что ваши удары закончатся голом. Высокий xG за удар означает, что игрок хорошо выбирает свои удары.',
      ChancesCreated: 'Количество передач, ведущих к удару',
      CompletedCrosses: 'Количество выполненных навесов',
      Crossing: 'Процент навесов, которые были выполнены от попыток навесов',
      OpenPlayKeyPasses: 'Количество передач, выполненных во время игры в открытую',
      OpenPlayKeyPassesInTeam: 'Процент передач, выполненных во время игры в открытую в команде',
      OpenPlayPassesIntoOpponentBox: 'Общее количество попыток передач в штрафную соперника во время игры в открытую',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Количество выполненных передач в штрафную соперника во время игры в открытую',
      xAssists: 'Метрика, которая анализирует качество созданных моментов, происходящих в матче. Каждая передача перед ударом имеет значение на основе вероятности того, что удар закончится голом. Это значение присваивается в соответствии с местом передачи, типом (навес, сквозная передача, стандарт…), состоянием игры и т.д. В отличие от xG, xA - это метрика, которая в идеале должна быть у игрока выше, чем его количество передач, поскольку создатель может контролировать только качество своих передач (xA), тогда как его количество передач зависит от завершающего',
      xGChain: 'Количество xG, в котором участвовал игрок',
      xGBuildup: 'Похоже на xG Chain, но не учитывает последних 2 игроков последовательности (исключая удары и передачи, ведущие к удару)',
      xGBuildupInTeam: 'Похоже на xG Chain, но не учитывает последних 2 игроков последовательности (исключая удары и передачи, ведущие к удару) в команде',
      BallProgression: 'Количество раз, когда игрок продвигается на 10 или более метров либо передачей, либо ведением мяча, либо комбинацией обоих',
      SuccessfulDribbles: 'Успешно выполненные дриблинги',
      Dispossessed: 'Количество раз, когда игрок был отобран и потерял владение мячом',
      TouchesInOpponentBox: 'Количество раз, когда владение мячом находится в штрафной соперника',
      xGSavedPerShot: 'Средняя вероятность гола пропущенных ударов в створ',
      BallRetentionOppHalf: 'Процент времени, когда у вас есть владение мячом и вы не теряете его в половине соперника',
      DeepProgression: 'Количество раз, когда последняя пятая поля достигается ведением мяча, плюс количество раз, когда владение мячом находится в последней пятой',
      DeepProgressionFinalThird: 'Количество раз, когда финальная треть поля достигается ведением мяча, плюс количество раз, когда владение мячом находится в финальной трети',
      FoulsTaken: 'Количество раз, когда игрок был сфолен',
      PenaltiesTaken: 'Количество раз, когда игрок был сфолен в штрафной соперника',
      BlockedCrosses: 'Заблокированные навесы',
      BlockedShots: 'Заблокированные удары',
      NonPenaltyGoalsAgainst: 'Количество пропущенных голов без пенальти',
      GoalsConceded: 'Количество пропущенных голов',
      Headers: 'Количество ударов, сделанных головой',
      HeadedGoals: 'Количество голов, забитых головой',
      Points: 'Количество очков, набранных командой',
      SavesInBox: 'Количество сейвов от бросков внутри штрафной',
      SavesOutBox: 'Количество сейвов от бросков из-за пределов штрафной',
      ShotsOnTargetInBoxAgainst: 'Количество пропущенных ударов в створ из штрафной',
      ShotsOnTargetOutBoxAgainst: 'Количество пропущенных ударов в створ из-за пределов штрафной',
      AveragePassDistance: 'Средняя дистанция передач в метрах',
      ProgressiveRuns: 'Успешные ведения, которые приближают владение на 20% ближе к воротам соперника',
      xT: 'Ожидаемая угроза (xT) - это метрика, которая измеряет угрозу, которую игрок создает сопернику, ведя или передавая мяч в области, где вероятность владения закончиться голом выше.',
      xTOpenPlay: 'Ожидаемая угроза, созданная во время игры в открытую',
      xTSetPiece: 'Ожидаемая угроза, созданная со стандартов',
      xGOT: 'Ожидаемые голы в створ. Количество ожидаемых голов, полученных вратарем. Эта метрика учитывает только удары в створ (Пропущенные удары и удары в штангу исключены)',
      BadActions: 'Сумма всех плохих действий (неудачная передача, неудачный дриблинг, потеря владения, офсайдная передача, неудачное касание мяча)',
      BadActionsOwnHalf: 'Сумма всех плохих действий (неудачная передача, неудачный дриблинг, потеря владения, офсайдная передача, неудачное касание мяча) в своей половине',
      AerialsWonOwnBox: 'Выигранные верховые единоборства своя штрафная',
      AerialsWonOppBox: 'Выигранные верховые единоборства штрафная соперника',
      AerialsTotalOppBox: 'Всего верховых единоборств штрафная соперника',
      AerialsTotalOwnBox: 'Всего верховых единоборств своя штрафная',
      FoulsOwnHalfPct: 'Процент фолов, совершенных в своей половине',
      RecoveriesOppHalf: 'Количество мячей, восстановленных игроком в половине соперника',
      DuelsPct: 'Процент успешных единоборств',
      TacklesUnsuccessful: 'Количество раз, когда игрок не смог выиграть мяч, когда соперник успешно обыграл его',
      TacklesWasDribbledFirstThird: 'Процент раз, когда игрок восстанавливает мяч при столкновении в финальной трети',
      TacklesWasDribbledSecondThird: 'Выигранные оборонительные единоборства 1 в 1 ⅔',
      TacklesWasDribbledFinalThird: 'Выигранные оборонительные единоборства 1 в 1 ⅓',
      BallProgressionFinalThird: 'Прогрессия мяча финальная треть',
      DuelsTotal: 'Общее количество отборов, верховых единоборств, касаний мяча, дриблингов и фолов, совершенных',
      QuickRecoveries: 'Подборы на 40 метров или более от своих ворот, сделанные через 8 секунд после потери владения мячом',
      ShotsPerNPG: 'Среднее количество ударов для забития гола без пенальти',
      ShotsOutBox: 'Количество ударов из-за пределов штрафной',
      GoalsOutBox: 'Количество голов из-за пределов штрафной',
      ShootingOutBox: 'Процент ударов в створ из-за пределов штрафной',
      HandPassing: 'Точность передач руками',
      Catching: 'Процент отражений, в которых вратарь ловит мяч',
      Caught: 'Сейв в момент, когда вратарь ловит и удерживает мяч, предотвращая повторную игру.',
      ClaimAccuracy: 'Измеряет, насколько хорош вратарь в ловле/блокировке верховых мячей. Число выше 1 указывает, что вратарь ловит больше верховых мячей, чем ожидалось',
      HighTurnovers: 'Потери ближе 40 метров от своих ворот',
      ShotEndingHighTurnovers: 'Высокие потери (потери ближе 40 метров от своих ворот), заканчивающиеся ударом команды соперника',
      GoalEndingHighTurnovers: 'Высокие потери (потери ближе 40 метров от своих ворот), заканчивающиеся голом команды соперника',
      AverageCarriesProgress: 'Средняя дистанция, на которую игрок перемещает мяч вертикально за ведение (метры)',
      ChanceEndingCarries: 'Ведения не менее 7 метров, заканчивающиеся передачей, за которой следует удар',
      AssistEndingCarries: 'Ведения не менее 7 метров, заканчивающиеся передачей, за которой следует гол',
      ShotEndingCarries: 'Ведения не менее 7 метров, заканчивающиеся ударом',
      GoalEndingCarries: 'Ведения не менее 7 метров, заканчивающиеся голом',
      ShotEndingSequence: 'Количество последовательностей, заканчивающихся ударом, где участвовал игрок',
      GoalEndingSequence: 'Количество последовательностей, заканчивающихся голом, где участвовал игрок',
      xGPerNPG: 'Ожидаемые голы, необходимые для забития гола без пенальти',
      AerialWonOffensive: 'Выигранные верховые единоборства атакующие',
      AerialWonDefensive: 'Выигранные верховые единоборства защитные',
      xGAgainst: 'Пропущенные ожидаемые голы',
      xGDiffAgainst: 'Разница между пропущенными ожидаемыми голами и пропущенными голами',
      xGPerNPGAgainst: 'Ожидаемые голы, полученные за пропущенный гол без пенальти',
      xGSetPieceAgainst: 'Ожидаемые голы, созданные со стандартов пропущено',
      xGOpenPlayAgainst: 'Ожидаемые голы, созданные в открытую пропущено',
      xGPerShotAgainst: 'Ожидаемые голы, полученные за пропущенный удар',
      ShotsAgainst: 'Количество пропущенных ударов',
      ShotsOnTargetAgainst: 'Количество пропущенных ударов в створ',
      RivalPossession: 'Владение соперника',
      AerialDefensivePct: 'Процент выигранных верховых единоборств без владения мячом',
      HighRecoveries: 'Подборы, сделанные на 40 метров или ближе к воротам соперника',
      HighDefensiveActions: 'Защитные действия (Отборы, Перехваты, Блоки, Фолы и 1vs1), сделанные на 40 метров над собственной линией ворот',
      HighDefensiveActionPct: 'Процент защитных действий (Отборы, Перехваты, Блоки, Фолы и 1vs1), сделанных на 40 метров над собственной линией ворот',
      HighDefensiveDistance: 'Средняя дистанция от своих ворот всех защитных действий',
      PassesPerPossession: 'Количество передач за владение',
      LengthPerPossession: 'Дистанция за владение',
      xTNet: 'Чистый xT',
      AvgCarriesDistance: 'Средняя дистанция ведений',
      PassesForwardPct: '% Передачи вперед',
      PassesForwardSuccessful: 'Успешные пасы вперед',
      PassesForwardTotal: 'Всего передач вперед',
      TacklesAttempted: 'Попытки отборов',
      DuelsLost: 'Проигранные единоборства',
      Carries: 'Ведения',
      CarriesPct: '% Ведения',
      Aerials: 'Общее количество верховых единоборств',
      ProgressivePassesReceivedIntoBox: 'Полученные прогрессивные передачи в штрафную',
      PassesOppHalf: 'Успешные передачи, заканчивающиеся в половине соперника',
      ShotsOnTarget: 'Удары в створ',
      AggressiveActions: 'Количество попыток отборов в следующие две секунды после потери владения',
      Crosses: 'Общее количество навесов',
      xGBuildup5pass: 'Количество xG, в котором участвовал игрок, только последние 5 передач (исключая удары и передачи, ведущие к удару)',
      DefensiveDistance: 'Средняя дистанция до своих ворот защитных единоборств',
      SpeedSequence: 'Средняя скорость (метры, пройденные за время) всех владений команды',
      Touches: 'Количество раз, когда игрок владеет мячом',
      AerialsTotalOppHalf: 'Всего верховых единоборств в половине соперника',
      AerialsWonOppHalf: 'Воздушные дуэли успешны на половине поля противника.',
      AerialsWonOppHalfPct: 'Процент выигранных верховых единоборств в половине соперника',
      AerialsPctOppBox: 'Процент выигранных верховых единоборств в штрафной соперника',
      AerialsPctOwnBox: 'Процент выигранных верховых единоборств в своей штрафной',
      AerialDefensive: 'Общее количество верховых единоборств, когда команда соперника владеет мячом',
      AerialOffensive: 'Общее количество верховых единоборств, когда своя команда владеет мячом',
      AerialOffensivePct: 'Процент выигранных верховых единоборств, когда своя команда владеет мячом',
      IndividualPressureOppHalf: 'Метрика, которая измеряет количество успешных усилий (восстановленных владений), сделанных игроком при прессинге соперника в половине соперника',
      ChancesCreatedOP: 'Количество передач, ведущих к удару во время игры в открытую',
      TouchesPerShot: 'Количество раз, когда игроки касаются мяча за удар',
      PassesFinalThirdTotalPct: 'Процент передач (успешных и неуспешных) в финальную треть',
      xACrosses: 'Ожидаемые передачи, созданные с навесов',
      Passes: 'Общее количество передач',
      PassesSuccessful: 'Количество выполненных передач',
      TacklesWasDribbledFouls: 'Процент выигранных отборов по отношению к общему количеству отборов и совершенных фолов',
      OffsidesCaught: 'Пойманные офсайды',
      ProgressivePassesReceivedFinalThird: 'Полученные прогрессивные передачи финальная треть',
      ProgressivePassesReceived: 'Полученные прогрессивные передачи',
      Breadth: 'Сумма отборов, вызовов, перехватов и совершенных фолов на флангах поля',
      DuelsDefTotal: 'Сумма всех отборов, защитных верховых единоборств и совершенных фолов',
      DefensiveActions: 'Защитные действия, когда соперник пытается обыграть (Отборы, Вызовы и Фолы)',
      ProgressivePassesReceivedOppHalf: 'Полученные прогрессивные передачи половина соперника',
      CompletedCrossesOP: 'Выполненные навесы игра в открытую',
      CrossingOP: 'Процент навесов, выполненных от всех попыток навесов в открытую',
      CrossesOP: 'Общее количество кроссов в открытой игре',
      PassingContribution: 'Процент, который измеряет угрозу передач с учетом позиции получателя',
      BallProgressionOppHalfInTeam: '% Прогрессия мяча половина соперника в команде',
      PassesOPIntoBoxInTeam: '% Передачи игра в открытую в штрафную в команде',
      TouchesOppBoxInTeam: '% Касания штрафная соперника в команде',
      xGOPInTeam: '% xG Игра в открытую в команде',
      DeepPasses: 'Передачи из-за пределов 20-метрового радиуса ворот соперника, которые заканчиваются внутри этой области',
      DeepPassesTotal: 'Общее количество передач, предпринятых из-за пределов 20-метрового радиуса ворот соперника, которые заканчиваются внутри этой зоны',
      DefensiveDuelsPct: 'Процент выигранных защитных единоборств от общего количества защитных единоборств',
      QuickRecoveriesPct: 'Процент быстрых подборов к перехватам и попыткам отборов',
      DiffDefensiveDistanceTeam: 'Разница между защитной дистанцией игрока и защитной дистанцией его команды',
      xTPassing: 'Ожидаемая угроза, созданная только передачами',
      xTPassing100Passes: 'Ожидаемая угроза, созданная только передачами и за 100 передач',
      ProgressivePassesAccurate: 'Выполненные передачи 10 метров или более по оси X',
      PassAbility: 'Соотношение выполненных передач к ожидаемым передачам (xP)',
      OPPassesIntoOppBoxPct: 'Процент выполненных передач в открытую в штрафную соперника и попыток передач в открытую в штрафную соперника',
      EntriesOppBox: 'Количество передач и ведений в штрафную соперника',
      Crosses6yardBox: 'Общее количество навесов, заканчивающихся в шестиметровой',
      Cutbacks: 'Передачи от лицевой линии назад и внутрь штрафной соперника',
      xTDribbling: 'Ожидаемая угроза, созданная только дриблингами',
      AvgShotDistance: 'Средняя дистанция общего количества сделанных ударов',
      xGOnTarget: 'Ожидаемые голы от ударов в створ. Измеряет вероятность удара закончиться голом, используя конечное местоположение удара',
      FinishingxGOT: 'Процент ударов в створ, заканчивающихся голом выше среднего. Эта метрика измеряет, какую ценность нападающий добавляет качеством своих ударов',
      DribblesWonOwnHalf: 'Успешные дриблинги, сделанные в своей половине',
      DribblesOwnHalf: 'Количество попыток дриблинга, сделанных в своей половине',
      DribblesOwnHalfPct: 'Процент успешных дриблингов и попыток дриблинга, сделанных в своей половине',
      DribblesWonOppHalf: 'Успешные дриблинги, сделанные в половине соперника',
      DribblesOppHalf: 'Количество попыток дриблинга, сделанных в половине соперника',
      DribblesOppHalfPct: 'Процент успешных дриблингов и попыток дриблинга, сделанных в половине соперника',
      DribblesWonFinalThird: 'Успешные дриблинги, сделанные в финальной трети',
      DribblesFinalThird: 'Количество попыток дриблинга, сделанных в финальной трети',
      DribblesFinalThirdPct: 'Процент успешных дриблингов и попыток дриблинга, сделанных в финальной трети',
      ShotEndingHighRecoveries: 'Высокие подборы (подборы, сделанные на 40 метров или ближе к воротам соперника), заканчивающиеся ударом',
      PassingFinalThirdAgainst: 'Успешные передачи от соперника в финальную треть',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Общее количество попыток передач от соперника в свою штрафную во время игры в открытую',
      EntriesOppBoxAgainst: 'Количество передач и ведений от соперника в свою штрафную',
      DeepProgressionAgainst: 'Количество раз, когда соперник достигает последней пятой поля ведением мяча, плюс количество раз, когда владение мячом находится в первой пятой',
      TouchesInOpponentBoxAgainst: 'Количество раз, когда соперник владеет мячом в нашей штрафной',
      Score: 'Производительность игрока на основе различных метрик',
      PDScore: 'Физическая производительность игрока на основе различных физических метрик',
      OrlegiScore: 'Производительность игрока на основе различных метрик',
      SirScore: 'Производительность игрока на основе различных метрик',
      ExcScore: 'Производительность игрока на основе различных метрик',
      xTOPInTeam: 'Ожидаемая угроза, созданная во время игры в открытую в команде',
      YellowCards: 'Полученные желтые карточки',
      RedCards: 'Полученные красные карточки',
      xTOpenPlayAgainst: 'Ожидаемая угроза, пропущенная во время игры в открытую',
      xTSetPieceAgainst: 'Ожидаемая угроза, пропущенная со стандартов',
      NPGOpenPlayAgainst: 'Количество пропущенных голов действиями в открытую, исключая голы с пенальти',
      NPGSetPieceAgainst: 'Количество пропущенных голов со стандартов, исключая голы с пенальти',
      PassesOppHalfPerPossession: 'Передачи половина соперника за владение',
      AverageTimeRecovery: 'Среднее время восстановления',
      ExpectedPassing: 'Процент передач, которые должны были быть выполнены',
      NumPossession10Passes: 'Владения, созданные 10 или более передачами',
      PassesReceived: 'Полученные передачи',
      PassesReceivedFinalThird: 'Полученные передачи финальная треть',
      ProgressivePassesTotalPct: 'Процент прогрессивных передач',
      ShortPassesPct: 'Процент коротких передач',
      TouchesOppBoxOppTeam: 'Количество действий соперника, пропущенных внутри своей штрафной, пока игрок на поле',
      ShotsOnTargetOppTeam: 'Удары в створ, пропущенные, пока игрок на поле',
      NPGOppTeam: 'Голы без пенальти, пропущенные, пока игрок на поле',
      xGSetPiecePerxG: 'Ожидаемые голы, созданные со стандартов, необходимые для создания одного ожидаемого гола',
      ShotsOpenPlay: 'Количество ударов, созданных в открытую',
      ShotsOpenPlayAgainst: 'Количество ударов, полученных в открытую',
      ShotsFromDribble: 'Удары, выполненные после обводки соперника',
      GoalsFromDribble: 'Голы, забитые после обводки соперника',
      PassesIntoFinalThird: 'Успешные передачи из финальной трети',
      PassesIntoFinalThirdTotal: 'Общее количество попыток передач, которые начинаются снаружи и заканчиваются внутри последней трети',
      PassesInsideFinalThird: 'Успешные передачи внутри финальной трети (начало и конец в этой зоне)',
      PassesInsideFinalThirdTotal: 'Общее количество передач, предпринятых в пределах последней трети (начало и окончание в последней трети)',
      PassesFinalThirdNoArea: 'Проходит последнюю треть (без коробки)',
      PassesIntoOppBox: 'Успешные передачи, завершившиеся в штрафной соперника',
      CarriesFinalThird: 'Продвижения мяча минимум на 7 метров, завершающиеся в финальной трети',
      CarriesInsideFinalThird: 'Продвижения мяча минимум на 7 метров внутри финальной трети',
      CarriesFinalThirdNoBox: 'Переносит последнюю треть (без коробки)',
      CarriesIntoOppBox: 'Продвижения мяча минимум на 7 метров, завершающиеся в штрафной соперника',
      TimePossessionAgainst: 'Время владения мячом соперником',
      TimePossessionTotal: 'Общее время владения мячом обеими командами',
      PassesInBox: 'Успешные передачи в своей штрафной',
      LongThrowInSuccessful: 'Успешные дальние вбрасывания с фланга, более 20 метров',
      LongThrowInTotal: 'Общее количество дальних вбрасываний с фланга (20+ метров)',
      LongThrowInPct: 'Процент успешных дальних вбрасываний (20+ метров)',
      Games: 'Сыгранные игры',
      PointsPerGame: 'Очки за игру',
      ExpectedPointsDiff: 'Ожидаемая разница в очках',
      PassesTotalOwnHalf: 'Общее количество передач со своей половины поля',
      PassesOwnHalf: 'Количество успешных передач со своей половины поля',
      PassesTotalOppHalf: 'Общее количество передач, сделанных с половины соперника',
      ProgressivePassesTotal: 'Общее количество проходов 10 и более метров по оси X',
      DuelsWon: 'Успешные дуэли (подборы, удары по воздуху, касания мяча, ведение и совершенные фолы)',
      NonPenaltySaves: 'Сейвы без учета пенальти',
      BadActionsOppHalf: 'Сумма всех совершенных плохих действий (неудачный пас, неудачный прием, лишение владения, пас из офсайда, неудачное касание мяча) на половине поля соперника',
      CarriesSuccessful: 'Количество переносов на расстояние не менее 7 метров, закончившихся успешным забегом.',
      ShotsOnTargetOutBox: 'Удары в створ из-за пределов штрафной',
      TotalDistance: 'Общая дистанция, которую игрок преодолел во время матча',
      WalkingDistance: 'Общая дистанция, которую игрок преодолел во время матча со скоростью ниже 2 м/с (7,2 км/ч)',
      JoggingDistance: 'Общая дистанция, которую игрок преодолел во время матча со скоростью между 2 м/с (7,2 км/ч) и 4 м/с (14,4 км/ч)',
      RunningDistance: 'Общая дистанция, которую игрок преодолел во время матча со скоростью между 4 м/с (14,4 км/ч) и 5,5 м/с (19,8 км/ч)',
      ExtremeAccelerations: 'Количество раз, когда игрок ускоряется более чем на 3 м/с<sup>2</sup>',
      NumberOfRuns: 'Количество пробежек, выполненных со скоростью между 4 м/с (14,4 км/ч) и 5,5 м/с (19,8 км/ч)',
      DistanceTIP: 'Дистанция (Команда во владении), которую игрок преодолел во время матча с владением',
      DistanceOTIP: 'Дистанция БВ (Команда соперника во владении), которую игрок преодолел во время матча без владения',
      HsrNumber: 'Количество раз, когда игрок движется со скоростью, которая больше или равна 5,5 м/с (19,8 км/ч), но меньше 7 м/с (25,2 км/ч), в течение периода не менее 1 секунды',
      HsrDistance: 'Общая дистанция, которую игрок преодолел во время матча со скоростью, которая больше или равна 5,5 м/с (19,8 км/ч), но меньше 7 м/с (25,2 км/ч)',
      HsrDistancePct: 'Процент дистанции HSR (Высокоскоростной бег) по отношению к общей пройденной дистанции',
      SprintsNumber: 'Количество раз, когда игрок движется со скоростью, которая больше или равна 7 м/с (25,2 км/ч), в течение периода не менее 1 секунды',
      SprintsDistance: 'Общая дистанция, которую игрок преодолел во время матча со скоростью, которая больше или равна 7 м/с (25,2 км/ч)',
      SprintNumberDeclinePct: 'Процентное снижение количества выполненных спринтов по сравнению со вторым таймом матча',
      SprintDistanceDeclinePct: 'Процентное снижение дистанции, пробеганной во время спринта, по сравнению со вторым таймом матча',
      SprintNumberDecline: 'Снижение количества выполненных спринтов по сравнению со вторым таймом матча',
      SprintDistanceDecline: 'Снижение дистанции, пробеганной во время спринта, по сравнению со вторым таймом матча',
      SprintDistancePct: 'Процент дистанции спринта по отношению к общей пройденной дистанции',
      Accelerations: 'Количество раз, когда игрок ускоряется между 1,5 м/с<sup>2</sup> и 3 м/с<sup>2</sup>',
      ExplosiveDistance: 'Взрывная дистанция',
      MaxSpeed: 'Максимальная скорость, достигнутая игроком',
      AvgMaxSpeed: 'Средняя максимальная скорость, достигнутая игроком',
      MaxAccelerations: 'Максимальные метры/секунду<sup>2</sup>, достигнутые игроком',
      BypassedPlayersByPasses: 'Общее количество соперников (защитников и полузащитников), обойденных передачами',
      BypassedDefendersByPasses: 'Общее количество соперников (защитников), обойденных передачами',
      PassesBypassingPlayers: 'Количество передач, которые обошли игроков',
      PassesBypassingDefenders: 'Количество передач, которые обошли защитников',
      BypassedPlayersPerPass: 'Общее количество обойденных игроков за передачи',
      BypassedDefendersPerPass: 'Общее количество обойденных защитников за передачи',
      LineBreakingPasses: 'Количество выполненных передач, которые успешно проникают через одну или более защитных линий',
      LineBreakingPassesMD: 'Количество выполненных передач, которые успешно проникают через линии полузащиты и защиты',
      LineBreakingPassesM: 'Количество выполненных передач, которые успешно проникают через линию полузащиты',
      LineBreakingThroughBalls: 'Количество выполненных передач, которые успешно проникают через защитную линию',
      LineBreakingPassesPerPass: 'Процент передач, прорывающих линии, за передачу',
      TotalPassesUnderStrongPressure: 'Общее количество передач, сделанных под сильным давлением (в пределах 0-2 метров от ближайшего соперника)',
      TotalPassesUnderLightPressure: 'Общее количество передач, сделанных под давлением (в пределах 2-4 метров от ближайшего соперника)',
      SuccessfulPassesUnderStrongPressure: 'Количество успешных передач, сделанных под сильным давлением (в пределах 0-2 метров от ближайшего соперника)',
      SuccessfulPassesUnderLightPressure: 'Количество успешных передач, сделанных под давлением (в пределах 2-4 метров от ближайшего соперника)',
      PassingUnderStrongPressure: 'Процент успешных передач и общих передач, обе под сильным давлением (в пределах 0-2 метров от ближайшего соперника)',
      PassingUnderLightPressure: 'Процент успешных передач и общих передач, обе под давлением (в пределах 2-4 метров от ближайшего соперника)',
      PassReceiptsInSpaceCompleted: 'Передачи, сделанные там, где получатель находится в атакующей половине и нет защитника в радиусе 5 метров в направлении ворот',
      PassReceiptsInSpace: 'Передачи, полученные в атакующей половине, и нет защитника в радиусе 5 метров в направлении ворот',
      PassReceiptsInSpaceCompletedFirstThird: 'Передачи, принятые в первой трети без защитника в радиусе 5 метров по направлению к воротам',
      PassReceiptsInSpaceCompletedSecondThird: 'Передачи, принятые во второй трети без защитника в радиусе 5 метров по направлению к воротам',
      PassReceiptsInSpaceCompletedFinalThird: 'Передачи, принятые в финальной трети без защитника в радиусе 5 метров по направлению к воротам',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Передачи, принятые на правом фланге половины соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Передачи, принятые в центральной зоне половины соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Передачи, принятые на левом фланге половины соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceFirstThird: 'Принятые передачи в первой трети без защитника в радиусе 5 метров',
      PassReceiptsInSpaceSecondThird: 'Принятые передачи во второй трети без защитника в радиусе 5 метров',
      PassReceiptsInSpaceFinalThird: 'Принятые передачи в финальной трети без защитника в радиусе 5 метров',
      PassReceiptsInSpaceOppHalfRight: 'Принятые передачи на правом фланге соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceOppHalfCenter: 'Принятые передачи в центре половины соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceOppHalfLeft: 'Принятые передачи на левом фланге соперника без защитника в радиусе 5 метров',
      TotalStrongOnBallPressures: 'Количество сильных давлений на мяч (в пределах 0-2 метров от владельца мяча)',
      TotalLightOnBallPressures: 'Количество давлений на мяч (в пределах 2-4 метров от владельца мяча)',
      SuccessfulStrongOnBallPressures: 'Количество успешных сильных давлений на мяч (в пределах 0-2 метров)',
      SuccessfulLightOnBallPressures: 'Количество успешных давлений на мяч (в пределах 2-4 метров)',
      StrongOnBallPressuresPct: 'Процент успешных и общих сильных давлений на мяч (в пределах 0-2 метров от ближайшего соперника)',
      LightOnBallPressuresPct: 'Процент успешных и общих давлений на мяч (в пределах 2-4 метров от ближайшего соперника)',
      TimesBypassedByPasses: 'Общее количество раз, обойденных передачей',
      TimesBypassedByCarries: 'Общее количество раз, обойденных ведением',
      TimesBypassedByActions: 'Общее количество раз, обойденных передачей и ведением вместе',
      BypassedPlayersByCarries: 'Общее количество соперников (защитников и полузащитников), обойденных ведениями',
      BypassedDefendersByCarries: 'Общее количество соперников (защитников), обойденных ведениями',
      BypassedPlayersByActions: 'Общее количество соперников (защитников и полузащитников), обойденных передачами и ведениями вместе',
      BypassedDefendersByActions: 'Общее количество соперников (защитников), обойденных передачами и ведениями вместе',
      CarriesBypassingPlayers: 'Количество ведений, которые обошли игроков',
      CarriesBypassingDefenders: 'Количество ведений, которые обошли защитников',
      BypassedPlayersPerCarry: 'Среднее количество обойденных соперников за ведение',
      BypassedDefendersPerCarry: 'Среднее количество обойденных защитников за ведение',
      LineBreakingCarries: 'Количество ведений, которые успешно проникают через одну или более защитных линий',
      LineBreakingCarriesMD: 'Количество ведений, которые успешно проникают через линии полузащиты и защиты',
      LineBreakingCarriesM: 'Количество ведений, которые успешно проникают через линию полузащиты',
      LineBreakingCarriesD: 'Количество ведений, которые успешно проникают через защитную линию',
      LineBreakingCarriesPerCarry: 'Процент ведений, прорывающих линии, за ведение',
      LineBreakingActions: 'Количество передач и ведений вместе, которые успешно проникают через одну или более защитных линий',
      LineBreakingActionsMD: 'Количество передач и ведений вместе, которые успешно проникают через линии полузащиты и защиты',
      LineBreakingActionsM: 'Количество передач и ведений вместе, которые успешно проникают через линию полузащиты',
      LineBreakingActionsD: 'Количество передач и ведений вместе, которые успешно проникают через защитную линию',
      PassesPerLineBreakingPass: 'Соотношение между общим количеством передач за передачу, прорывающую линии',
      CarriesPerLineBreakingCarry: 'Соотношение между общим количеством ведений за ведение, прорывающее линии',
      LinesBrokenByPasses: 'Общее количество линий, прорванных передачами',
      LinesBrokenByCarries: 'Общее количество линий, прорванных ведениями',
      LinesBrokenByActions: 'Общее количество линий, прорванных передачами и ведениями вместе',
      LinesBrokenPerPass: 'Соотношение между общим количеством прорванных линий за передачу',
      LinesBrokenPerCarry: 'Соотношение между общим количеством прорванных линий за ведение',
      AvgLastDefenderDistanceIP: 'Дистанция между последним защитником (ближайшим к своим воротам) и линией ворот во владении',
      AvgLastDefenderDistanceOOP: 'Дистанция между последним защитником (ближайшим к своим воротам) и линией ворот без владения',
      AvgDefensiveLineDistanceIP: 'Дистанция между позицией самой глубокой защитной линии и воротами во владении',
      AvgDefensiveLineDistanceOOP: 'Дистанция между позицией самой глубокой защитной линии и воротами без владения',
      AvgRBDistanceIP: 'Дистанция от правого защитника до своих ворот во владении',
      AvgRBDistanceOOP: 'Дистанция от правого защитника до своих ворот без владения',
      AvgLBDistanceIP: 'Дистанция от левого защитника до своих ворот во владении',
      AvgLBDistanceOOP: 'Дистанция от левого защитника до своих ворот без владения',
      AvgBlockDistanceIP: 'Дистанция между самым глубоким и самым продвинутым полевым игроком во владении',
      AvgBlockDistanceOOP: 'Дистанция между самым глубоким и самым продвинутым полевым игроком без владения',
      AvgBlockAreaIP: 'Площадь ограничивающего прямоугольника вокруг всех полевых игроков (мера того, сколько пространства занимает команда) во владении',
      AvgBlockAreaOOP: 'Площадь ограничивающего прямоугольника вокруг всех полевых игроков (мера того, сколько пространства занимает команда) без владения',
      AvgDefensiveLineWidthOOP: 'Ширина самой задней линии игроков (самой далекой от своих ворот) без владения',
      AvgOffensiveLineLastThirdWidthIP: 'Горизонтальная ширина атакующей линии в последней трети во владении',
      AvgLByIP: 'Позиция левого защитника во владении',
      AvgRByIP: 'Позиция правого защитника во владении',
      AvgOffensiveLineDistanceIP: 'Дистанция между своими воротами и атакующей линией во владении',
      AvgOffensiveLineLastThirdDistanceIP: 'Дистанция между своими воротами и атакующей линией в последней трети во владении',
      AvgOffensiveLineWidthIP: 'Горизонтальная ширина атакующей линии во владении',
      OffBallRuns: 'Намеренные безмячевые движения (пробежки) для поддержки атакующей фазы',
      OffBallRunsOverlap: 'Пробежки, где игрок движется вокруг внешней стороны товарища по команде (ближе к боковой линии), пока этот товарищ владеет мячом',
      OffBallRunsUnderlap: 'Пробежки, где игрок движется внутри товарища по команде, выбирая внутренний маршрут (ближе к центру поля)',
      OffBallRunsRunAhead: 'Пробежка вперед, которая идет дальше владельца мяча, но остается впереди последнего защитника',
      OffBallRunsRunBehind: 'Пробежка вперед, которая прорывается в последнюю защитную линию, попадая между защитниками и вратарем',
      OffBallRunsCrossReceiver: 'Игрок вбегает в штрафную и позиционируется для получения навеса от товарища по команде',
      OffBallRunsSupport: 'Игрок бежит, чтобы выровняться с владельцем мяча, предлагая близкий вариант передачи в атаке',
      OffBallRunsComingShort: 'Игрок движется к владельцу мяча, чтобы предложить близкую поддержку или вариант передачи от ворот',
      AerialsOppHalf: 'Успешные верховые единоборства в половине соперника',
      CarriesIntoFinalThird: 'Трубопроводы длиной не менее 7 метров снаружи внутрь последней трети',
      SpeedScore: 'Физические показатели игрока на основе различных показателей скорости',
      EnduranceScore: 'Физические показатели выносливости игрока на основе различных показателей',
      SwitchPlaySuccessful: 'Количество завершенных передач на расстояние более 32 метров, при которых боковое смещение мяча превышает его смещение в сторону ворот соперника.',
      SwitchPlayTotal: 'Общее количество попыток передач на расстояние более 32 метров, при которых боковое смещение мяча превышает его смещение в сторону ворот соперника.',
      PassesInsideOppHalf: 'Общее количество передач, которые начинаются и заканчиваются на половине поля соперника',
      PassesInsideOppHalfSuccessful: 'Количество завершенных передач, которые начинаются и заканчиваются на половине поля соперника',
      TacklesAttemptedFirstThird: 'Общее количество попыток отбора мяча в первой трети поля',
      TacklesAttemptedSecondThird: 'Общее количество попыток отбора мяча во второй трети поля',
      TacklesFirstThird: 'Количество успешных отборов мяча, выполненных в первой трети поля',
      TacklesSecondThird: 'Количество успешных отборов мяча, выполненных на второй трети поля',
      FoulsOwnHalf: 'Количество нарушений, совершенных на своей половине поля',
      TouchesOppHalf: 'Количество касаний мяча на половине поля противника',
      TacklesAttemptedNotAdjusted: 'Общее количество попыток отбора мяча без учета владения мячом',
      TacklesSuccessfulNotAdjusted: 'Общее количество успешных отборов мяча без учета владения мячом',
      AvgTop5MaxSpeed: 'Среднее из пяти самых высоких максимальных скоростей игрока',
      LBPReceived: 'Количество полученных проходов с нарушением линии. Это завершенные передачи, которые перемещают мяч как минимум на 10% ближе к воротам соперника и пересекают пару защитников, находящихся в непосредственной близости, или выходят за линию защиты.',
      LBPMReceived: 'Количество полученных передач с прорывом через линию полузащиты соперника',
      LBPMDReceived: 'Количество полученных передач, прорывающих как полузащиту, так и линию защиты соперника',
      ThroughBallReceived: 'Количество полученных передач, прорвавших последнюю линию обороны противника',
      HsrDistanceIP: 'Спринтерская дистанция >21 км/ч при владении мячом.',
      HsrDistanceOOP: 'Спринтерская дистанция >21 км/ч без владения мячом.',
      JoggingDistanceIP: 'Расстояние бега во владении мячом',
      JoggingDistanceOOP: 'Беговая дистанция без владения мячом',
      RunningDistanceIP: 'Беговая дистанция владения мячом',
      RunningDistanceOOP: 'Беговая дистанция без владения мячом',
      SprintsDistanceIP: 'Спринтерская дистанция >24 км/ч при владении мячом.',
      SprintsDistanceOOP: 'Спринтерская дистанция >24 км/ч без владения мячом.',
      WalkingDistanceIP: 'В шаговой доступности во владении',
      WalkingDistanceOOP: 'В нескольких минутах ходьбы от владения'
    },
    subtitles: {
      Possession: 'Процент владения мячом команды',
      TimePossession: 'Время владения мячом команды',
      PassesPerShots: 'Среднее количество передач за удар',
      PPDA: 'Давление, которое команда оказывает на игроков соперника, когда они владеют мячом',
      Directness: 'Большее количество передач вперед по отношению к передачам в стороны',
      ExpectedPoints: 'Количество ожидаемых очков команды, рассчитанное на основе ожидаемых голов',
      PassesPerLongBall: 'Процент успешных длинных передач от общего количества выполненных передач',
      CrossingPerXG: 'Процент ожидаемых голов, пришедших с навесов',
      PenaltySavedPenaltyFaced: 'Процент отраженных ударов с пенальти от всех полученных ударов с пенальти',
      Goals: 'Количество забитых голов',
      PenaltyShots: 'Общее количество ударов с пенальти',
      PenaltyGoals: 'Общее количество голов с пенальти',
      NonPenaltyGoals: 'Голы (исключая пенальти)',
      AerialWins: 'Выигранные верховые единоборства',
      AerialEfficiency: 'Метрика, которая объединяет выигранные верховые единоборства с общим количеством верховых единоборств',
      AerialWinsPct: 'Процент выигранных верховых единоборств',
      Assists: 'Передачи',
      Catching: 'Процент отражений, в которых вратарь ловит мяч',
      Caught: 'Сейв в момент, когда вратарь ловит и удерживает мяч, предотвращая повторную игру.',
      ChancesCreated: 'Количество передач, ведущих к удару',
      ClaimAccuracy: 'Мячи, перехваченные выше среднего',
      CompletedCrosses: 'Успешно выполненные навесы',
      Crossing: 'Процент успешных навесов',
      Dispossessed: 'Потери',
      Finishing: 'Процент ударов, заканчивающихся голом',
      xGEfficiency: 'Количество ожидаемых голов, необходимое игроку для забития гола',
      Fouls: 'Фолы, совершенные',
      DeepProgression: 'Количество раз, когда последняя пятая поля достигается ведением мяча, плюс количество раз, когда владение мячом находится в последней пятой',
      DeepProgressionFinalThird: 'Раз владение мячом в финальной трети',
      FoulsTaken: 'Полученные фолы',
      IndividualPressure: 'Успешные усилия (восстановленные владения)',
      Interceptions: 'Перехваты мяча',
      LongBallPct: 'Процент выполненных передач не менее 32 метров',
      LongBallTotal: 'Общее количество проходов более 32 метров',
      LongBallSuccessful: 'Выполненные передачи не менее 32 метров',
      NPGOpenPlay: 'Голы (исключая пенальти) действиями в открытую',
      NPGSetPiece: 'Голы (исключая пенальти) со стандартов',
      OpenPlayKeyPasses: 'Передачи, заканчивающиеся ударом (исключая передачи) в открытую',
      OpenPlayKeyPassesInTeam: 'Процент передач, заканчивающихся ударом (исключая передачи) в открытую в команде',
      PassingFinalThird: 'Успешные передачи в финальную треть',
      PassesFinalThirdTotal: 'Общее количество попыток передач, исключая навесы, стандартные положения, угловые и вбрасывания, которые заканчиваются в последней трети',
      PassingFinalThirdPct: 'Процент успешных передач в финальной трети',
      PassingOppHalfPct: 'Процент успешных передач в половину соперника',
      PassingOwnHalfPct: 'Процент успешных передач в свою половину',
      PassingPct: 'Процент успешных передач',
      Recoveries: 'Подборы мяча (через отборы или перехваты)',
      SavesInBoxPct: 'Процент отражений от ударов из штрафной',
      SavesOutOfBoxPct: 'Процент отражений от ударов из-за пределов штрафной',
      SavesPct: 'Процент отражений',
      ScoringContribution: 'Количество передач и голов',
      xAssistsOpenPlay: 'Количество ожидаемых передач, созданных в открытую',
      xAssistsSetPiece: 'Количество ожидаемых передач, созданных со стандартов',
      xAssistsOpenPlayInTeam: 'Количество ожидаемых передач, созданных в открытую в команде',
      xAssistsSetPieceInTeam: 'Количество ожидаемых передач, созданных со стандартов в команде',
      xGChainFinalThird: 'Количество xG, в котором участвовал игрок в финальной трети',
      xGBuildupFinalThird: 'Количество xG, в котором участвовал игрок в финальной трети (исключая удары и передачи, ведущие к удару)',
      BallProgressionPassing: 'Количество раз, когда игрок продвигает мяч на 10 метров или более передачей',
      BallProgressionDribbling: 'Количество раз, когда игрок продвигает мяч на 10 метров или более ведением',
      Shooting: 'Процент ударов (исключая пенальти) в створ',
      Shots: 'Количество ударов',
      ShotsPerGoal: 'Среднее количество ударов для забития гола',
      SuccessfulDribbles: 'Успешные дриблинги',
      TacklesSuccessful: 'Общее количество отборов',
      TacklesWasDribbled: 'Процент выигранных единоборств через отбор',
      ThroughBalls: 'Количество передач, прорывающих защитную линию',
      TouchesInOpponentBox: 'Количество контролей мяча в штрафной соперника',
      xAssists: 'Ожидаемые передачи, созданные',
      xG: 'Ожидаемые голы, созданные',
      xGDiff: 'Разница между xG и голами',
      xGOpenPlay: 'Ожидаемые голы, созданные в открытую',
      xGSetPiece: 'Ожидаемые голы, созданные со стандартов',
      xGBuildup: 'Участие в построении xG',
      xGBuildupInTeam: 'Участие в построении xG в команде',
      BallProgression: 'Прогрессии передачей или ведением мяча не менее 10 метров',
      xGChain: 'Участие в цепочке xG',
      xGPerNPG: 'Ожидаемые голы, необходимые для забития гола без пенальти',
      xGPerShot: 'Средний xG за удар',
      xGSavedPerShot: 'Средний xG отражен за полученный удар',
      xGSavedPerXGFacedOnTarget: 'Средний xG отражен за xG получен в створ',
      xGFacedOnTargetPerGoalReceived: 'Ожидаемые голы, необходимые для забития гола определенному вратарю',
      xGFacedOnTargetEfficiency: 'Количество предотвращенных голов без пенальти вратарем',
      xGFacedOnTarget: 'Всего xG (отражено и забито), полученного вратарем',
      HighTurnovers: 'Потери ближе 40 метров от своих ворот',
      OpenPlayPassesIntoOpponentBox: 'Всего передач в открытую в штрафную соперника',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Выполненные передачи в открытую в штрафную соперника',
      ChancesCreatedOP: 'Количество передач, ведущих к удару во время игры в открытую',
      PenaltiesTaken: 'Количество раз, когда игрок был сфолен в штрафной соперника',
      BlockedCrosses: 'Заблокированные навесы',
      BlockedShots: 'Заблокированные удары',
      NonPenaltyGoalsAgainst: 'Количество пропущенных голов без пенальти',
      Headers: 'Количество ударов, сделанных головой',
      AveragePassDistance: 'Средняя дистанция передач в метрах',
      ProgressiveRuns: 'Успешные ведения, которые приближают владение на 20% ближе к воротам соперника',
      xT: 'Угроза, созданная перемещением мяча в опасные зоны',
      xTOpenPlay: 'Ожидаемая угроза, созданная во время игры в открытую',
      xTSetPiece: 'Ожидаемая угроза, созданная со стандартов',
      xGOT: 'Количество ожидаемых голов, полученных вратарем',
      BadActions: 'Сумма всех плохих действий',
      BadActionsOwnHalf: 'Сумма всех плохих действий в своей половине',
      AerialsWonOwnBox: 'Выигранные верховые единоборства своя штрафная',
      AerialsWonOppBox: 'Выигранные верховые единоборства штрафная соперника',
      AerialsTotalOppBox: 'Всего верховых единоборств штрафная соперника',
      AerialsTotalOwnBox: 'Всего верховых единоборств своя штрафная',
      FoulsOwnHalfPct: 'Процент фолов, совершенных в своей половине',
      RecoveriesOppHalf: 'Количество мячей, восстановленных игроком в половине соперника',
      DuelsPct: 'Процент успешных единоборств',
      TacklesUnsuccessful: 'Количество раз, когда игрок не смог выиграть мяч, когда соперник успешно обыграл его',
      TacklesWasDribbledFirstThird: 'Процент раз, когда игрок восстанавливает мяч при столкновении в финальной трети',
      TacklesWasDribbledSecondThird: 'Выигранные оборонительные единоборства 1 в 1 ⅔',
      TacklesWasDribbledFinalThird: 'Выигранные оборонительные единоборства 1 в 1н финальная ⅓',
      BallProgressionFinalThird: 'Количество раз, когда игрок продвигается на 10 или более метров в финальной трети',
      DuelsTotal: 'Общее количество отборов, верховых единоборств, касаний мяча, дриблингов и фолов, совершенных',
      QuickRecoveries: 'Подборы на 40 метров или более от своих ворот, сделанные через 8 секунд после потери владения',
      ShotsPerNPG: 'Среднее количество ударов для забития гола без пенальти',
      ShotsOutBox: 'Количество ударов из-за пределов штрафной',
      GoalsOutBox: 'Количество голов из-за пределов штрафной',
      ShootingOutBox: 'Процент ударов в створ из-за пределов штрафной',
      HandPassing: 'Точность передач руками',
      ShotEndingHighTurnovers: 'Высокие потери (потери ближе 40 метров от своих ворот), заканчивающиеся ударом команды соперника',
      GoalEndingHighTurnovers: 'Высокие потери (потери ближе 40 метров от своих ворот), заканчивающиеся голом команды соперника',
      AverageCarriesProgress: 'Средняя дистанция, на которую игрок перемещает мяч вертикально за ведение (метры)',
      ChanceEndingCarries: 'Ведения не менее 7 метров, заканчивающиеся передачей, за которой следует удар',
      AssistEndingCarries: 'Ведения не менее 7 метров, заканчивающиеся передачей, за которой следует гол',
      ShotEndingCarries: 'Ведения не менее 7 метров, заканчивающиеся ударом',
      GoalEndingCarries: 'Ведения не менее 7 метров, заканчивающиеся голом',
      ShotEndingSequence: 'Количество последовательностей, заканчивающихся ударом, где участвовал игрок',
      GoalEndingSequence: 'Количество последовательностей, заканчивающихся голом, где участвовал игрок',
      AerialWonOffensive: 'Выигранные верховые единоборства атакующие',
      AerialWonDefensive: 'Выигранные верховые единоборства защитные',
      xGAgainst: 'Пропущенные ожидаемые голы',
      xGDiffAgainst: 'Разница между пропущенными ожидаемыми голами и пропущенными голами',
      xGPerNPGAgainst: 'Ожидаемые голы, полученные за пропущенный гол без пенальти',
      xGOpenPlayAgainst: 'Ожидаемые голы, созданные в открытую пропущено',
      xGSetPieceAgainst: 'Ожидаемые голы, созданные со стандартов пропущено',
      xGPerShotAgainst: 'Ожидаемые голы, полученные за пропущенный удар',
      ShotsAgainst: 'Пропущенные удары',
      ShotsOnTargetAgainst: 'Пропущенные удары в створ',
      RivalPossession: 'Владение соперника',
      AerialDefensivePct: 'Процент выигранных верховых единоборств без владения мячом',
      HighRecoveries: 'Подборы, сделанные на 40 метров близко к воротам соперника',
      HighDefensiveActions: 'Защитные действия (Отборы, Перехваты, Блоки, Фолы и 1vs1), сделанные на 40 метров над собственной линией ворот',
      HighDefensiveActionPct: 'Процент защитных действий (Отборы, Перехваты, Блоки, Фолы и 1vs1), сделанных на 40 метров над собственной линией ворот',
      HighDefensiveDistance: 'Средняя дистанция от своих ворот всех защитных действий',
      PassesPerPossession: 'Количество передач за владение',
      LengthPerPossession: 'Дистанция за владение',
      xTNet: 'Чистый xT',
      AvgCarriesDistance: 'Средняя дистанция ведений',
      PassesForwardPct: '% Передачи вперед',
      PassesForwardSuccessful: 'Успешные пасы вперед',
      PassesForwardTotal: 'Всего передач вперед',
      TacklesAttempted: 'Попытки отборов',
      DuelsLost: 'Проигранные единоборства',
      Carries: 'Ведения',
      CarriesPct: '% Ведения',
      Aerials: 'Общее количество верховых единоборств',
      ProgressivePassesReceivedIntoBox: 'Полученные прогрессивные передачи в штрафную',
      PassesOppHalf: 'Успешные передачи, заканчивающиеся в половине соперника',
      LongBallReceived: 'Количество полученных длинных передач (>32 метра)',
      ShotsOnTarget: 'Удары в створ',
      AggressiveActions: 'Количество попыток отборов в следующие две секунды после потери владения',
      Crosses: 'Общее количество навесов',
      xGBuildup5pass: 'Количество xG, в котором участвовал игрок, только последние 5 передач (исключая удары и передачи, ведущие к удару)',
      DefensiveDistance: 'Средняя дистанция до своих ворот защитных единоборств',
      SpeedSequence: 'Средняя скорость (метры, пройденные за время) всех владений команды',
      Touches: 'Количество раз, когда игрок владеет мячом',
      AerialsTotalOppHalf: 'Всего верховых единоборств в половине соперника',
      AerialsWonOppHalf: 'Воздушные дуэли успешны на половине поля противника.',
      AerialsWonOppHalfPct: 'Процент выигранных верховых единоборств в половине соперника',
      AerialsPctOppBox: 'Процент выигранных верховых единоборств в штрафной соперника',
      AerialsPctOwnBox: 'Процент выигранных верховых единоборств в своей штрафной',
      AerialDefensive: 'Общее количество верховых единоборств, когда команда соперника владеет мячом',
      AerialOffensive: 'Общее количество верховых единоборств, когда своя команда владеет мячом',
      AerialOffensivePct: 'Процент выигранных верховых единоборств, когда своя команда владеет мячом',
      IndividualPressureOppHalf: 'Владения, восстановленные игроком при прессинге соперника в половине соперника',
      TouchesPerShot: 'Количество раз, когда игроки касаются мяча за удар',
      PassesFinalThirdTotalPct: 'Процент передач (успешных и неуспешных) в финальную треть',
      xACrosses: 'Ожидаемые передачи, созданные с навесов',
      Passes: 'Общее количество передач',
      PassesSuccessful: 'Количество выполненных передач',
      TacklesWasDribbledFouls: 'Процент выигранных отборов по отношению к общему количеству отборов и совершенных фолов',
      OffsidesCaught: 'Пойманные офсайды',
      ProgressivePassesReceivedFinalThird: 'Полученные прогрессивные передачи финальная треть',
      ProgressivePassesReceived: 'Полученные прогрессивные передачи',
      Breadth: 'Сумма отборов, вызовов, перехватов и совершенных фолов на флангах поля',
      DuelsDefTotal: 'Сумма всех отборов, защитных верховых единоборств и совершенных фолов',
      DefensiveActions: 'Защитные действия, когда соперник пытается обыграть (Отборы, Вызовы и Фолы)',
      ProgressivePassesReceivedOppHalf: 'Полученные прогрессивные передачи половина соперника',
      CompletedCrossesOP: 'Выполненные навесы игра в открытую',
      CrossingOP: 'Процент навесов, выполненных от всех попыток навесов в открытую',
      CrossesOP: 'Общее количество кроссов в открытой игре',
      PassingContribution: 'Процент, который измеряет угрозу передач с учетом позиции получателя',
      BallProgressionOppHalfInTeam: '% Прогрессия мяча в половине соперника в команде',
      PassesOPIntoBoxInTeam: '% Передачи игра в открытую в штрафную в команде',
      TouchesOppBoxInTeam: '% Касания штрафная соперника в команде',
      xGOPInTeam: '% xG Игра в открытую в команде',
      DeepPasses: 'Передачи из-за пределов 20-метрового радиуса ворот соперника, которые заканчиваются внутри этой области',
      DeepPassesTotal: 'Общее количество передач, предпринятых из-за пределов 20-метрового радиуса ворот соперника, которые заканчиваются внутри этой зоны',
      DefensiveDuelsPct: 'Процент выигранных защитных единоборств от общего количества защитных единоборств',
      QuickRecoveriesPct: 'Процент быстрых подборов к перехватам и попыткам отборов',
      DiffDefensiveDistanceTeam: 'Разница между защитной дистанцией игрока и защитной дистанцией его команды',
      xTPassing: 'Ожидаемая угроза, созданная только передачами',
      xTPassing100Passes: 'Ожидаемая угроза, созданная только передачами и за 100 передач',
      ProgressivePassesAccurate: 'Выполненные передачи 10 метров или более по оси X',
      PassAbility: 'Соотношение выполненных передач к ожидаемым передачам (xP)',
      OPPassesIntoOppBoxPct: 'Процент выполненных передач в открытую в штрафную соперника и попыток передач в открытую в штрафную соперника',
      EntriesOppBox: 'Количество передач и ведений в штрафную соперника',
      Crosses6yardBox: 'Общее количество навесов, заканчивающихся в шестиметровой',
      Cutbacks: 'Передачи от лицевой линии назад и внутрь штрафной соперника',
      xTDribbling: 'Ожидаемая угроза, созданная только дриблингами',
      AvgShotDistance: 'Средняя дистанция общего количества сделанных ударов',
      xGOnTarget: 'Ожидаемые голы от ударов в створ',
      FinishingxGOT: 'Процент ударов в створ, заканчивающихся голом выше среднего',
      DribblesWonOwnHalf: 'Успешные дриблинги, сделанные в своей половине',
      DribblesOwnHalf: 'Количество попыток дриблинга, сделанных в своей половине',
      DribblesOwnHalfPct: 'Процент успешных дриблингов и попыток дриблинга, сделанных в своей половине',
      DribblesWonOppHalf: 'Успешные дриблинги, сделанные в половине соперника',
      DribblesOppHalf: 'Количество попыток дриблинга, сделанных в половине соперника',
      DribblesOppHalfPct: 'Процент успешных дриблингов и попыток дриблинга, сделанных в половине соперника',
      DribblesWonFinalThird: 'Успешные дриблинги, сделанные в финальной трети',
      DribblesFinalThird: 'Количество попыток дриблинга, сделанных в финальной трети',
      DribblesFinalThirdPct: 'Процент успешных дриблингов и попыток дриблинга, сделанных в финальной трети',
      ShotEndingHighRecoveries: 'Высокие подборы (подборы, сделанные на 40 метров или ближе к воротам соперника), заканчивающиеся ударом',
      PassingFinalThirdAgainst: 'Успешные передачи от соперника в финальную треть',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Общее количество попыток передач от соперника в свою штрафную во время игры в открытую',
      EntriesOppBoxAgainst: 'Количество передач и ведений от соперника в свою штрафную',
      DeepProgressionAgainst: 'Количество раз, когда соперник достигает последней пятой поля ведением мяча, плюс количество раз, когда владение мячом находится в первой пятой',
      TouchesInOpponentBoxAgainst: 'Количество раз, когда соперник владеет мячом в нашей штрафной',
      Score: 'Производительность игрока на основе различных метрик',
      PDScore: 'Физическая производительность игрока на основе различных физических метрик',
      OrlegiScore: 'Производительность игрока на основе различных метрик',
      SirScore: 'Производительность игрока на основе различных метрик',
      ExcScore: 'Производительность игрока на основе различных метрик',
      xTOPInTeam: 'Ожидаемая угроза, созданная во время игры в открытую в команде',
      YellowCards: 'Полученные желтые карточки',
      RedCards: 'Полученные красные карточки',
      xTOpenPlayAgainst: 'Ожидаемая угроза, пропущенная во время игры в открытую',
      xTSetPieceAgainst: 'Ожидаемая угроза, пропущенная со стандартов',
      NPGOpenPlayAgainst: 'Количество пропущенных голов без пенальти действиями в открытую',
      NPGSetPieceAgainst: 'Количество пропущенных голов без пенальти со стандартов',
      PassesOppHalfPerPossession: 'Передачи половина соперника за владение',
      AverageTimeRecovery: 'Среднее время восстановления',
      ExpectedPassing: 'Процент передач, которые должны были быть выполнены',
      NumPossession10Passes: 'Владения, созданные 10 или более передачами',
      PassesReceived: 'Полученные передачи',
      PassesReceivedFinalThird: 'Полученные передачи финальная треть',
      ProgressivePassesTotalPct: 'Процент прогрессивных передач',
      ShortPassesPct: 'Процент коротких передач',
      TouchesOppBoxOppTeam: 'Количество действий соперника, пропущенных внутри своей штрафной, пока игрок на поле',
      ShotsOnTargetOppTeam: 'Удары в створ, пропущенные, пока игрок на поле',
      NPGOppTeam: 'Голы без пенальти, пропущенные, пока игрок на поле',
      xGSetPiecePerxG: 'Ожидаемые голы, созданные со стандартов, необходимые для создания одного ожидаемого гола',
      ShotsOpenPlay: 'Количество ударов, созданных в открытую',
      ShotsOpenPlayAgainst: 'Количество ударов, полученных в открытую',
      ShotsFromDribble: 'Удары, выполненные после обводки соперника',
      GoalsFromDribble: 'Голы, забитые после обводки соперника',
      PassesIntoFinalThird: 'Успешные передачи из финальной трети',
      PassesIntoFinalThirdTotal: 'Общее количество попыток передач, которые начинаются снаружи и заканчиваются внутри последней трети',
      PassesInsideFinalThird: 'Успешные передачи внутри финальной трети (начало и конец в этой зоне)',
      PassesInsideFinalThirdTotal: 'Общее количество передач, предпринятых в пределах последней трети (начало и окончание в последней трети)',
      PassesFinalThirdNoArea: 'Проходит последнюю треть (без коробки)',
      PassesIntoOppBox: 'Успешные передачи, завершившиеся в штрафной соперника',
      CarriesFinalThird: 'Продвижения мяча минимум на 7 метров, завершающиеся в финальной трети',
      CarriesInsideFinalThird: 'Продвижения мяча минимум на 7 метров внутри финальной трети',
      CarriesFinalThirdNoBox: 'Переносит последнюю треть (без коробки)',
      CarriesIntoOppBox: 'Продвижения мяча минимум на 7 метров, завершающиеся в штрафной соперника',
      TimePossessionAgainst: 'Время владения мячом соперником',
      TimePossessionTotal: 'Общее время владения мячом обеими командами',
      PassesInBox: 'Успешные передачи в своей штрафной',
      LongThrowInSuccessful: 'Успешные дальние вбрасывания с фланга, более 20 метров',
      LongThrowInTotal: 'Общее количество дальних вбрасываний с фланга (20+ метров)',
      LongThrowInPct: 'Процент успешных дальних вбрасываний (20+ метров)',
      Games: 'Сыгранные игры',
      PointsPerGame: 'Очки за игру',
      ExpectedPointsDiff: 'Ожидаемая разница в очках',
      PassesTotalOwnHalf: 'Общее количество передач со своей половины поля',
      PassesOwnHalf: 'Количество успешных передач со своей половины поля',
      PassesTotalOppHalf: 'Общее количество передач, сделанных с половины соперника',
      ProgressivePassesTotal: 'Общее количество проходов 10 и более метров по оси X',
      DuelsWon: 'Успешные дуэли (подборы, удары по воздуху, касания мяча, ведение и совершенные фолы)',
      NonPenaltySaves: 'Сейвы без учета пенальти',
      BadActionsOppHalf: 'Сумма всех плохих действий, совершенных на половине поля соперника',
      CarriesSuccessful: 'Количество переносов на расстояние не менее 7 метров, закончившихся успешным забегом.',
      ShotsOnTargetOutBox: 'Удары в створ из-за пределов штрафной',
      TotalDistance: 'Общая дистанция',
      WalkingDistance: 'Общая дистанция, которую игрок преодолел во время матча со скоростью ниже 2 м/с (7,2 км/ч)',
      JoggingDistance: 'Общая дистанция, которую игрок преодолел во время матча со скоростью между 2 м/с (7,2 км/ч) и 4 м/с (14,4 км/ч)',
      RunningDistance: 'Общая дистанция, которую игрок преодолел во время матча со скоростью между 4 м/с (14,4 км/ч) и 5,5 м/с (19,8 км/ч)',
      ExtremeAccelerations: 'Количество раз, когда игрок ускоряется более чем на 3 м/с<sup>2</sup>',
      NumberOfRuns: 'Количество пробежек, выполненных со скоростью между 14,4 км/ч и 19,8 км/ч',
      HsrDistance: 'Дистанция высокоскоростного бега > 19,8 км/ч',
      HsrNumber: 'Количество высокоскоростного бега > 19,8 км/ч',
      HsrDistancePct: '% Дистанция HSR',
      SprintsNumber: 'Количество спринтов > 25,2 км/ч',
      SprintsDistance: 'Дистанция спринтов > 25,2 км/ч',
      SprintNumberDeclinePct: '% Снижение количества спринтов',
      SprintDistanceDeclinePct: '% Снижение дистанции спринтов',
      SprintNumberDecline: 'Снижение количества спринтов по сравнению со вторым таймом',
      SprintDistanceDecline: 'Снижение дистанции, пробеганной во время спринта, по сравнению со вторым таймом',
      SprintDistancePct: '% Дистанция спринта',
      Accelerations: 'Количество ускорений',
      MaxSpeed: 'Макс. Скорость',
      AvgMaxSpeed: 'Средняя максимальная скорость, достигнутая игроком',
      MaxAccelerations: 'Максимальные метры/секунду<sup>2</sup>, достигнутые игроком',
      BypassedPlayersByPasses: 'Общее количество соперников (защитников и полузащитников), обойденных передачами',
      BypassedDefendersByPasses: 'Общее количество соперников (защитников), обойденных передачами',
      PassesBypassingPlayers: 'Количество передач, которые обошли игроков',
      PassesBypassingDefenders: 'Количество передач, которые обошли защитников',
      BypassedPlayersPerPass: 'Общее количество обойденных игроков за передачи',
      BypassedDefendersPerPass: 'Общее количество обойденных защитников за передачи',
      LineBreakingPasses: 'Количество передач, которые успешно проникают через одну или более защитных линий',
      LineBreakingPassesMD: 'Количество передач, которые успешно проникают через линии полузащиты и защиты',
      LineBreakingPassesM: 'Количество передач, которые успешно проникают через линию полузащиты',
      LineBreakingThroughBalls: 'Количество передач, которые успешно проникают через защитную линию',
      LineBreakingPassesPerPass: 'Процент передач, прорывающих линии, за передачу',
      TotalPassesUnderStrongPressure: 'Общее количество передач, сделанных под сильным давлением (в пределах 0-2 метров от ближайшего соперника)',
      TotalPassesUnderLightPressure: 'Общее количество передач, сделанных под давлением (в пределах 2-4 метров от ближайшего соперника)',
      SuccessfulPassesUnderStrongPressure: 'Количество успешных передач, сделанных под сильным давлением (в пределах 0-2 метров от ближайшего соперника)',
      SuccessfulPassesUnderLightPressure: 'Количество успешных передач, сделанных под давлением (в пределах 2-4 метров от ближайшего соперника)',
      PassingUnderStrongPressure: 'Процент успешных передач и общих передач, обе под сильным давлением (в пределах 0-2 метров от ближайшего соперника)',
      PassingUnderLightPressure: 'Процент успешных передач и общих передач, обе под давлением (в пределах 2-4 метров от ближайшего соперника)',
      PassReceiptsInSpaceCompleted: 'Передачи, сделанные там, где получатель находится в атакующей половине и нет защитника в радиусе 5 метров в направлении ворот',
      PassReceiptsInSpace: 'Передачи, полученные в атакующей половине, и нет защитника в радиусе 5 метров в направлении ворот',
      PassReceiptsInSpaceCompletedFirstThird: 'Передачи, принятые в первой трети без защитника в радиусе 5 метров по направлению к воротам',
      PassReceiptsInSpaceCompletedSecondThird: 'Передачи, принятые во второй трети без защитника в радиусе 5 метров по направлению к воротам',
      PassReceiptsInSpaceCompletedFinalThird: 'Передачи, принятые в финальной трети без защитника в радиусе 5 метров по направлению к воротам',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Передачи, принятые на правом фланге половины соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Передачи, принятые в центральной зоне половины соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Передачи, принятые на левом фланге половины соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceFirstThird: 'Принятые передачи в первой трети без защитника в радиусе 5 метров',
      PassReceiptsInSpaceSecondThird: 'Принятые передачи во второй трети без защитника в радиусе 5 метров',
      PassReceiptsInSpaceFinalThird: 'Принятые передачи в финальной трети без защитника в радиусе 5 метров',
      PassReceiptsInSpaceOppHalfRight: 'Принятые передачи на правом фланге соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceOppHalfCenter: 'Принятые передачи в центре половины соперника без защитника в радиусе 5 метров',
      PassReceiptsInSpaceOppHalfLeft: 'Принятые передачи на левом фланге соперника без защитника в радиусе 5 метров',
      TotalStrongOnBallPressures: 'Количество сильных давлений на мяч (в пределах 0-2 метров от владельца мяча)',
      TotalLightOnBallPressures: 'Количество давлений на мяч (в пределах 2-4 метров от владельца мяча)',
      SuccessfulStrongOnBallPressures: 'Количество успешных сильных давлений на мяч (в пределах 0-2 метров)',
      SuccessfulLightOnBallPressures: 'Количество успешных давлений на мяч (в пределах 2-4 метров)',
      StrongOnBallPressuresPct: 'Процент успешных и общих сильных давлений на мяч (в пределах 0-2 метров от ближайшего соперника)',
      LightOnBallPressuresPct: 'Процент успешных и общих давлений на мяч (в пределах 2-4 метров от ближайшего соперника)',
      TimesBypassedByPasses: 'Общее количество раз, обойденных передачей',
      TimesBypassedByCarries: 'Общее количество раз, обойденных ведением',
      TimesBypassedByActions: 'Общее количество раз, обойденных передачей и ведением вместе',
      BypassedPlayersByCarries: 'Общее количество соперников (защитников и полузащитников), обойденных ведениями',
      BypassedDefendersByCarries: 'Общее количество соперников (защитников), обойденных ведениями',
      BypassedPlayersByActions: 'Общее количество соперников (защитников и полузащитников), обойденных передачами и ведениями вместе',
      BypassedDefendersByActions: 'Общее количество соперников (защитников), обойденных передачами и ведениями вместе',
      CarriesBypassingPlayers: 'Количество ведений, которые обошли игроков',
      CarriesBypassingDefenders: 'Количество ведений, которые обошли защитников',
      BypassedPlayersPerCarry: 'Среднее количество обойденных соперников за ведение (не менее 7 метров)',
      BypassedDefendersPerCarry: 'Среднее количество обойденных защитников за ведение (не менее 7 метров)',
      LineBreakingCarries: 'Количество ведений, которые успешно проникают через одну или более защитных линий',
      LineBreakingCarriesMD: 'Количество ведений, которые успешно проникают через линии полузащиты и защиты',
      LineBreakingCarriesM: 'Количество ведений, которые успешно проникают через линию полузащиты',
      LineBreakingCarriesD: 'Количество ведений, которые успешно проникают через защитную линию',
      LineBreakingCarriesPerCarry: 'Процент ведений, прорывающих линии, за ведение',
      LineBreakingActions: 'Количество передач и ведений вместе, которые успешно проникают через одну или более защитных линий',
      LineBreakingActionsMD: 'Количество передач и ведений вместе, которые успешно проникают через линии полузащиты и защиты',
      LineBreakingActionsM: 'Количество передач и ведений вместе, которые успешно проникают через линию полузащиты',
      LineBreakingActionsD: 'Количество передач и ведений вместе, которые успешно проникают через защитную линию',
      PassesPerLineBreakingPass: 'Соотношение между общим количеством передач за передачу, прорывающую линии',
      CarriesPerLineBreakingCarry: 'Соотношение между общим количеством ведений за ведение, прорывающее линии',
      LinesBrokenByPasses: 'Общее количество линий, прорванных передачами',
      LinesBrokenByCarries: 'Общее количество линий, прорванных ведениями',
      LinesBrokenByActions: 'Общее количество линий, прорванных передачами и ведениями вместе',
      LinesBrokenPerPass: 'Соотношение между общим количеством прорванных линий за передачу',
      LinesBrokenPerCarry: 'Соотношение между общим количеством прорванных линий за ведение',
      AvgLastDefenderDistanceIP: 'Дистанция между последним защитником (ближайшим к своим воротам) и линией ворот во владении',
      AvgLastDefenderDistanceOOP: 'Дистанция между последним защитником (ближайшим к своим воротам) и линией ворот без владения',
      AvgDefensiveLineDistanceIP: 'Дистанция между позицией самой глубокой защитной линии и воротами во владении',
      AvgDefensiveLineDistanceOOP: 'Дистанция между позицией самой глубокой защитной линии и воротами без владения',
      AvgRBDistanceIP: 'Дистанция от правого защитника до своих ворот во владении',
      AvgRBDistanceOOP: 'Дистанция от правого защитника до своих ворот без владения',
      AvgLBDistanceIP: 'Дистанция от левого защитника до своих ворот во владении',
      AvgLBDistanceOOP: 'Дистанция от левого защитника до своих ворот без владения',
      AvgBlockDistanceIP: 'Дистанция между самым глубоким и самым продвинутым полевым игроком во владении',
      AvgBlockDistanceOOP: 'Дистанция между самым глубоким и самым продвинутым полевым игроком без владения',
      AvgBlockAreaIP: 'Площадь ограничивающего прямоугольника вокруг всех полевых игроков (мера того, сколько пространства занимает команда) во владении',
      AvgBlockAreaOOP: 'Площадь ограничивающего прямоугольника вокруг всех полевых игроков (мера того, сколько пространства занимает команда) без владения',
      AvgDefensiveLineWidthOOP: 'Ширина самой задней линии игроков (самой далекой от своих ворот) без владения',
      AvgOffensiveLineLastThirdWidthIP: 'Горизонтальная ширина атакующей линии в последней трети во владении',
      AvgLByIP: 'Позиция левого защитника во владении',
      AvgRByIP: 'Позиция правого защитника во владении',
      AvgOffensiveLineDistanceIP: 'Дистанция между своими воротами и атакующей линией во владении',
      AvgOffensiveLineLastThirdDistanceIP: 'Дистанция между своими воротами и атакующей линией в последней трети во владении',
      AvgOffensiveLineWidthIP: 'Горизонтальная ширина атакующей линии во владении',
      OffBallRuns: 'Намеренные безмячевые движения (пробежки) для поддержки атакующей фазы',
      OffBallRunsOverlap: 'Пробежки, где игрок движется вокруг внешней стороны товарища по команде (ближе к боковой линии), пока этот товарищ владеет мячом',
      OffBallRunsUnderlap: 'Пробежки, где игрок движется внутри товарища по команде, выбирая внутренний маршрут (ближе к центру поля)',
      OffBallRunsRunAhead: 'Пробежка вперед, которая идет дальше владельца мяча, но остается впереди последнего защитника',
      OffBallRunsRunBehind: 'Пробежка вперед, которая прорывается в последнюю защитную линию, попадая между защитниками и вратарем',
      OffBallRunsCrossReceiver: 'Игрок вбегает в штрафную и позиционируется для получения навеса от товарища по команде',
      OffBallRunsSupport: 'Игрок бежит, чтобы выровняться с владельцем мяча, предлагая близкий вариант передачи в атаке',
      OffBallRunsComingShort: 'Игрок движется к владельцу мяча, чтобы предложить близкую поддержку или вариант передачи от ворот',
      AerialsOppHalf: 'Успешные верховые единоборства в половине соперника',
      CarriesIntoFinalThird: 'Трубопроводы длиной не менее 7 метров снаружи внутрь последней трети',
      DribblesAttempted: 'Количество попыток ведения мяча',
      SpeedScore: 'Физические показатели игрока на основе различных показателей скорости',
      EnduranceScore: 'Физические показатели выносливости игрока на основе различных показателей',
      GoalsConceded: 'Количество пропущенных голов',
      HeadedGoals: 'Количество голов, забитых головой',
      SavesInBox: 'Количество сейвов от ударов внутри штрафной',
      SavesOutBox: 'Количество сейвов от ударов из-за пределов штрафной',
      ShotsOnTargetInBoxAgainst: 'Количество пропущенных ударов в створ из штрафной',
      ShotsOnTargetOutBoxAgainst: 'Количество пропущенных ударов в створ из-за пределов штрафной',
      SwitchPlaySuccessful: 'Количество завершенных передач на расстояние более 32 метров, при которых боковое смещение мяча превышает его смещение в сторону ворот соперника.',
      SwitchPlayTotal: 'Общее количество попыток передач на расстояние более 32 метров, при которых боковое смещение мяча превышает его смещение в сторону ворот соперника.',
      PassesInsideOppHalf: 'Общее количество передач, которые начинаются и заканчиваются на половине поля соперника',
      PassesInsideOppHalfSuccessful: 'Количество завершенных передач, которые начинаются и заканчиваются на половине поля соперника',
      TacklesAttemptedFirstThird: 'Общее количество попыток отбора мяча в первой трети поля',
      TacklesAttemptedSecondThird: 'Общее количество попыток отбора мяча во второй трети поля',
      TacklesFirstThird: 'Количество успешных отборов мяча, выполненных в первой трети поля',
      TacklesSecondThird: 'Количество успешных отборов мяча, выполненных на второй трети поля',
      FoulsOwnHalf: 'Количество нарушений, совершенных на своей половине поля',
      TouchesOppHalf: 'Количество касаний мяча на половине поля противника',
      TacklesAttemptedNotAdjusted: 'Общее количество попыток отбора мяча без учета владения мячом',
      TacklesSuccessfulNotAdjusted: 'Общее количество успешных отборов мяча без учета владения мячом',
      AvgTop5MaxSpeed: 'Среднее из пяти самых высоких максимальных скоростей игрока',
      LBPReceived: 'Количество полученных проходов с нарушением линии',
      LBPMReceived: 'Количество полученных передач с прорывом через линию полузащиты соперника',
      LBPMDReceived: 'Количество полученных передач, прорывающих как полузащиту, так и линию защиты соперника',
      ThroughBallReceived: 'Количество полученных передач, прорвавших последнюю линию обороны противника',
      ShortPassesSuccessful: 'Количество выполненных коротких передач (менее 12 метров)',
      PassingSuccessForwardPct: 'Процент успешных передач вперед',
      PassingSuccessBackwardPct: 'Процент успешных передач назад',
      PassingForwardBackwardPct: 'Соотношение передач вперед и передач назад',
      LongBallPerPassesPct: 'Процент длинных передач по отношению к общему количеству передач',
      LongBallReceivedOppHalf: 'Количество длинных мячей, полученных на поле соперника',
      OffensiveActions: 'Наступательные действия',
      SuccessfulDribblesPct: 'Успешные попытки ведения/общее количество попыток ведения',
      OffensiveTouchesOutBoxPct: '% атакующих касаний за пределами штрафной',
      HsrDistanceIP: 'Спринтерская дистанция >21 км/ч при владении мячом.',
      HsrDistanceOOP: 'Спринтерская дистанция >21 км/ч без владения мячом.',
      JoggingDistanceIP: 'Расстояние бега во владении мячом',
      JoggingDistanceOOP: 'Беговая дистанция без владения мячом',
      RunningDistanceIP: 'Беговая дистанция владения мячом',
      RunningDistanceOOP: 'Беговая дистанция без владения мячом',
      SprintsDistanceIP: 'Спринтерская дистанция >24 км/ч при владении мячом.',
      SprintsDistanceOOP: 'Спринтерская дистанция >24 км/ч без владения мячом.',
      WalkingDistanceIP: 'В шаговой доступности во владении',
      WalkingDistanceOOP: 'В нескольких минутах ходьбы от владения'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'КАУ',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'ПТОХ',
      PassesOwnHalf: 'ПОХ',
      PassesTotalOppHalf: 'ПТОПФ',
      ProgressivePassesTotal: 'ТЭС',
      DuelsWon: 'ДВ',
      NonPenaltySaves: 'НПС',
      BadActionsOppHalf: 'БАОПФ',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'СОТОБ',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'ХГ',
      GoalsConceded: 'ГК',
      SavesInBox: 'СИБ',
      SavesOutBox: 'СОБ',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP%',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR'
    },
    AerialsOppHalf: 'Верховые половина соперника',
    CarriesIntoFinalThird: 'Едет до последней ⅓',
    scoreDifference: 'Разница в счете: показывает, была ли результативность в этой игре выше или ниже среднего показателя сезона.',
    SpeedScore: 'Оценка скорости и мощности',
    EnduranceScore: 'Оценка выносливости',
    HeadedShots: 'Удары головой',
    HeadedXG: 'Во главе xG',
    HeadedSetPieceTooltip: 'Показаны только игроки, забившие головой со стандартов.',
    SwitchPlaySuccessful: 'Переключить игру успешно',
    SwitchPlayTotal: 'Переключить игру Всего',
    PassesInsideOppHalf: 'Проходит внутрь Opp Half',
    PassesInsideOppHalfSuccessful: 'Проходит внутрь Opp наполовину успешно',
    TacklesAttemptedFirstThird: 'Первая попытка отбора мяча ⅓',
    TacklesAttemptedSecondThird: 'Попытка отбора мяча, вторая ⅓',
    TacklesFirstThird: 'Успешный отбор первым ⅓',
    TacklesSecondThird: 'Успешный отбор второго ⅓',
    FoulsOwnHalf: 'Нарушения на своей половине поля',
    TouchesOppHalf: 'Касается OPP Half',
    TacklesAttemptedNotAdjusted: 'Попытка отбора мяча не отрегулирована',
    TacklesSuccessfulNotAdjusted: 'Отборы успешные, не скорректированные',
    AvgTop5MaxSpeed: 'Средняя скорость Top5 MaxSpeed',
    LBPReceived: 'Получены передачи на разрыв линии',
    LBPMReceived: 'Получены передачи на разрыв линии (линия M)',
    LBPMDReceived: 'Получены передачи на разрыв линии (линия MD)',
    ThroughBallReceived: 'Полученные мячи вразрез',
    recoveriesRate: 'Коэффициент восстановления',
    turnoversRate: 'Коэффициент потерь',
    HsrDistanceIP: 'Расстояние HSR IP',
    HsrDistanceOOP: 'Расстояние HSR ООП',
    JoggingDistanceIP: 'Расстояние бега IP',
    JoggingDistanceOOP: 'Дистанция бега ООП',
    RunningDistanceIP: 'Дистанция бега IP',
    RunningDistanceOOP: 'Беговая дистанция ООП',
    SprintsDistanceIP: 'Спринтерская дистанция IP',
    SprintsDistanceOOP: 'Спринтерская дистанция ООП',
    WalkingDistanceIP: 'IP-адрес в шаговой доступности',
    WalkingDistanceOOP: 'Пешком ООП'
  },
  team: {
    title: 'Состав команды',
    subtitle: 'Углубитесь в характеристики и статистику команды',
    averageAge: 'Средний возраст',
    transferBalance: 'Трансферный баланс',
    roster: 'Состав',
    stadium: 'Стадион',
    coach: 'Тренер',
    transfers: 'Трансферы',
    trends: 'Тренды',
    loans: 'Аренды',
    loanFrom: 'Аренда из',
    loanTo: 'Аренда в',
    latestGames: 'Последние матчи',
    latestXGames: 'Последние {0} матчей',
    playingFor: 'Играет за',
    overview: 'Обзор',
    visualization: 'Визуализация',
    location: 'Местоположение',
    outcome: 'Результат',
    beeswarm: 'Рейтинг',
    parentTeam: 'Основная команда',
    childTeam: 'Молодежная команда',
    preferredFormation: 'Предпочитаемая расстановка',
    mostFrecuentFormations: 'Наиболее частые расстановки',
    viewType: 'Тип отображения',
    overviewTab: {
      axisXTotal: 'Всего',
      axisXper90: 'За 90\'',
      dataPerGameText: 'Данные за матч',
      season: 'Сезон',
      last: 'Последний',
      current: 'Текущий',
      TeamStyle: 'Стиль',
      TeamDefensive: 'Защитный',
      TeamOffensive: 'Атакующий',
      TeamCustom1: 'Пользовательский 1',
      TeamCustom2: 'Пользовательский 2',
      TeamCustom3: 'Пользовательский 3',
      TeamCustom4: 'Пользовательский 4',
      coach: 'Тренер',
      groups: {
        Goals: {
          name: 'Голы',
          desc: 'Показывает голы с пенальти и без пенальти (в открытую и со стандартов).'
        },
        Assists: {
          name: 'Передачи',
          desc: 'Игроки с наибольшим количеством передач (в открытую и со стандартов) в этом сезоне.'
        },
        xG: {
          name: 'Ожидаемые голы',
          desc: 'Ожидаемые голы в открытую и со стандартов'
        },
        xA: {
          name: 'Ожидаемые передачи',
          desc: 'Ожидаемые передачи в открытую и со стандартов.'
        },
        Finishing: {
          name: 'Завершение',
          desc: 'Процент ударов, заканчивающихся голом.'
        },
        ScoringContribution: {
          name: 'Вклад в голы',
          desc: 'Количество передач и голов команды.'
        },
        xT: {
          name: 'Ожидаемая угроза',
          desc: 'Ожидаемая угроза, созданная в открытую, со стандартов и отрицательная xT.'
        }
      },
      stats: {
        openPlay: 'Игра в открытую',
        setPiece: 'Стандарт',
        negative: 'Отрицательная',
        npg: 'Голы без пенальти',
        goalsPenalty: 'Голы с пенальти',
        npgOpenPlay: 'Голы без пенальти игра в открытую',
        npgSetPiece: 'Голы без пенальти со стандартов',
        assists: 'Передачи',
        assistsConceded: 'Пропущенные передачи',
        assistsOpenPlay: 'Передачи игра в открытую',
        assistsSetPiece: 'Передачи со стандартов',
        xGOpenPlay: 'xG игра в открытую',
        xGSetPiece: 'xG со стандартов',
        xAOpenPlay: 'xA игра в открытую',
        xASetPiece: 'xA со стандартов',
        xAConceded: 'Пропущенные xA',
        nonPenaltyShots: 'Удары без пенальти',
        penaltyShots: 'Удары с пенальти',
        xT: 'Ожидаемая угроза',
        xTOpenPlay: 'xT игра в открытую',
        xTSetPiece: 'xT со стандартов',
        xTNeg: 'Отрицательная xT',
        totalFinishing: 'Завершение',
        nonPenaltyFinishing: 'Завершение без пенальти',
        goalsPenaltyFinishing: 'Завершение с пенальти',
        goal: 'Гол',
        notGoal: 'Не гол',
        chance: 'Момент',
        finished: 'Завершено',
        notFinished: 'Не завершено',
        walkingDistance: 'Ходьба',
        joggingDistance: 'Бег трусцой',
        runningDistance: 'Бег',
        hsrDistance: 'HSR',
        sprintsDistance: 'Спринт',
        runningNumber: 'Пробежки',
        hsrNumber: 'HSR Спринты',
        sprintsNumber: 'Спринты',
        maxSpeed: 'Макс. Скорость',
        accelerations: 'Ускорения',
        extremeAccelerations: 'Экстремальные ускорения',
        maxAcceleration: 'Максимальное ускорение'
      }
    },
    teamAnalysis: 'Анализ команды',
    agentView: {
      positions: {
        gk: 'ВР',
        leftFullback: 'ЛЗ',
        centralDefender: 'ЦЗ',
        rightFullback: 'ПЗ',
        midfielder: 'Полузащитник',
        attackingMidfielder: 'Атак. полузащитник',
        leftWinger: 'Левый вингер',
        rightWinger: 'Правый вингер',
        fw: 'НП'
      },
      groups: {
        contractEnd: 'Месяцы',
        age: 'Лет',
        availability: 'Доступность'
      },
      placer: {
        legend: 'Сила на основе возраста, контракта, доступности и производительности'
      }
    },
    transfersTab: {
      valueMovements: 'Стоимость движений',
      valueTransfers: 'Стоимость трансферов',
      valueLoans: 'Стоимость аренд',
      avgAgeMovements: 'Средний возраст движений',
      avgAgeTransfers: 'Средний возраст трансферов',
      avgAgeLoans: 'Средний возраст аренд',
      operations: {
        buys: {
          buy: 'Покупка',
          loan: 'Аренда',
          'end of loan': 'Окончание аренды',
          'free transfer': 'Свободный агент',
          free: 'Свободный агент',
          'loan transfer': 'Аренда',
          other: 'Другое'
        },
        sells: {
          buy: 'Продажа',
          loan: 'Аренда',
          'end of loan': 'Окончание аренды',
          'free transfer': 'Свободный агент',
          free: 'Свободный агент',
          'loan transfer': 'Аренда',
          other: 'Другое',
          retired: 'Завершил карьеру'
        }
      }
    },
    trendsTab: {
      streaks: 'Серии',
      wins: 'Победы',
      cleanSheets: 'Сухие матчи',
      goalPeriods: 'Периоды забитых голов',
      concededGoalPeriods: 'Периоды пропущенных голов',
      comebacks: 'Возвращения',
      avgTime: 'Среднее время',
      kindOfGoals: 'Тип голов',
      percentWinning: '% Побед',
      percentDrawing: '% Ничьих',
      percentLosing: '% Поражений',
      totalOf: 'Всего',
      minutes: 'минут',
      before: 'До',
      after: 'После',
      playedOn: 'Играли на',
      scored: 'Забито',
      conceded: 'Пропущено',
      ownGoals: 'Автоголы',
      phasesOfGame: 'Фазы игры',
      intensityLabel: 'Интенсивность зоны',
      intensityByTeam: 'По команде %',
      intensityByLeagueAvg: 'По среднему лиги %',
      buildup: 'Построение',
      midfieldProgression: 'Прогрессия в центре',
      attackOpposition: 'Атака соперника',
      attackingTransition: 'Атакующий переход',
      highPress: 'Высокий прессинг',
      midBlock: 'Средний блок',
      lowBlock: 'Низкий блок',
      defensiveTransition: 'Защитный переход',
      draws: 'Ничья',
      losts: 'Поражение',
      chokes: 'Провал',
      zoneTooltip: 'Определяет критерии, используемые для цветового градиента каждого блока:',
      teamPctTooltip: 'На основе процента общего времени, сыгранного командой в каждой зоне.',
      leagueAvgPctTooltip: 'Сравнивает процент команды со средним показателем по лиге для каждой зоны.',
      leagueAvgMinsTooltip: 'Применяет те же критерии сравнения с лигой, но оценивает общее время в минутах, а не в процентах.',
      losses: 'Потери',
      results: 'Результаты',
      kindOfConcededGoals: 'Типы пропущенных голов',
      showMinutes: 'Показать минуты'
    },
    onOff: 'В игре/Вне игры',
    dragUpToXPlayers: 'Перетащите до {x} игроков',
    selectUpToXPlayers: 'Выберите до {x} игроков',
    onOffTab: {
      G90: 'Голы 90',
      GA90: 'Пропущенные голы 90',
      diffG90: 'Разница голов 90',
      XG90: 'xG 90',
      XGA90: 'xG пропущено 90',
      diffXG90: 'Разница xG 90',
      playersOn: 'Комбо В ИГРЕ',
      playersOff: 'Комбо ВНЕ ИГРЫ',
      ground: 'Поле',
      playersOnThePitch: 'Игроки на поле',
      playersOffThePitch: 'Игроки вне поля',
      attackTitle: 'Атака',
      attackSubTitle: 'Атакующая статистика',
      defenseTitle: 'Защита',
      defenseSubTitle: 'Защитная статистика',
      associationTitle: 'Ассоциация',
      associationSubTitle: 'Ассоциативная статистика',
      comboOn: 'Активное комбо',
      comboOff: 'Любое другое',
      diffGoals90: 'Разница голов 90',
      goals90: 'Голы без пенальти 90',
      goalsAgainst90: 'Пропущенные голы без пенальти 90',
      xgAgainstPer90: 'xG пропущено 90',
      xgDiffPer90: 'Разница xG 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Удары в створ 90',
      touchesOppBox90: 'Касания штрафная соперника 90',
      shotsOnTargetAgainst90: 'Пропущенные удары в створ 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Прямолинейность 90',
      possession: 'Владение %',
      pctPasses: 'Передачи %',
      pctPassesFinalThird: 'Передачи финальная треть %',
      placeholder: 'Начните с выбора команды',
      subtitle: 'Оптимизируйте метрики команды, добавляя или удаляя игроков из состава'
    },
    terms: {
      short: 'Краткосрочный',
      mid: 'Среднесрочный',
      long: 'Долгосрочный'
    },
    report: {
      title: 'Отчет команды',
      selectedPeriod: 'Выбранный период',
      stackedCharts: 'Сложенные графики',
      radars: 'Радары',
      generalData: 'Общие данные',
      scoringChances: 'Голевые моменты',
      areasReport: 'Отчет по зонам',
      setPieceReport: 'Отчет по стандартам',
      corners: 'Угловые',
      cornersAgainst: 'Угловые пропущено',
      indirectFreeKicks: 'Непрямые штрафные',
      indirectFreeKicksAgainst: 'Непрямые штрафные пропущено',
      freeKicks: 'Штрафные',
      freeKicksAgainst: 'Штрафные пропущено',
      penaltys: 'Пенальти',
      freeKicksContribution: 'Вклад штрафных',
      shotsContribution: 'Вклад ударов',
      topXPlayersByStats: 'Топ {x} игроков по статистике',
      lastShotZone: 'Последняя зона удара',
      throwSide: 'Сторона вбрасывания',
      kindOfThrow: 'Тип вбрасывания',
      scored: 'Забито',
      against: 'Пропущено',
      perGame: 'за матч',
      total: 'Всего',
      efficiency: 'Эффективность',
      organizedAttack: 'Организованная атака',
      offTransition: 'Атакующий переход',
      chances: 'Моменты',
      chancesScored: 'Моменты забито',
      chancesAgainst: 'Моменты пропущено',
      goalsScored: 'Голы забито',
      goalsAgainst: 'Голы пропущено',
      goalsOrganizedAttack: 'Голы организованная атака',
      goalsOffTransition: 'Голы атакующий переход',
      goalsSetPiece: 'Голы со стандартов',
      goalsOrganizedAttackScored: 'Голы орг. атака забито',
      goalsOrganizedAttackAgainst: 'Голы орг. атака пропущено',
      goalsOffTransitionScored: 'Голы атак. переход забито',
      goalsOffTransitionAgainst: 'Голы атак. переход пропущено',
      goalsSetPieceScored: 'Голы со стандартов забито',
      goalsSetPieceAgainst: 'Голы со стандартов пропущено',
      crossSide: 'Сторона навеса',
      externalShot: 'Внешний удар',
      innerPlay: 'Внутренняя игра',
      throwIn: 'Вбрасывание',
      box: 'Штрафная',
      zone2: 'Зона 2',
      goalsPerPhases: 'Голы по фазам'
    },
    minutesAlert: '*Показываются только игроки с 450 или более сыгранными минутами',
    minutesException: 'Нет игроков с 450 или более сыгранными минутами. Показываются все игроки',
    analysis: 'Анализ',
    substitutions: 'Замены',
    attackZones: 'Атакующие зоны',
    formations: 'Расстановки',
    shotZones: 'Зоны ударов',
    crossings: 'Навесы',
    byTime: 'По времени',
    byPosition: 'По позиции',
    byPlayer: 'По игроку',
    W: 'Победа',
    D: 'Ничья',
    L: 'Поражение',
    substitutionsByGame: 'Замены по матчам',
    substitutionsShort: 'Замены',
    avgSeasonShort: 'Сред. сезон',
    startingAt: 'Начало в',
    endingAt: 'Окончание в',
    startingAtInfo: 'Показывает долю владений на основе местоположения первого события',
    endingAtInfo: 'Показывает долю владений на основе местоположения последнего события',
    endingWithShot: 'Заканчивается ударом',
    endingInBox: 'Заканчивается в штрафной',
    pfX: 'ПФ {x}',
    bySide: 'По стороне',
    cornerKicks: 'Угловые',
    included: 'Включено',
    excluded: 'Исключено',
    onlyCorner: 'Только угловые',
    sizeByMarketValue: 'Размер по рыночной стоимости',
    timeInTeam: 'Сезонов в команде',
    newSignings: 'Новые подписания',
    sizeBy: 'Размер по',
    connections: 'Связи',
    assistant: 'Отдающий',
    finisher: 'Завершающий',
    playersMinutesAlert: 'Показываются только игроки с сыгранными минутами в выбранном сезоне',
    strategyFilterTooltip: 'Отображение событий, произошедших во время стандартных положений или во время открытой игры.',
    sideFilterTooltip: 'Отображать только те стандартные положения, которые начинаются с выбранной стороны (слева или справа).',
    teamMinutesAlert: '*Показаны только команды, сыгравшие 450 и более минут.',
    homeCoach: 'Домашний тренер',
    awayCoach: 'Выездной тренер'
  },
  leagueTable: {
    subtitle: 'Проверьте, как идут лиги'
  },
  leagueMatchdays: {
    byRound: 'По туру',
    byDate: 'По дате',
    byTeam: 'По команде'
  },
  teamStats: {
    subtitle: 'Сравните, как выступают команды',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Разница между ожидаемыми голами и голами',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Разница между ожидаемыми очками и очками',
    games: 'ИГР',
    gamesExplicit: 'Сыграно матчей',
    pointsPerGame: 'ОЗМ',
    pointsPerGameExplicit: 'Очки за матч'
  },
  roles: {
    ROLE_USER: 'Пользователь',
    ROLE_ADMIN: 'Администратор',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Physical Data',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Легко извлекайте информацию об игроках, командах, матчах и лигах в формате JSON.',
    ROLE_EVENTING_DATA_description: 'Погрузитесь в статистику с помощью радарных графиков, рейтингов игроков, карт и многого другого на основе более 100 метрик производительности.',
    ROLE_PHYSICAL_DATA_description: 'Получайте доступ к данным о физической форме и фильтруйте игроков по различным метрикам производительности (дистанция, скорость, спринты, ускорение…).',
    ROLE_VIDEO_description: 'Предоставляйте видео и составы и получайте матчи с тегами событий и статистики для глубокого анализа.',
    ROLE_DRIBLAB_HUB_description: 'Эффективно отслеживайте и управляйте задачами скаутинга с помощью календарей, заметок, уведомлений и обмена документами.',
    ROLE_TRACKING_description: 'Получайте позиционные данные всех игроков в матче через наш API для комплексного анализа.',
    ROLE_ARRIGO_description: 'Объединяйте данные событий и отслеживания в инновационные метрики, которые выходят за рамки традиционных и добавляют ценность каждому действию.',
    ROLE_REPORTS_description: 'Запрашивайте подробные отчеты скаутинга от нашей команды аналитиков, чтобы найти идеальную команду или игрока.',
    ROLE_RAW_EVENTING: 'Сырое троеборье'
  },
  administration: {
    pageSubtitle: 'Управление работой приложения',
    newClient: 'Новый клиент',
    clientDuplicateName: 'Клиент с таким именем уже существует. Выберите его в списке и используйте «Новый пользователь», чтобы добавить пользователей этому клиенту.',
    newUser: 'Новый пользователь',
    editClient: 'Редактировать клиента',
    editUser: 'Редактировать пользователя',
    clientName: 'Имя',
    permissions: 'Разрешения',
    releaseUser: 'Освободить пользователя',
    connectAsUser: 'Подключиться как пользователь',
    releaseModalTitle: 'Подтверждение освобождения пользователя',
    releaseModalMessage: 'Пользователь получит электронное письмо о своем новом аккаунте. Вы уверены, что хотите уведомить его?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Команда',
      Brand: 'Бренд',
      Federation: 'Федерация',
      Media: 'Медиа',
      Agency: 'Агентство',
      Individual: 'Частное лицо'
    },
    userType: {
      Ownership: 'Владелец',
      SportingDirector: 'Спортивный директор',
      Brand: 'Бренд',
      Federation: 'Федерация',
      Media: 'Медиа',
      Agency: 'Агентство',
      Individual: 'Частное лицо',
      Scout: 'Скаут',
      Coach: 'Тренер',
      supervision: {
        title: 'Иерархия надзора',
        subtitle: 'Надзор осуществляется только вниз. Надзор на одном уровне не допускается.',
        supervisesLowerLevels: 'Руководит всеми нижеуказанными должностями',
        ruleNoSameLevel: 'Роли на одном уровне не могут контролировать друг друга.',
        ruleOnlyDownwards: 'Надзор разрешен только от более высоких должностей к более низким.',
        ruleLevel3NoSupervision: 'Самый низкий уровень не имеет разрешений на надзор.',
        currentUserType: 'Ваш текущий тип пользователя'
      }
    },
    visibleYears: 'Видимые годы',
    areaModalTitle: 'Подтверждение активации/деактивации лиг',
    areaModalMessage: 'Вы уверены, что хотите активировать/деактивировать все лиги из выбранной области?',
    countStats: 'Подсчет статистики',
    userClientModalTitle: 'Пользователь уже существует в другом клиенте',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Контракт',
    contracts: 'Контракты',
    invoiceName: 'Имя для счета',
    contractFee: 'Стоимость контракта',
    renewal: 'Продление',
    consultancy: 'Консультация',
    deleteContract: 'Удалить контракт клиента',
    deleteContractMessage: 'Контракт будет удален навсегда. Вы уверены?',
    activeVsHired: 'Активные vs Нанятые',
    requestedVsHired: 'Запрошенные vs Нанятые',
    activeVsHiredWithPlaceholder: '{0} Активен против {1} Нанят',
    requestedVsHiredWithPlaceholder: '{0} Запрошен и {1} Нанят',
    salesRepresentative: 'Торговый представитель',
    periodicities: {
      periodicity: 'Периодичность',
      annual: 'Ежегодно',
      biannual: 'Раз в два года',
      quarterly: 'Ежеквартально',
      monthly: 'Ежемесячно',
      bimonthly: 'Раз в два месяца',
      onePayment: 'Одноразовый платеж',
      fourmonthly: 'Каждые четыре месяца'
    },
    paymentMethods: {
      payment: 'Платеж',
      method: 'Метод',
      transfer: 'Перевод',
      mandate: 'Мандат'
    },
    marketingOptions: {
      marketing: 'Маркетинг',
      socialMediaAdd: 'Реклама в социальных сетях',
      videoWithFeedback: 'Видео с обратной связью'
    },
    status: {
      status: 'Статус',
      pending: 'В ожидании',
      active: 'Активный',
      expiringSoon: 'Скоро истекает',
      expired: 'Истек',
      expiringSoonWithDays: 'Срок действия контракта скоро истекает: осталось {0} дней'
    },
    updates: {
      roleAdded: '<b>{0}</b> добавил роль <b>{1}</b> для <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> удалил роль <b>{1}</b> у <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> добавил <b>{1}</b> в лигу <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> удалил <b>{1}</b> из лиги <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> добавил <b>{1}</b> в сезон <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> удалил <b>{1}</b> из сезона <b>{2}</b>.',
      updateNotesPlaceholder: 'Пожалуйста, включите некоторый контекст для изменения или добавьте любые соответствующие заметки здесь...',
      updates: 'Обновления',
      products: 'Продукты'
    },
    clients: 'Клиенты',
    trials: 'Испытания',
    activeClients: 'Активные клиенты',
    activeTrials: 'Активные пробные версии',
    activeTrialUsers: 'Активные пробные пользователи',
    activeContracts: 'Активные контракты',
    expiration: 'Срок действия',
    clientWarnings: {
      activeContractInactiveClient: 'Клиенты с активными контрактами, но без активированных пользователей',
      activeContractTrialUsers: 'Клиенты с пробными пользователями при активном договоре',
      activeUsersWithoutContract: 'Клиенты с активными пользователями, не использующими пробную версию, но без активного контракта',
      upcomingExpirations: 'Предстоящие истечения срока действия',
      renewedContracts: 'Клиенты по продленным договорам',
      clientsWithWarnings: 'Клиенты, требующие внимания',
      enabledUsersWithoutContract: '«Включены пользователи без пробной версии без активного контракта»',
      trialUsersWithContract: 'Пользователи в пробном режиме, несмотря на активный контракт',
      activeContractInactiveUsers: 'У клиента есть активный контракт, все пользователи неактивны.',
      activeContract: 'У этого клиента действующий договор',
      noEnabledUsers: 'У этого клиента нет активированных пользователей',
      ongoingTrialInactiveUsers: 'Клиенты с продолжающейся пробной версией, но без включенных пользователей',
      neverLoggedIn: 'Клиенты, которые никогда не авторизовались'
    },
    daysLeft: 'Осталось дней',
    expiringSoon: 'Срок действия скоро истекает',
    loggedThisWeek: 'Зашел в систему на этой неделе',
    withWarnings: 'С предупреждениями',
    ofActiveClients: 'активных клиентов',
    endingIn30Days: 'закончится через 30 дней',
    neverLogged: 'никогда не входил в систему',
    ofActiveTrials: 'активных испытаний',
    activeClientsWithoutTrial: 'активные клиенты (кроме пробной версии)',
    renewals: 'Продление',
    ofActiveContracts: 'активных контрактов'
  },
  dashboards: {
    lastGame: 'Анализ последнего матча',
    lastGameSimple: 'Последний матч',
    seeAllGameInfo: 'Посмотреть всю информацию о матче',
    nextGame: 'Предпросмотр следующего матча',
    myTeam: 'Моя команда',
    lastMatchdayGames: 'Последний тур',
    lastAdded: 'Последние добавленные',
    myFavorites: 'Мои избранные',
    seeAllFavorites: 'Посмотреть все избранные',
    placeholderFavorites: 'Вы можете добавить избранные из деталей игрока',
    placeholderTeamFavorites: 'Вы можете добавить избранные из деталей команды',
    placeholderLeagueFavorites: 'Вы можете добавить избранные из деталей лиги',
    myCollections: 'Мои коллекции',
    placeholderCollections: 'У вас пока нет коллекций',
    lastCreated: 'Последние созданные',
    seeAllCollections: 'Посмотреть все коллекции',
    seeRival: 'Посмотреть соперника',
    seeMyTeam: 'Посмотреть мою команду',
    title: 'Обзор панели управления',
    subtitle: 'С возвращением',
    recentPlayers: 'Недавние игроки',
    lastScouted: 'Последние разведанные',
    scout: 'Разведка',
    reportsRequested: 'Отчеты',
    lastRequested: 'Последние запрошенные',
    goInbox: 'Перейти в почту',
    placeholderLastScouted: 'Вы можете искать игроков в левой панели или в инструменте разведки',
    placeholderReports: 'Вы можете запросить отчеты из деталей игрока',
    nationalPlayers: 'Самые ценные национальные игроки в других странах',
    lastGames: 'Последние матчи',
    nationalPlayersShort: 'Национальные игроки в других странах',
    nextMatchdayGames: 'Следующий тур',
    injuredPlayers: 'Травмированные игроки',
    atPresent: 'В настоящее время',
    seeAllPlayers: 'Посмотреть всех игроков',
    suspendedPlayers: 'Дисквалифицированные игроки',
    placeholderInjured: 'Нет травмированных игроков',
    teamValueImpacted: 'Стоимость команды затронута',
    placeholderSuspended: 'Нет дисквалифицированных игроков',
    placeholderNextGame: 'Нет доступного матча',
    placeholderNoGames: 'Пока нет доступных матчей',
    placeholderLastMatchDayNotFound: 'Последний тур недоступен',
    placeholderNextMatchDayNotFound: 'Следующий тур недоступен',
    usersMostSearch: 'Пользователи с наибольшим количеством поисков',
    lastTwoDays: 'Последние два дня',
    searchesHistory: 'История поисков',
    dayByDay: 'Ежедневно',
    activeUsersTitle: 'Активные пользователи',
    activeUsersSubtitle: 'Входили хотя бы раз в последний месяц',
    onlineUsersTitle: 'Онлайн пользователи',
    onlineUsersSubtitle: 'Искали что-то в последний час',
    searchesPerformed: 'Выполнено поисков',
    onlyClients: 'Только клиенты',
    activeClientsTitle: 'Активные клиенты',
    activeClientsSubtitle: 'Имеют хотя бы одного активного пользователя',
    last24Hours: 'Последние 24 часа',
    activityHistory: 'История активности',
    loginHistory: 'История доступа',
    failLogins: 'Неудачные входы',
    successLogins: 'Успешные входы',
    clientStats: 'Статистика клиентов',
    playersMostSearch: 'Игроки с наибольшим количеством поисков',
    toolsMoreUsed: 'Наиболее используемые инструменты',
    hotPlayers: 'Популярные игроки',
    last_month: 'Последний месяц',
    last_week: 'Последняя неделя',
    last_day: 'Последний день',
    nClients: 'Кол-во клиентов',
    userDashboard: 'Панель пользователя',
    userDashboardSubtitle: 'Сводка активности аккаунта',
    offlineDaysOfClient: 'Офлайн дни для каждого клиента',
    hideNoConnected: 'Скрыть не подключенных',
    onlyTrial: 'Только пробные клиенты',
    daysWithoutLogin: 'Дней без входа',
    trialDays: 'Пробные дни'
  },
  faq: {
    subtitle: 'Узнайте больше о том, что такое Driblab PRO',
    categories: {
      playerMetrics: 'Метрики игроков',
      teamMetrics: 'Метрики команд',
      positions: 'Позиции команды',
      tools: 'Инструменты',
      api: 'API',
      videos: 'Обучающие видео',
      playerPositions: 'Позиции игроков',
      userTypes: 'Типы пользователей'
    },
    positions: {
      GK: 'Вратарь',
      DR: 'Правый защитник / Правый фулбек (ПЗ)',
      DC: 'Центральный защитник / Центрбек (ЦЗ)',
      DL: 'Левый защитник / Левый фулбек (ЛЗ)',
      DMR: 'Правый вингбек (ПВБ)',
      DMC: 'Опорный полузащитник (ОПЗ)',
      DML: 'Левый вингбек (ЛВБ)',
      MR: 'Правый полузащитник (ППЗ)',
      MC: 'Центральный полузащитник (ЦПЗ)',
      ML: 'Левый полузащитник (ЛПЗ)',
      AMR: 'Правый атакующий полузащитник / Правый вингер (ПВ)',
      AMC: 'Центральный атакующий полузащитник / Атакующий полузащитник',
      AML: 'Левый атакующий полузащитник / Левый вингер (ЛВ)',
      FWR: 'Правый нападающий / Правый форвард (ПФ)',
      FW: 'Нападающий / Форвард (НП)',
      FWL: 'Левый нападающий / Левый форвард (ЛФ)'
    },
    metrics: {
      categories: {
        Association: 'Ассоциация',
        Saving: 'Спасения',
        Shooting: 'Удары',
        Defending: 'Защита',
        Passing: 'Передачи',
        BallHandling: 'Работа с мячом',
        Aerial: 'Игра в воздухе',
        Physical: 'Физика',
        Predictive: 'Прогнозирование',
        Arrigo: 'Arrigo',
        Score: 'Счет',
        Turnovers: 'Потери',
        Carries: 'Ведения',
        SequenceInvolvement: 'Участие в эпизодах',
        Crosses: 'Навесы',
        Distance: 'Дистанция',
        Sprint: 'Спринт',
        Acceleration: 'Ускорение',
        MaxAcceleration: 'Макс. ускорение',
        Speed: 'Скорость',
        OutPlay: 'Обводка',
        LineBreakingPasses: 'Проникающие передачи',
        LineBreakingCarries: 'Проникающие ведения',
        LineBreakingActions: 'Проникающие действия',
        PassUnderPressure: 'Передачи под давлением',
        BallReceived: 'Приемы мяча',
        PassesUnderPressure: 'проходит под давлением',
        OnBallPressureReceived: 'Давление на мяч получено',
        OnBallPressure: 'Давление на мяч',
        BallReceiptsInSpace: 'Приём мяча в пространстве',
        SpatialCoverage: 'Пространственное покрытие',
        OffBallPressure: 'Давление без мяча',
        OffBallRuns: 'Забегания без мяча',
        NoCategory: 'Другое',
        subcategories: {
          Quality: 'Качество',
          Quantity: 'Количество',
          TeamComparison: 'Сравнение команд',
          Receptions: 'Приемы',
          LongBalls: 'Длинные передачи',
          Efficiency: 'Эффективность',
          Ratio: 'Соотношение',
          Defensive: 'Защитный',
          Offensive: 'Атакующий',
          Foot: 'Нога',
          Progression: 'Прогрессия',
          TopValue: 'Топ значение',
          Predictive: 'Прогнозирование',
          Distance: 'Дистанция',
          Aerial: 'Игра в воздухе',
          Crosses: 'Навесы',
          NoCategory: 'Другое'
        },
        desc: {
          Association: 'Ассоциация',
          Saving: 'Спасения',
          Shooting: 'Удары',
          Defending: 'Защита',
          Passing: 'Передачи',
          BallHandling: 'Работа с мячом',
          Aerial: 'Игра в воздухе',
          Physical: 'Физика',
          Predictive: 'Прогнозирование',
          Arrigo: 'Arrigo',
          Score: 'Счет',
          Turnovers: 'Потери',
          Carries: 'Ведения',
          SequenceInvolvement: 'Участие в эпизодах',
          Crosses: 'Навесы',
          Distance: 'Дистанция, пройденная с разной скоростью',
          Sprint: 'Спринт с разной скоростью',
          Acceleration: 'Ускорение',
          Speed: 'Скорость, достигнутая игроками в какой-то момент матча',
          OutPlay: 'Обводка',
          LineBreakingPasses: 'Проникающие передачи',
          LineBreakingCarries: 'Проникающие ведения',
          LineBreakingActions: 'Проникающие действия',
          PassUnderPressure: 'Передачи под давлением',
          BallReceived: 'Приемы мяча',
          OnBallPressureReceived: 'Давление на мяч получено',
          OnBallPressure: 'Давление на мяч',
          BallReceiptsInSpace: 'Приём мяча в пространстве',
          SpatialCoverage: 'Пространственное покрытие',
          OffBallPressure: 'Давление без мяча',
          OffBallRuns: 'Забегания без мяча'
        },
        abbr: {
          Association: 'Ассоциация',
          Saving: 'Спасения',
          Shooting: 'Удары',
          Defending: 'Защита',
          Passing: 'Передачи',
          BallHandling: 'Работа с м.',
          Aerial: 'Игра в воздухе',
          Physical: 'Физика',
          Predictive: 'Прогнозирование',
          Arrigo: 'Arrigo',
          Score: 'Счет',
          Turnovers: 'ПОТ',
          Carries: 'Ведения',
          SequenceInvolvement: 'Участие в эп.',
          Crosses: 'Навесы',
          Distance: 'Дистанция',
          Sprint: 'Спринт',
          Acceleration: 'Ускорение',
          MaxAcceleration: 'Макс. ускорение',
          Speed: 'Скорость',
          OutPlay: 'Обводка',
          LineBreakingPasses: 'Проникающие передачи',
          LineBreakingCarries: 'Проникающие ведения',
          LineBreakingActions: 'Проникающие действия',
          PassUnderPressure: 'Передачи под давлением',
          BallReceived: 'Приемы мяча',
          OnBallPressureReceived: 'Давление на мяч получено',
          OnBallPressure: 'Давление на мяч',
          BallReceiptsInSpace: 'Приём мяча в пространстве',
          SpatialCoverage: 'Пространственное покрытие',
          OffBallPressure: 'Давление без мяча',
          OffBallRuns: 'Забегания без мяча'
        }
      },
      types: {
        1: 'За 90',
        2: 'Процент',
        3: 'Коэффициент',
        4: 'Эффективность',
        5: 'Среднее',
        6: 'За матч',
        7: 'Разница',
        8: 'Макс'
      },
      moreInfo: 'Вы можете прочитать больше здесь'
    },
    api: {
      subtitle: 'Получайте данные из различных запросов',
      resourcesTitle: 'Ресурсы',
      authentication: 'Аутентификация',
      authText: 'Для вызова API вы должны включить в каждый запрос заголовок `Authorization` со значением `Bearer {API_TOKEN}`',
      generate: 'Сгенерировать',
      tokenPlaceholder: 'Если у вас нет токена или он истек, нажмите \'Сгенерировать\'',
      pathParameters: 'Параметры пути',
      queryParameters: 'Параметры запроса',
      responseModel: 'Модель ответа',
      tokenWarning: '* Сгенерируйте токен для использования API',
      pathParamsWarning: '* Есть незаполненные параметры пути',
      genericDescription: 'API (Application Programming Interface) позволяет разработчикам получать доступ и интегрировать данные или функциональность в свои приложения. Наш API футбольной статистики предоставляет комплексный доступ к различным данным о странах, соревнованиях, командах, игроках, матчах и многом другом. Используя этот API, вы можете создавать приложения, использующие наши богатые футбольные данные для аналитики, визуализации или других инновационных решений.',
      methods: {
        getAllCountries: 'Этот метод получает полный список всех стран, доступных в API, предоставляя ключевые детали, такие как уникальный идентификатор и название каждой страны. Этот эндпоинт идеален для приложений, требующих географических футбольных данных, позволяя реализовать функции выбора страны, фильтрации и аналитики. Он также служит основным ресурсом для взаимодействия с другими эндпоинтами, зависящими от параметра `countryId`, обеспечивая плавную навигацию и интеграцию с более широким набором данных API.',
        getCountryDetail: 'Этот метод предоставляет подробную информацию о конкретной стране, доступной в API. Используя этот эндпоинт, вы можете получить данные, такие как название страны, код и любые соответствующие метаданные, связанные с ней. Этот метод особенно полезен для приложений, требующих специфических для страны деталей для улучшения пользовательского опыта, таких как отображение контекстной информации или создание персонализированных инсайтов на основе географических данных. Он дополняет другие эндпоинты, позволяя более глубокое исследование выбранной страны.',
        getCountryCompetitions: 'Этот метод получает список всех соревнований, доступных в конкретной стране. Это ценный ресурс для создания функций, позволяющих пользователям исследовать соревнования по регионам, обеспечивая бесшовный способ связи данных страны с связанными турнирами. Этот эндпоинт необходим для приложений, ориентированных на локализованный футбольный контент или региональную аналитику.',
        getAllCompetitionTypes: 'Этот метод возвращает список всех типов соревнований, доступных в API, таких как лиги, кубки и международные турниры. Этот эндпоинт идеален для категоризации соревнований и предоставления пользователям организованного представления различных типов покрываемых событий. Он особенно полезен для создания функций, таких как фильтры или выпадающие списки, которые позволяют пользователям исследовать футбольные данные на основе характера соревнования.',
        getAllCompetitions: 'Этот метод получает полный список всех соревнований, доступных в API, независимо от типа или местоположения. Этот эндпоинт полезен для приложений, которым необходимо отображать или анализировать широкий спектр футбольных соревнований, позволяя пользователям исследовать и выбирать интересующие события.',
        getCompetitionAvailable: 'Этот метод получает список соревнований, в настоящее время отмеченных как доступные в API. Это гарантирует, что возвращаемые данные актуальны и готовы к использованию в приложениях. Он особенно полезен для разработчиков, создающих функции, которые полагаются на активные или доступные соревнования, позволяя пользователям исследовать релевантные события без столкновения с устаревшими или неполными данными.',
        getCompetitionDetail: 'Этот метод предоставляет подробную информацию о конкретном соревновании, доступном в API. Он особенно полезен для приложений, требующих глубокой информации о соревновании, позволяя реализовать функции, такие как детальные представления, контекстные инсайты или опции фильтрации на основе характеристик соревнования.',
        getCompetitionSeasons: 'Этот метод получает список всех сезонов, связанных с конкретным соревнованием. Этот эндпоинт необходим для приложений, которые стремятся предоставить комплексное покрытие истории соревнования или его текущего состояния, позволяя пользователям исследовать данные сезон за сезоном.',
        getSeasonAvailable: 'Этот метод предоставляет список сезонов, в настоящее время отмеченных как доступные в API. Он особенно полезен для приложений, которые фокусируются на живых или текущих футбольных событиях, позволяя пользователям взаимодействовать с релевантными и актуальными данными сезона.',
        getSeasonDetail: 'Этот метод получает подробную информацию о конкретном сезоне, включая его временную шкалу, связанное соревнование и ключевые метаданные. Этот эндпоинт необходим для приложений, требующих глубоких инсайтов в конкретный сезон, позволяя реализовать функции, такие как обзоры сезона, фильтрация по соревнованию или отображение детальных временных шкал для взаимодействия пользователя.',
        getSeasonTeams: 'Этот метод предоставляет список всех команд, участвующих в конкретном сезоне. Он идеален для функций, таких как управление составом, анализ производительности команды или создание фильтров, специфичных для сезона, для пользователей.',
        getSeasonPlayer: 'Этот метод получает список всех игроков, зарегистрированных в конкретном сезоне. Он идеален для создания функций, таких как составы игроков, отслеживание производительности или фильтрация игроков на основе выбранного сезона.',
        getSeasonPlayerStats: 'Этот метод предоставляет подробную статистику для всех игроков в конкретном сезоне. Он особенно полезен для приложений, ориентированных на аналитику, сравнение игроков или создание динамических визуализаций достижений игроков в течение сезона.',
        getSeasonArrigoMetrics: 'Этот метод предоставляет объединенную статистику для всех игроков в конкретном сезоне. Он особенно полезен для приложений, ориентированных на аналитику, сравнение игроков или создание динамических визуализаций достижений игроков в течение сезона.',
        getSeasonTeamStats: 'Этот метод предоставляет комплексную статистику для всех команд, участвующих в конкретном сезоне. Он особенно полезен для приложений, ориентированных на анализ команд, сводки сезона или сравнения производительности команд в течение сезона.',
        getSeasonCoaches: 'Этот метод получает список всех тренеров, которые управляли командами в течение конкретного сезона. Он особенно полезен для приложений, которые фокусируются на инсайтах сезона, анализе тренерской работы или отслеживании изменений в управлении командой в течение сезона.',
        getSeasonGames: 'Этот метод предоставляет список всех матчей, сыгранных в конкретном сезоне. Он идеален для приложений, которым необходимо отображать полные расписания сезона, анализировать результаты матчей или предоставлять пользователям доступ к комплексным данным матчей сезона.',
        getSeasonGamesMatchday: 'Этот метод получает все матчи для конкретного тура в заданном сезоне. Он особенно полезен для приложений, которые стремятся отображать расписания туров, анализировать конкретные раунды или предоставлять сфокусированные инсайты в конкретный набор матчей в течение сезона.',
        getSeasonLeagueTable: 'Этот метод предоставляет таблицу лиги для конкретного сезона, включая рейтинги, очки, победы, ничьи, поражения и другую релевантную статистику для каждой команды. Этот эндпоинт необходим для приложений, ориентированных на отслеживание позиций команд, анализ прогресса лиги или представление пользователям актуальных рейтингов в течение сезона.',
        getTeamDetail: 'Этот метод предоставляет подробную информацию о конкретной команде, включая ее название, год основания, стадион и другие метаданные. Этот эндпоинт идеален для приложений, требующих специфических для команды инсайтов, позволяя реализовать функции, такие как детальные профили команд, исторический контекст или улучшенный пользовательский опыт с богатыми данными, связанными с командой.',
        getTeamLoans: 'Этот метод получает информацию о сделках аренды, связанных с конкретной командой. Этот эндпоинт особенно полезен для приложений, ориентированных на анализ трансферов, управление составом команды или отслеживание движений игроков в течение сезона.',
        getTeamRoster: 'Этот метод предоставляет полный список игроков в составе конкретной команды. Он идеален для приложений, которым необходимо отображать составы команд, анализировать роли игроков или управлять функциями, связанными с составом для команды.',
        getTeamGames: 'Этот метод получает список всех матчей, сыгранных конкретной командой. Он особенно полезен для приложений, которые фокусируются на производительности команды, отслеживании расписания или предоставлении пользователям доступа к полной истории матчей команды.',
        getTeamGameStats: 'Этот метод предоставляет подробную статистику для конкретной команды в заданном матче. Он особенно полезен для приложений, ориентированных на аналитику матчей, оценку производительности или глубокие разбивки производительности команды в отдельных матчах.',
        getTeamTransfers: 'Этот метод получает информацию о сделках трансферов, связанных с конкретной командой. Он особенно полезен для приложений, которые фокусируются на анализе трансферного рынка, изменениях состава команды или отслеживании движений игроков с течением времени.',
        getGameStatus: 'Этот метод предоставляет список всех возможных статусов матчей, доступных в API, таких как запланирован, в процессе, завершен, отложен или отменен. Этот эндпоинт особенно полезен для приложений, требующих отслеживания матчей в реальном времени, фильтрации матчей по статусу или предоставления пользователям четких обновлений о прогрессе или состоянии матча.',
        getPlayerPositions: 'Этот метод возвращает список всех возможных позиций игроков, таких как вратарь, защитник, полузащитник и нападающий. Этот эндпоинт особенно полезен для приложений, которые категоризируют игроков, анализируют позиционные данные или позволяют пользователям фильтровать игроков на основе их ролей на поле.',
        getGameDetail: 'Этот метод предоставляет комплексную информацию о конкретном матче, включая детали, такие как участвующие команды, дата и время, место проведения, счет и другие ключевые метаданные. Этот эндпоинт идеален для приложений, требующих глубоких инсайтов о матче, позволяя реализовать функции, такие как детальные предматчевые обзоры, отчеты или аналитика.',
        getGameStats: 'Этот метод предоставляет подробную статистику для конкретного матча, включая метрики, такие как голы, удары, проценты владения, передачи и защитные действия. Этот эндпоинт особенно полезен для приложений, ориентированных на анализ матчей, послематчевые отчеты или визуализации производительности команды во время матча.',
        getGamePlayerStats: 'Этот метод получает подробную статистику производительности для всех игроков, которые участвовали в конкретном матче. Он особенно полезен для приложений, которые анализируют индивидуальные выступления игроков, генерируют отчеты о матчах или сравнивают игроков в контексте одного матча.',
        getGamePlayerPhysicalStats: 'Этот метод предоставляет подробные метрики физической производительности для игроков в конкретном матче. Он особенно полезен для приложений, ориентированных на анализ физической формы игроков, отслеживание физической производительности или генерацию детальных инсайтов о матче для отдельных игроков.',
        getGameTeamPhysicalStats: 'Этот метод предоставляет подробные метрики физической производительности для команд в конкретном матче. Это включает данные, такие как общая пройденная дистанция, количество спринтов, высокоинтенсивные пробежки и другие физические атрибуты. Он особенно полезен для приложений, ориентированных на анализ физической формы команд, сравнение физических усилий между командами или оценку общей производительности в матче.',
        getGamePlayerArrigoMetrics: 'Этот метод предоставляет подробные метрики Arrigo для игроков в конкретном матче. Он особенно полезен для приложений, ориентированных на анализ и генерацию детальных инсайтов об игроках в матче.',
        getGameTeamArrigoMetrics: 'Этот метод предоставляет подробные метрики Arrigo для команд в конкретном матче. Это включает данные, такие как обойденные игроки и другие атрибуты. Он особенно полезен для приложений, ориентированных на анализ и оценку общей производительности в матче.',
        getGameLineup: 'Этот метод получает состав для конкретного матча, включая стартовых игроков, запасных и их соответствующие позиции. Этот эндпоинт особенно полезен для приложений, которые отображают предматчевую информацию, анализируют расстановки команд или предоставляют инсайты о тактических решениях, принятых командами для данного матча.',
        getGameTimeline: 'Этот метод предоставляет хронологический список событий, произошедших во время конкретного матча. Он особенно полезен для приложений, которые предлагают обновления матчей в реальном времени, послематчевые сводки или детальные анализы событий матча.',
        getGameTracking: 'Этот метод предоставляет ссылку для загрузки файла данных отслеживания для конкретного матча. Этот файл содержит подробные данные о движении и позициях игроков и мяча в течение матча. Он особенно полезен для приложений, ориентированных на продвинутую аналитику, тактический анализ или создание визуализаций движений игроков и мяча во время матча.',
        getTrackingStatus: 'Этот метод возвращает полный список всех состояний, доступных в отслеживании, предоставляя ключевые детали, такие как уникальный идентификатор и название каждого состояния. Этот эндпоинт идеален для приложений, требующих отслеживания матчей, позволяя реализовать функции, такие как выбор состояния, фильтрация и анализ. Он также служит критическим ресурсом для взаимодействия с другими эндпоинтами, зависящими от параметра `statusId`, обеспечивая бесшовную навигацию и интеграцию с более широким набором данных API.',
        getPlayerTransfersTypes: 'Этот метод получает список возможных типов трансферов игроков, таких как постоянный трансфер, аренда, свободный трансфер или обмен. Этот эндпоинт особенно полезен для приложений, которые анализируют тренды трансферного рынка, категоризируют движения игроков или предоставляют пользователям детальные инсайты о типах транзакций, связанных с игроками.',
        getPlayerDetail: 'Этот метод предоставляет подробную информацию о конкретном игроке, включая личные данные, карьерную статистику и текущую принадлежность к команде. Этот эндпоинт идеален для приложений, которые предлагают профили игроков, исторические инсайты или аналитику индивидуальных выступлений игроков и карьерных траекторий.',
        getPlayerGames: 'Этот метод получает список всех матчей, в которых участвовал конкретный игрок. Он особенно полезен для приложений, ориентированных на отслеживание производительности игрока, анализ истории матчей или предоставление пользователям комплексных журналов матчей для отдельных игроков.',
        getPlayerInjuries: 'Этот метод предоставляет подробную запись травм, полученных конкретным игроком. Он особенно полезен для приложений, ориентированных на анализ здоровья игрока, оценку влияния на карьеру или отслеживание временных рамок восстановления.',
        getPlayerNationalTeam: 'Этот метод получает подробную информацию об участии игрока в матчах сборной. Он особенно полезен для приложений, ориентированных на производительность игрока на национальном уровне, отслеживание международной карьеры или предоставление инсайтов о вкладе во время турниров и товарищеских матчей.',
        getPlayerSeasons: 'Этот метод предоставляет список всех сезонов, в которых участвовал конкретный игрок. Он особенно полезен для приложений, которые отслеживают карьерный прогресс игрока, анализируют производительность по сезонам или предоставляют исторический контекст для их достижений.',
        getPlayerTransfers: 'Этот метод получает подробную историю сделок трансферов, связанных с конкретным игроком. Он особенно полезен для приложений, ориентированных на анализ карьеры игрока, инсайты трансферного рынка или отслеживание движения игроков между командами с течением времени.',
        getPlayerSeasonTeamStats: 'Этот метод предоставляет подробную статистику производительности для конкретного игрока в течение конкретного сезона с командой. Он особенно полезен для приложений, ориентированных на анализ игрока в течение сезона, сравнения между командами или сезонами и отслеживания индивидуального вклада в успех команды.',
        getPlayerSeasonPhysicalStats: 'Этот метод предоставляет подробные метрики физической производительности для конкретного игрока в течение сезона. Он особенно полезен для приложений, ориентированных на отслеживание физической формы игрока, анализ физической производительности или оценку рабочей нагрузки игрока в течение сезона.',
        getPlayerSeasonGamePhysicalStats: 'Этот метод предоставляет подробные метрики физической производительности для конкретного игрока на основе каждого матча в течение сезона. Он особенно полезен для приложений, ориентированных на анализ физической формы для конкретного матча, отслеживание рабочей нагрузки игрока или сравнение физической производительности в разных матчах.',
        getPlayerSeasonGameStats: 'Этот метод получает подробную статистику производительности для конкретного игрока на основе каждого матча в течение сезона. Он особенно полезен для приложений, ориентированных на анализ игрока для конкретного матча, тренды производительности или детальные сравнения между матчами в течение сезона.',
        getCoachDetail: 'Этот метод предоставляет подробную информацию о конкретном тренере, включая его имя, карьерную историю, управляемые команды и заметные достижения. Этот эндпоинт особенно полезен для приложений, которые выделяют тренерские профили, отслеживают карьеры менеджеров или анализируют влияние тренеров на производительность команды.',
        getCoachHistory: 'Этот метод получает комплексную историю карьеры конкретного тренера, включая команды, которыми он управлял, соревнования, в которых участвовал, и продолжительность его работы. Этот эндпоинт особенно полезен для приложений, которые фокусируются на анализе тренерских карьер, отслеживании изменений в управлении или предоставлении инсайтов о профессиональном пути и достижениях тренера.',
        getGameEventing: 'Этот метод предоставляет все события',
        getLinkStream: 'Этот метод получает ссылку для просмотра игрового видео.',
        getLinkDownload: 'Этот метод получает ссылку для загрузки игрового видео.',
        getGameTs: 'Этот метод предоставляет последнюю метку времени в определенном совпадении.',
        getGameFileTypes: 'Этот метод предоставляет типы файлов для соответствия',
        deletePlayer: 'This method delete a player'
      },
      responseCodes: 'Коды ответов',
      furtherInformation: 'Для получения дополнительной информации, пожалуйста, прочитайте нашу документацию API',
      clipboard: 'Скопировано в буфер обмена!',
      limit50: 'Показаны только первые 50 результатов'
    }
  },
  globalSearch: {
    subtitle: 'Глубокая фильтрация'
  },
  global: {
    teamElos: {
      title: 'КОМАНДНЫЙ ELO',
      subtitle: 'Глобальные рейтинги и аналитика команд',
      team: 'Команда',
      teams: 'Команды',
      dates: 'Даты',
      excludeInternational: 'Исключить международные команды',
      elo: 'ELO',
      selectButton: 'Выберите Топ',
      selectTeamFromTable: 'Выберите команду из таблицы, чтобы отобразить тренд ELO.',
      showingTeamAveragesLastSeason: 'Показаны средние значения команд за последний сезон',
      showingTeamStatsLastSeason: 'Показаны только статистические данные команд за их последний активный сезон',
      searchToolTip: 'Совет: нажмите Ctrl + B для прямого доступа к строке поиска.',
      selectTopTooltip: 'Отображение дополнительных команд на диаграмме для сравнения',
      loadingPage: 'Подготовка данных...'
    },
    leagueElos: {
      title: 'ЛИГОВОЙ ELO',
      subtitle: 'Глобальные рейтинги и аналитика лиг',
      rankings: 'РЕЙТИНГИ',
      insights: 'АНАЛИТИКА',
      filters: 'ФИЛЬТРЫ',
      leagues: 'Лиги',
      from: 'С',
      to: 'По',
      elo: 'ELO',
      change: 'Изменение',
      league: 'Лига',
      excludeContinental: 'Исключить международные соревнования',
      eloTrend: 'Динамика ELO',
      eloRanking: 'Рейтинг ELO',
      currentELOLabel: '(Текущий ЭЛО)',
      allTime: 'За всё время',
      average: 'Среднее',
      noChartData: 'Нет данных для выбранных фильтров.',
      selectLeagueFromTable: 'Выберите лигу из таблицы, чтобы отобразить тренд ELO.',
      noInsightsData: 'Нет аналитических данных для выбранных лиг. Пожалуйста, убедитесь, что для лиг выбраны сезоны и доступны командные данные.',
      showingLeagueAveragesLastSeason: 'Показаны только средние показатели лиг за их последний активный сезон',
      selectTopTooltip: 'Отобразите дополнительные лиги в таблице для сравнения.',
      confederations: {
        world: 'Мир',
        top5: 'ТОП 5',
        uefa: 'УЕФА',
        conmebol: 'КОНМЕБОЛ',
        concacaf: 'КОНКАКАФ',
        caf: 'КАФ',
        afc: 'АФК'
      },
      numberOfLeagues: 'Количество лиг',
      minimumElo: 'Минимальный ЭЛО'
    },
    players: {
      title: 'GPI игрока',
      subtitle: 'Глобальные рейтинги игроков и аналитика',
      gpiRanking: 'Рейтинг GPI',
      rankTooltip: 'Наведите курсор, чтобы отобразить глобальный рейтинг',
      globalRanking: 'Глобальный рейтинг',
      player: 'Игрок',
      players: 'Игроки',
      gpiTrend: 'Тенденция GPI',
      currentGPILabel: '(Текущий GPI)',
      nationality: 'Страна рождения',
      position: 'Позиция',
      marketValue: 'Рыночная стоимость',
      apply: 'Применять',
      marketValueAndAgeTooltip: 'Введите диапазон и нажмите «Применить» или нажмите «Ввод».',
      searchPlaceholder: 'Найти игрока...',
      selectTopTooltip: 'Отображение дополнительных игроков в таблице для сравнения',
      gpi: 'GPI',
      numberOfPlayers: 'Количество игроков',
      showingPlayerStatsLastSeason: 'Показана только средняя статистика игроков за последний активный сезон.',
      date: 'ДАТА',
      showChartLabels: 'Показать метки',
      marketValueTooltip: 'Введите диапазон и нажмите «Применить» или нажмите «Ввод».',
      freeAgents: 'Свободные агенты',
      selectPlayerFromTable: 'Выберите игрока из таблицы, чтобы просмотреть динамику GPI.'
    }
  },
  iso: {
    AF: 'Афганистан',
    DZ: 'Алжир',
    AO: 'Ангола',
    AR: 'Аргентина',
    AU: 'Австралия',
    AZ: 'Азербайджан',
    BH: 'Бахрейн',
    BB: 'Барбадос',
    BE: 'Бельгия',
    BJ: 'Бенин',
    BO: 'Боливия',
    BW: 'Ботсвана',
    BN: 'Бруней',
    BF: 'Буркина-Фасо',
    KH: 'Камбоджа',
    CA: 'Канада',
    CF: 'Центральноафриканская Республика',
    CL: 'Чили',
    CO: 'Колумбия',
    CD: 'Демократическая Республика Конго',
    CG: 'Конго',
    CI: 'Кот-д\'Ивуар',
    CU: 'Куба',
    CZ: 'Чехия',
    DJ: 'Джибути',
    DO: 'Доминиканская Республика',
    EC: 'Эквадор',
    SV: 'Сальвадор',
    ER: 'Эритрея',
    ET: 'Эфиопия',
    FI: 'Финляндия',
    PF: 'Французская Полинезия',
    GM: 'Гамбия',
    DE: 'Германия',
    GI: 'Гибралтар',
    GL: 'Гренландия',
    GP: 'Гваделупа',
    GN: 'Гвинея',
    GY: 'Гайана',
    HN: 'Гондурас',
    HU: 'Венгрия',
    IN: 'Индия',
    IR: 'Иран',
    IE: 'Ирландия',
    IT: 'Италия',
    JP: 'Япония',
    KZ: 'Казахстан',
    KI: 'Кирибати',
    KR: 'Южная Корея',
    KG: 'Кыргызстан',
    LV: 'Латвия',
    LS: 'Лесото',
    LY: 'Ливия',
    LT: 'Литва',
    MO: 'Макао',
    MG: 'Мадагаскар',
    MY: 'Малайзия',
    ML: 'Мали',
    MH: 'Маршалловы Острова',
    MR: 'Мавритания',
    MX: 'Мексика',
    MD: 'Молдова',
    MN: 'Монголия',
    MA: 'Марокко',
    MM: 'Мьянма',
    NR: 'Науру',
    NL: 'Нидерланды',
    NZ: 'Новая Зеландия',
    NE: 'Нигер',
    MP: 'Северные Марианские Острова',
    OM: 'Оман',
    PW: 'Палау',
    PA: 'Панама',
    PY: 'Парагвай',
    PH: 'Филиппины',
    PT: 'Португалия',
    QA: 'Катар',
    RO: 'Румыния',
    RW: 'Руанда',
    LC: 'Сент-Люсия',
    SM: 'Сан-Марино',
    SA: 'Саудовская Аравия',
    RS: 'Сербия',
    SL: 'Сьерра-Леоне',
    SK: 'Словакия',
    SB: 'Соломоновы Острова',
    ZA: 'Южная Африка',
    LK: 'Шри-Ланка',
    SD: 'Судан',
    SZ: 'Свазиленд',
    CH: 'Швейцария',
    TW: 'Тайвань',
    TZ: 'Танзания',
    TG: 'Того',
    TT: 'Тринидад и Тобаго',
    TR: 'Турция',
    TV: 'Тувалу',
    UA: 'Украина',
    GB: 'Великобритания',
    UY: 'Уругвай',
    VU: 'Вануату',
    VE: 'Венесуэла',
    VG: 'Британские Виргинские Острова',
    EH: 'Западная Сахара',
    ZM: 'Замбия',
    AL: 'Албания',
    AD: 'Андорра',
    AG: 'Антигуа и Барбуда',
    AM: 'Армения',
    AT: 'Австрия',
    BS: 'Багамы',
    BD: 'Бангладеш',
    BY: 'Беларусь',
    BZ: 'Белиз',
    BT: 'Бутан',
    BA: 'Босния и Герцеговина',
    BR: 'Бразилия',
    BG: 'Болгария',
    BI: 'Бурунди',
    CM: 'Камерун',
    CV: 'Кабо-Верде',
    TD: 'Чад',
    CN: 'Китай',
    KM: 'Коморы',
    CR: 'Коста-Рика',
    HR: 'Хорватия',
    CY: 'Кипр',
    DK: 'Дания',
    DM: 'Доминика',
    TL: 'Восточный Тимор',
    EG: 'Египет',
    GQ: 'Экваториальная Гвинея',
    EE: 'Эстония',
    FJ: 'Фиджи',
    FR: 'Франция',
    GA: 'Габон',
    GE: 'Грузия',
    GH: 'Гана',
    GR: 'Греция',
    GD: 'Гренада',
    GT: 'Гватемала',
    GW: 'Гвинея-Бисау',
    HT: 'Гаити',
    HK: 'Гонконг',
    IS: 'Исландия',
    ID: 'Индонезия',
    IQ: 'Ирак',
    IL: 'Израиль',
    JM: 'Ямайка',
    JO: 'Иордания',
    KE: 'Кения',
    KP: 'Северная Корея',
    KW: 'Кувейт',
    LA: 'Лаос',
    LB: 'Ливан',
    LR: 'Либерия',
    LI: 'Лихтенштейн',
    LU: 'Люксембург',
    MK: 'Македония',
    MW: 'Малави',
    MV: 'Мальдивы',
    MT: 'Мальта',
    MQ: 'Мартиника',
    MU: 'Маврикий',
    FM: 'Микронезия',
    MC: 'Монако',
    ME: 'Черногория',
    MZ: 'Мозамбик',
    NA: 'Намибия',
    NP: 'Непал',
    NC: 'Новая Каледония',
    NI: 'Никарагуа',
    NG: 'Нигерия',
    NO: 'Норвегия',
    PK: 'Пакистан',
    PS: 'Палестинские территории',
    PG: 'Папуа — Новая Гвинея',
    PE: 'Перу',
    PL: 'Польша',
    PR: 'Пуэрто-Рико',
    RE: 'Реюньон',
    RU: 'Российская Федерация',
    KN: 'Сент-Китс и Невис',
    WS: 'Самоа',
    ST: 'Сан-Томе и Принсипи',
    SN: 'Сенегал',
    SC: 'Сейшелы',
    SG: 'Сингапур',
    SI: 'Словения',
    SO: 'Сомали',
    ES: 'Испания',
    VC: 'Сент-Винсент и Гренадины',
    SR: 'Суринам',
    SE: 'Швеция',
    SY: 'Сирия',
    TJ: 'Таджикистан',
    TH: 'Таиланд',
    TO: 'Тонга',
    TN: 'Тунис',
    TM: 'Туркменистан',
    UG: 'Уганда',
    AE: 'Объединенные Арабские Эмираты',
    US: 'Соединенные Штаты',
    UZ: 'Узбекистан',
    VA: 'Ватикан',
    VN: 'Вьетнам',
    VI: 'Виргинские Острова (США)',
    YE: 'Йемен',
    ZW: 'Зимбабве',
    EU: 'Европа',
    INT: 'Международный',
    CW: 'Кюрасао',
    AFC: 'АФК',
    CONCACAF: 'КОНКАКАФ',
    'GB-ENG': 'Англия',
    'GB-WLS': 'Уэльс',
    'GB-SCT': 'Шотландия',
    LATAM: 'Южная Америка',
    CAF: 'КАФ',
    XK: 'Косово',
    AI: 'Ангилья',
    AN: 'Нидерландские Антильские острова',
    AS: 'Американское Самоа',
    AW: 'Аруба',
    BM: 'Бермуды',
    BQ: 'Бонайре, Синт-Эстатиус и Саба',
    CK: 'Острова Кука',
    FO: 'Фарерские острова',
    GF: 'Гвиана',
    GG: 'Гернси',
    GU: 'Гуам',
    IM: 'Остров Мэн',
    JE: 'Джерси',
    KY: 'Острова Кайман',
    MF: 'Сен-Мартен',
    MS: 'Монтсеррат',
    NU: 'Ниуэ',
    OC: 'Океания',
    RI: 'Индонезия',
    SS: 'Южный Судан',
    TC: 'Острова Теркс и Кайкос',
    YT: 'Майотта',
    SX: 'Синт-Мартен'
  },
  loadingMessages: {
    players: 'Подготовка игроков',
    teams: 'Упорядочивание команд',
    games: 'Загрузка матчей',
    stats: 'Расчет метрик',
    graphs: 'Построение графиков',
    gettingReady: 'Разогрев',
    placeholder: 'Приготовьтесь'
  },
  requestReport: {
    subtitle: 'Получите подробный отчет со всем необходимым',
    categories: {
      scouting: {
        title: 'Разведка',
        subtitle: 'Кто лучшие игроки определенной лиги? А из нескольких лиг вместе? Запросите индивидуальный отчет с любыми фильтрами (возраст, рост, окончание контракта и т.д.) и узнайте, какие игроки подходят лучше всего'
      },
      coaches: {
        title: 'Тренеры',
        subtitle: 'Как тренер впишется в систему вашей команды? Получите подробную информацию или, учитывая определенный профиль, узнайте, какие тренеры подходят лучше всего'
      },
      'team analysis': {
        title: 'Команда',
        subtitle: 'Укажите команду и получите сводку сезона с ценными инсайтами о стиле, защитной и атакующей игре, слабых местах, лучших игроках и т.д...'
      },
      'game analysis': {
        title: 'Анализ матча',
        subtitle: 'Укажите матч и получите глубокий предматчевый и послематчевый анализ с подробной информацией'
      },
      'special projects': {
        title: 'Специальные проекты',
        subtitle: 'Как игрок выступает в гостевых матчах? Как игроки меняются от лиги к лиге? Какие игроки доступны для аренды? Спросите все, что придет в голову'
      },
      conversation: {
        title: 'Разговор',
        subtitle: 'Начните разговор с нашей командой'
      }
    },
    notesPlaceholder: 'Сообщите нам лигу, профиль, статистику, тренера, команду или матч, о которых вы хотите узнать больше',
    chooseType: 'Выберите тип отчета',
    requestSummary: 'Сводка запроса',
    reportType: 'Тип отчета',
    reportLanguage: 'Язык отчета',
    detailTitle: 'Отслеживание отчета',
    detailSubtitle: 'Вся информация об отчете, который вы запросили'
  },
  bugReport: {
    modalSubtitle: 'Помогите нам улучшиться',
    about: 'О программе',
    sendSuccess: 'Успешно отправлено. Проверьте обновления в почте',
    bugs: 'Ошибки'
  },
  gbe: {
    autopass: 'Автоматический пропуск',
    bandX: 'Бэнд {0}',
    bandXCont: 'Бэнд {0} Континентальное соревнование',
    points: 'Очки',
    titleWinner: 'Победитель титула',
    qualifiedGroupsBandX: 'Прошел в групповой этап Бэнд {0} Континентального соревнования',
    qualifiedQualifiersBandX: 'Прошел в квалификацию Бэнд {0} Континентального соревнования',
    midTable: 'Середина таблицы',
    relegation: 'Вылет',
    promotion: 'Повышение',
    final: 'Финал',
    semifinal: 'Полуфинал',
    quarterfinal: 'Четвертьфинал',
    round16: '1/8 финала',
    round32: '1/32 финала',
    groupstage: 'Групповой этап',
    firstRound: '1-й раунд',
    secondRound: '2-й раунд',
    thirdRound: '3-й раунд',
    fourthRound: '4-й раунд',
    preliminaryRound: 'Предварительный раунд',
    other: 'Другое',
    score: 'Счет',
    totalSummary: 'Общая сводка',
    currentlyPlayingInUK: 'Игрок является гражданином Соединенного Королевства или Ирландии, или игрок является постоянным жителем Соединенного Королевства',
    bandsAlert: 'Есть минуты, сыгранные более чем в одном бэнде, итог - максимальное значение',
    bandsAlertMax: 'Есть минуты, сыгранные более чем в одном бэнде, итог - максимальное значение',
    bandsAlertAvg: 'Есть минуты, сыгранные более чем в одном бэнде, итог - среднее значение',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: 'Дебют для молодого игрока',
    table1: {
      name: 'Международные матчи игрока',
      title1: 'Совокупный рейтинг ФИФА национальной ассоциации игрока',
      title2: 'Международные матчи игрока'
    },
    table2: {
      name: 'Домашние минуты игрока',
      title1: 'Домашние минуты игрока'
    },
    table3: {
      name: 'Континентальные минуты игрока',
      title1: 'Континентальные минуты игрока'
    },
    table4: {
      name: 'Финальная позиция в лиге последнего клуба игрока',
      title1: 'Финальная позиция в лиге последнего клуба'
    },
    table5: {
      name: 'Континентальный прогресс последнего клуба игрока',
      title1: 'Континентальный прогресс'
    },
    table6: {
      name: 'Качество лиги текущего клуба игрока',
      title1: 'Бэнд текущего клуба игрока'
    },
    table7: {
      name: 'Молодежь - Дебют',
      title1: 'Бэнд'
    },
    table8: {
      name: 'Молодежь - Финальная позиция в лиге',
      title1: 'Финальная позиция в лиге последнего клуба'
    },
    table9: {
      name: 'Молодежь - Континентальный прогресс',
      title1: 'Континентальный прогресс'
    },
    table10: {
      name: 'Молодежь - Качество лиги текущего клуба игрока',
      title1: 'Бэнд текущего клуба игрока'
    },
    table11: {
      name: 'Молодежь - Качество лиги текущего клуба игрока',
      title1: 'Бэнд текущего клуба игрока'
    },
    table12: {
      name: 'Молодежь - Международные матчи',
      title1: 'Международные матчи игрока'
    }
  },
  mediaMode: {
    borderColor: 'Цвет границы',
    fillColor: 'Цвет заливки',
    bgColor: 'Цвет фона',
    upperText: 'Верхний текст',
    lowerText: 'Нижний текст',
    socialMedia: 'Социальные сети',
    textColor: 'Цвет текста',
    axisColor: 'Цвет осей',
    logo: 'Логотип',
    comparisonBorderColor: 'Цвет границы сравнения',
    comparisonFillColor: 'Цвет заливки сравнения',
    comparisonUpperText: 'Верхний текст сравнения',
    comparisonLowerText: 'Нижний текст сравнения',
    homeFillColor: 'Цвет заливки дома',
    homeBorderColor: 'Цвет границы дома',
    awayFillColor: 'Цвет заливки в гостях',
    awayBorderColor: 'Цвет границы в гостях',
    face: 'Лицо',
    nationalTeam: 'Сборная',
    comparisonFace: 'Лицо сравнения',
    upperTextX: 'Верхний текст {0}',
    lowerTextX: 'Нижний текст {0}',
    borderColorX: 'Цвет границы {0}',
    fillColorX: 'Цвет заливки {0}',
    homeFillColorX: 'Цвет заливки (Дома) {0}',
    homeBorderColorX: 'Цвет границы (Дома) {0}',
    awayFillColorX: 'Цвет заливки (В гостях) {0}',
    awayBorderColorX: 'Цвет границы (В гостях) {0}',
    faceX: 'Лицо {0}',
    selectField: 'Выберите свойство',
    orientationX: 'Ориентация {0}',
    searchBarPlaceholder: 'Поиск игроков и/или матчей...',
    title: 'Медиа панель',
    pageSubtitle: 'Исследуйте и скачивайте карты и графики',
    chooseChart: 'Выберите график...',
    headerTextX: 'Текст заголовка {0}',
    avatarLineLength: 'Длина линии аватара',
    avatarLineWeight: 'Толщина линии аватара',
    avatarSize: 'Размер аватара',
    chartX: 'График {0}',
    chartHeaderFontSize: 'Размер шрифта заголовка графиков',
    chartHeaderFontWeight: 'Толщина шрифта заголовка графиков',
    upperTextFontSize: 'Размер шрифта верхнего текста',
    upperTextFontWeight: 'Толщина шрифта верхнего текста',
    lowerTextFontSize: 'Размер шрифта нижнего текста',
    lowerTextFontWeight: 'Толщина шрифта нижнего текста',
    socialMediaFontSize: 'Размер шрифта социальных сетей',
    socialMediaFontWeight: 'Толщина шрифта социальных сетей',
    subtitle: 'Подзаголовок',
    subtitleFontSize: 'Размер шрифта подзаголовка',
    subtitleFontWeight: 'Толщина шрифта подзаголовка',
    subtitleX: 'Подзаголовок {0}',
    subtitleFontSizeX: 'Размер шрифта подзаголовка ${0}',
    subtitleFontWeightX: 'Толщина шрифта подзаголовка ${0}',
    titleX: 'Заголовок {0}',
    titleFontSize: 'Размер шрифта заголовка',
    titleFontWeight: 'Толщина шрифта заголовка',
    sponsor: 'Спонсор',
    fontFamily: 'Семейство шрифтов'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Отчеты разведки',
      GAME_REPORT: 'Отчеты о матчах',
      MEDICAL_REPORT: 'Медицинские отчеты',
      PHYSICAL_REPORT: 'Физические отчеты',
      PSYCHOLOGICAL_REPORT: 'Психологические отчеты',
      OTHER: 'Другое',
      QUICK_NOTES: 'Быстрые заметки',
      PLAYER_REPORT: 'Отчеты об игроках',
      GENERAL_COMMENTS: 'Общие комментарии',
      PLAYER_ANALYSIS: 'Анализ игрока'
    },
    uploadDocument: 'Загрузить документ',
    notesPlaceholder: 'Введите описательные заметки или комментарии, связанные с документом',
    notesPlaceholderAlt: 'Введите описательные заметки или комментарии, связанные с игроком',
    uploadedBy: 'Загружено',
    updatedBy: 'Обновлено',
    seeNotes: 'Посмотреть заметки',
    addNote: 'Добавить заметку',
    rating: 'Оценка',
    position: 'Лучшая позиция',
    physical: 'Физика',
    onBall: 'С мячом',
    offBall: 'Без мяча',
    mental: 'Психология',
    potential: 'Потенциал',
    conclusion: 'Заключение',
    recommendation: {
      1: 'Подписать',
      2: 'Наблюдать',
      3: 'Отклонить',
      4: 'Интересно',
      label: 'Рекомендация'
    },
    match: 'Матч',
    deleteQuickNote: 'Удалить заметку',
    deleteQuickNoteMessage: 'Заметка будет удалена навсегда. Вы уверены?',
    noQuickNotes: 'Нет данных. Начните с добавления быстрых заметок!',
    deleteDocument: 'Удалить документ',
    deleteDocumentMessage: 'Документ будет удален навсегда. Вы уверены?',
    noDocuments: 'Нет данных. Начните с добавления документов!'
  },
  notifications: {
    newReportMessage: 'Есть новое сообщение в отчете'
  },
  blog: {
    subtitle: 'Последние статьи, обновления и новости',
    newEntry: 'Новая запись',
    title: 'Заголовок',
    text: 'Текст',
    link: 'Ссылка',
    image: 'Изображение',
    author: 'Автор',
    date: 'Дата публикации',
    deleteEntry: 'Удалить запись',
    deleteEntryMessage: 'Вы уверены, что хотите удалить эту запись?',
    readMore: 'Читать далее'
  },
  positionsOrlegi: {
    GK: 'Вратарь',
    DC: 'Защитник',
    DR: 'Фулбек',
    MC: 'Полузащитник',
    AMC: 'Атакующий полузащитник',
    FW: 'Нападающий',
    FWR: 'Вингер'
  },
  library: {
    subtitle: 'Просмотр и обмен загруженными документами',
    mediaSubtitle: 'Просмотр и обмен экспортированными графиками',
    charts: 'Графики',
    goToLibrary: 'Перейти в библиотеку'
  },
  scatterPlot: {
    bubbleSize: 'Размер пузыря',
    byMinutes: 'По минутам',
    byAge: 'По возрасту',
    byMarketValue: 'По рыночной стоимости'
  },
  eventChart: {
    successfulEvent: 'Успешный',
    unsuccessfulEvent: 'Неудачный',
    possessionLost: 'Успешное не восстановлено',
    successfulPass: 'Успешная передача',
    unsuccessfulPass: 'Неуспешная передача',
    successfulCarry: 'Успешное ведение',
    unsuccessfulCarry: 'Неуспешное ведение',
    carryAndKeyPass: 'Ведение и ключевая передача',
    carryAndAssist: 'Ведение и передача',
    carryAndShot: 'Ведение и удар',
    ballProgressionAndPass: 'Прогрессия мяча и передача',
    ballProgression: 'Прогрессия мяча',
    ballProgressionAndKeyPass: 'Прогрессия мяча и ключевая передача',
    ballProgressionAndAssist: 'Прогрессия мяча и передача',
    ballProgressionAndShot: 'Прогрессия мяча и удар',
    ballProgressionAndGoal: 'Прогрессия мяча и гол',
    pass: 'Передача',
    carryAndPass: 'Ведение и передача',
    carryAndGoal: 'Ведение и гол',
    totalTouches: 'Всего касаний',
    totalPasses: 'Всего Передач',
    successful: 'Успешно',
    unsuccessful: 'Неуспешно',
    tacklePossessionLost: 'Успешно – владение потеряно',
    gamesSelected: '{count} матчей выбрано',
    allGamesOfSeason: 'Все матчи сезона',
    allGamesOfSeasons: 'Все матчи сезонов',
    allEvents: 'Все события',
    eventTypesCount: '{count} типов событий',
    totalEvents: 'Всего событий'
  },
  event: {
    Pass: 'Передача',
    TakeOn: 'Дриблинг',
    Takeon: 'Дриблинг',
    Foul: 'Фол',
    Error: 'Ошибка',
    Tackle: 'Отбор',
    Interception: 'Перехват',
    Clearance: 'Вынос',
    MissedShot: 'Мимо ворот',
    ShotOnPost: 'Удар в штангу',
    SavedShot: 'Спасенный удар',
    Goal: 'Гол',
    Aerial: 'Игра в воздухе',
    BallRecovery: 'Подбор мяча',
    Dispossessed: 'Потеря владения',
    ChanceMissed: 'Упущенный момент',
    BallTouch: 'Касание мяча',
    BlockedPass: 'Заблокированная передача',
    Challenge: 'Единоборство',
    lossPossession: 'Потеря владения',
    OffsidePass: 'Передача в офсайд',
    groundDuelsLost: 'Проигранные единоборства на земле',
    'Ball touch': 'Касание мяча',
    Smother: 'Захват',
    'Keeper pickup': 'Подбор вратарем',
    'Good skill': 'Хороший навык',
    Punch: 'Удар кулаком',
    'Saved shot': 'Спасенный удар',
    'Shot on post': 'Удар в штангу',
    'Missed shot': 'Мимо ворот',
    Save: 'Спасение',
    'Take on': 'Дриблинг',
    'Offside pass': 'Передача в офсайд',
    Claim: 'Захват',
    'Blocked pass': 'Заблокированная передача',
    KeeperPickup: 'Пикап Хранителя',
    'Ball recovery': 'Подбор мяча',
    'Ball Recovery': 'Подбор мяча',
    'Chance missed': 'Упущенный момент',
    'Loss possession': 'Потеря владения',
    Carries: 'Ведения',
    BallProgression: 'Прогрессия мяча',
    MissedChance: 'Упущенный шанс',
    Event: 'Событие',
    Shot: 'Удар',
    Assist: 'Ассист',
    KeyPass: 'Ключевая передача',
    'Foul taken': 'Фол получен'
  },
  leagueTab: {
    leagueTable: 'Таблица лиги',
    matchdays: 'Туры',
    playerInsights: 'Инсайты игроков',
    onlyLocalPlayers: 'Только локальные игроки',
    teamInsights: 'Инсайты команд',
    head2head: 'Очные встречи',
    addNewChart: 'Добавить новый график',
    rounds: {
      16: '1/8 финала',
      32: '1/32 финала',
      W: 'Победитель',
      F: 'Финал',
      SF: 'Полуфинал',
      QF: 'Четвертьфинал',
      GR: 'Групповой этап',
      '4R': 'Четвертый раунд',
      '3R': 'Третий раунд',
      '2R': 'Второй раунд',
      '1R': 'Первый раунд',
      PR: 'Предварительный раунд',
      QPO1: 'Выход в 1/32 финала уровень ниже',
      QPO2: 'Квалификационный раунд 1/8 финала',
      QPO3: 'Отборочный раунд из 32'
    },
    positions: 'Позиции',
    prediction: 'Прогнозы',
    predicted: 'Прогноз',
    groups: 'Группы',
    ranking: 'Рейтинг',
    numberOfTeams: 'Количество команд',
    statsWithMinimum: {
      message: 'Показываются только игроки с более чем {0} {1} в выбранном сезоне',
      dribblesTotal90: 'дриблингов за 90 минут',
      crosses90: 'навесов за 90 минут',
      tacklesAttempted90: 'попыток отбора за 90 минут',
      aerialsTotal90: 'единоборств в воздухе за 90 минут'
    },
    numberOfLeagues: 'Количество лиг',
    position: {
      titleWinner: 'Обладатель титула',
      championsLeague: 'Лига Чемпионов',
      qualifierChampionsLeague: 'Квалификация Лиги Чемпионов',
      europeLeague: 'Лига Европы',
      qualifierEuropeLeague: 'Квалификация Лиги Европы',
      conferenceLeague: 'Конференция Лиги',
      qualifierConferenceLeague: 'Отборочная конференция лиги',
      midTable: 'Середина стола',
      relegation: 'Понижение',
      promotion: 'Повышение',
      relegationPlayoff: 'Плей-офф на вылет',
      promotionPlayoff: 'Продвижение',
      championshipGroup: 'Группа Чемпионата',
      relegationGroup: 'Группа вылета',
      championshipPlayoffs: 'Плей-офф чемпионата',
      preChampionshipPlayoffs2: 'Предчемпионат плей-офф 2',
      preChampionshipPlayoffs3: 'Предчемпионат, плей-офф 3',
      playoffsQualifierBand3: 'Отборочная группа плей-офф 3',
      continentalGroup: 'Континентальная группа'
    },
    group: {
      1: 'А',
      2: 'Б',
      3: 'С',
      4: 'Д',
      5: 'Э',
      6: 'Ф',
      7: 'Г',
      8: 'ЧАС',
      9: 'я',
      10: 'Дж',
      11: 'К',
      12: 'л'
    }
  },
  similarity: {
    subtitle: 'Найдите похожих игроков',
    searchBarPlaceholder: 'Найдите и выберите игрока для поиска похожих',
    radarFilters: 'Фильтры радара',
    similarityFilters: 'Фильтры схожести',
    playersFilters: 'Фильтры игроков',
    similarPlayers: 'Похожие игроки',
    seasonWarning: 'В инструменте Схожесть доступны только сезоны, в которых игрок сыграл более 450 минут'
  },
  squadBuilder: {
    subtitle: 'Создайте свой уникальный состав',
    playerSelector: 'Выбор игрока',
    loadSquad: 'Загрузить состав',
    yearsOld: 'лет',
    playersPerPosition: 'Игроков на позицию',
    custom: 'Пользовательский',
    removeSquad: 'Удалить состав',
    removeSquadMessage: 'Вы уверены, что хотите удалить состав?',
    deleteSquadSuccess: 'Состав успешно удален',
    playerDetails: 'Видимость деталей игрока',
    ageFormat: 'Формат возраста',
    mainPlayer: 'Основной игрок',
    showDetails: 'Показать детали',
    all: 'Все',
    squadPosition: 'Позиция в составе',
    noData: 'Нет данных. Начните с добавления игроков на поле!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Больше не показывать',
      skipTour: 'Пропустить экскурсию',
      previous: 'Назад',
      next: 'Далее',
      finish: 'Завершить'
    },
    playerRadar: {
      step1: {
        title: 'ЛИЧНОЕ ДОСЬЕ',
        message: 'Проверьте основные данные игрока: возраст, рост или дата контракта'
      },
      step2: {
        title: 'ФИЛЬТР GBE',
        message: 'Функциональность, позволяющая узнать, достаточно ли у игрока очков GBE для игры в Великобритании'
      },
      step3: {
        title: 'ДОСТУПНОСТЬ',
        message: 'Процент доступных минут и процент сыгранных минут'
      },
      step4: {
        title: 'ПОЗИЦИИ',
        message: 'Узнайте, на каких позициях играл игрок и сколько минут он сыграл на каждой позиции'
      },
      step5: {
        title: 'ФОРМАТЫ ОТОБРАЖЕНИЯ',
        message: 'Измерьте производительность с помощью 4 различных визуализаций: Радар, Полярная, Леденец и Текст, чтобы сравнить с игроками на его позиции'
      },
      step6: {
        title: 'РАДАР ПРОИЗВОДИТЕЛЬНОСТИ',
        message: 'Здесь производительность отображается визуально. Панель интерактивна, вы можете навести курсор на каждую метрику и получить ее определение'
      },
      step7: {
        title: 'ВЫБОР СЕЗОНА',
        message: 'Выберите или добавьте сезоны для измерения производительности'
      },
      step8: {
        title: 'ВЫБОР ПОЛЬЗОВАТЕЛЬСКОГО ШАБЛОНА',
        message: 'Используйте созданные вами пользовательские шаблоны для измерения игрока с помощью других метрик, чем стандартный радар'
      },
      step9: {
        title: 'ВЫБОР СЫГРАННЫХ ПОЗИЦИЙ',
        message: 'Отмечайте и снимайте отметки с разных позиций, чтобы измерить его на той позиции, на которой вы хотите его измерить'
      },
      step10: {
        title: 'ВЫБОР МИНИМУМОВ И МАКСИМУМОВ',
        message: 'Измерьте игрока с максимумами и минимумами его сезона, топ-5 лиг или собственного и стандартного сезона учетной записи пользователя'
      },
      step11: {
        title: 'СРАВНЕНИЯ',
        message: 'Сравнивает игрока с его предыдущей производительностью, с другими игроками на его позиции, со средним показателем позиции'
      },
      step12: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'СЕЗОН, СОСТАВ И ПОЗИЦИЯ',
        message: 'Выберите сезон, состав и позицию для сравнения игрока'
      },
      step2: {
        title: 'БАЗОВЫЕ ФИЛЬТРЫ',
        message: 'Фильтруйте игроков по возрасту, сыгранным минутам или росту'
      },
      step3: {
        title: 'ВЫДЕЛЕНИЕ И ИСКЛЮЧЕНИЕ',
        message: 'Выделите нужных игроков и исключите команды из отображения'
      },
      step4: {
        title: 'ФИЛЬТР ПО КАТЕГОРИИ',
        message: 'Фильтруйте статистику по категориям: Ассоциация, Защита, Передачи, Работа с мячом и т.д.'
      },
      step5: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'ВЫБОР ОТОБРАЖЕНИЯ',
        message: 'Вы можете видеть карту завершения в основном виде, виде ворот и в таблице распределения'
      },
      step2: {
        title: 'ВЫБОР СЕЗОНОВ',
        message: 'Добавьте сезоны для измерения эффективности ударов'
      },
      step3: {
        title: 'МЕСТОПОЛОЖЕНИЕ УДАРА',
        message: 'Выберите возможность видеть точное местоположение удара (круги) или по зонам штрафной и поля (зоны)'
      },
      step4: {
        title: 'xG В СТВОР',
        message: 'Отметьте поля для xG до гола и завершения xG, чтобы увидеть, какую добавленную ценность игрок добавил после удара'
      },
      step5: {
        title: 'ТИП УДАРА',
        message: 'Фильтруйте по типу удара, стратегии, зоне или части тела'
      },
      step6: {
        title: 'ФИЛЬТР ПО МИНУТАМ',
        message: 'Полоса минут для выбора ударов и голов, забитых в определенные периоды матча'
      },
      step7: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      },
      step8: {
        title: 'КАРТА УДАРОВ',
        message: 'Карта интерактивна. Наведите курсор на каждый круг, чтобы узнать xG каждого удара'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'ВЫБОР СЕЗОНА',
        message: 'Добавьте сезоны для измерения эффективности ударов'
      },
      step2: {
        title: 'МЕСТОПОЛОЖЕНИЕ КЛЮЧЕВОЙ ПЕРЕДАЧИ',
        message: 'Выберите возможность просмотра точного местоположения ключевой передачи (круг) или по зонам области и поля (зоны)'
      },
      step3: {
        title: 'ТИП ЗАВЕРШЕНИЯ ПОСЛЕ КЛЮЧЕВОЙ ПЕРЕДАЧИ',
        message: 'Фильтруйте по типу удара, стратегии, зоне или части тела, выполненным после ключевой передачи'
      },
      step4: {
        title: 'ФИЛЬТР ПО МИНУТАМ',
        message: 'Полоса минут для выбора ударов и голов, забитых в определенные периоды матча'
      },
      step5: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      },
      step6: {
        title: 'КАРТА КЛЮЧЕВЫХ ПЕРЕДАЧ',
        message: 'Карта интерактивна. Наведите курсор на каждый круг, чтобы узнать xA каждой передачи'
      }
    },
    playerThreat: {
      step1: {
        title: 'ВЫБОР СЕЗОНА',
        message: 'Добавьте сезоны для измерения эффективности ударов'
      },
      step2: {
        title: 'МЕСТОПОЛОЖЕНИЕ УГРОЗЫ',
        message: 'Выберите возможность просмотра точного местоположения ключевой передачи (круг) или по зонам области и поля (зоны)'
      },
      step3: {
        title: 'ДЕЙСТВИЕ И ЗАВЕРШЕНИЕ',
        message: 'Отмечайте и снимайте отметки в соответствии с типом действия и завершения, которые вы хотите отобразить на карте'
      },
      step4: {
        title: 'МИНУТЫ И УГРОЗА',
        message: 'Фильтруйте по периоду, минутам и значению угрозы действий'
      },
      step5: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      },
      step6: {
        title: 'КАРТА УГРОЗ',
        message: 'Карта интерактивна. Наведите курсор на каждый круг, чтобы узнать угрозу, созданную в каждом xT эпизоде каждой передачи'
      }
    },
    playerTouches: {
      step1: {
        title: 'ВЫБОР МАТЧА И СОБЫТИЙ',
        message: 'Выберите матч и события, которые вы хотите отобразить на карте'
      },
      step2: {
        title: 'ТИП СОБЫТИЯ',
        message: 'Отмечайте и снимайте отметки в соответствии с защитным или атакующим характером событий игрока в течение матча'
      },
      step3: {
        title: 'ФИЛЬТР ОТОБРАЖЕНИЯ',
        message: 'Фильтруйте карту по базовым действиям, тепловой карте, кругам или квадратам'
      },
      step4: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      },
      step5: {
        title: 'КАРТА КАСАНИЙ',
        message: 'Карта интерактивна. Вы можете просмотреть каждое событие, нажав на него'
      }
    },
    playerAllGames: {
      step1: {
        title: 'ДОСТУПНОСТЬ',
        message: 'Проверьте доступность и сыгранные минуты по каждому матчу'
      },
      step2: {
        title: 'ПОЗИЦИИ',
        message: 'Просмотрите позиции, на которых он играл в каждом матче'
      }
    },
    playerInjuries: {
      step1: {
        title: 'ИСТОРИЯ И ПОТЕРЯННЫЕ ДНИ',
        message: 'Просмотрите травмы за последний год или всю историю и диапазон травм в соответствии с их продолжительностью в днях'
      },
      step2: {
        title: 'ТРАВМЫ ПО КЛУБАМ',
        message: 'Просмотрите травмы, разделенные по сезонам и/или клубам его карьеры'
      }
    },
    playerInfo: {
      step1: {
        title: 'КАРЬЕРА И ТРАНСФЕРЫ',
        message: 'Вы можете просмотреть историю минут, позиций или доступности с его клубом, со сборной и трансферы игрока на протяжении его карьеры'
      }
    },
    teamOverview: {
      step1: {
        title: 'СОСТАВ КОМАНДЫ',
        message: 'Просмотрите основные данные команды: средний возраст, базовая расстановка, ELO или баланс трансферов'
      },
      step2: {
        title: 'БАЗОВАЯ СТАТИСТИКА',
        message: 'Просмотрите владение, xG, удары, PPDA или вертикальность'
      },
      step3: {
        title: 'РАДАР И СЕЗОН',
        message: 'Выберите радар, сезон и домашние или гостевые матчи для измерения производительности команды'
      },
      step4: {
        title: 'ФИЛЬТР ПО ТРЕНЕРУ И МАТЧАМ',
        message: 'Выберите производительность по этапам для каждого тренера'
      },
      step5: {
        title: 'РАДАР ПРОИЗВОДИТЕЛЬНОСТИ',
        message: 'Панель интерактивна, вы можете навести курсор на каждую метрику и получить ее определение'
      },
      step6: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны два формата скачивания: png и svg'
      },
      step7: {
        title: 'КАЛЕНДАРЬ',
        message: 'Просмотрите расписание матчей команды'
      },
      step8: {
        title: 'ЛУЧШИЕ ИГРОКИ ПО МЕТРИКАМ',
        message: 'В этой панели вы можете выбрать разные метрики и увидеть, какие игроки являются наиболее важными'
      },
      step9: {
        title: 'СЛЕДУЮЩИЙ МАТЧ И ТРАВМЫ',
        message: 'Проверьте следующего соперника и травмированных и дисквалифицированных игроков команды'
      },
      step10: {
        title: 'ГРАФИКИ И ТРЕНДЫ',
        message: 'Просмотрите различные графики за последние 10 или 20 матчей'
      }
    },
    teamRoster: {
      step1: {
        title: 'ТИП ОТОБРАЖЕНИЯ',
        message: 'Просмотрите состав из 6 различных категорий: по позиции, окончанию контракта, возрасту, доступности, возрастному профилю и полю'
      }
    },
    teamLoans: {
      step1: {
        title: 'АРЕНДОВАННЫЕ ИГРОКИ',
        message: 'Просмотрите игроков, отданных в аренду другим командам, и на каких позициях они играют'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'СЕЗОН И СОСТАВ',
        message: 'Фильтруйте по сезону, составу радара и сравнивайте с лигами по вашему выбору'
      },
      step2: {
        title: 'ПРОИЗВОДИТЕЛЬНОСТЬ ПО МЕТРИКАМ',
        message: 'Посмотрите, где находится команда по каждой метрике по сравнению со всеми командами в ранее выбранных лигах'
      },
      step3: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'ВЫБОР СЕЗОНА',
        message: 'Добавьте сезоны для измерения эффективности ударов'
      },
      step2: {
        title: 'ЗАВЕРШЕНИЕ СВОЕЙ ИЛИ СОПЕРНИКА',
        message: 'Выберите, хотите ли вы видеть карту завершения команды или всех ее соперников'
      },
      step3: {
        title: 'РАЗМЕЩЕНИЕ УДАРОВ',
        message: 'Выберите, как вы хотите видеть удары команды: по кругам или по зонам (квадратам)'
      },
      step4: {
        title: 'ТИП УДАРА',
        message: 'Фильтруйте по типу удара, стратегии, зоне или части тела'
      },
      step5: {
        title: 'ФИЛЬТР ПО МИНУТАМ',
        message: 'Полоса минут для выбора ударов и голов, забитых в определенные периоды матча'
      },
      step6: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      },
      step7: {
        title: 'КАРТА УДАРОВ',
        message: 'Карта интерактивна. Наведите курсор на каждый круг, чтобы узнать xG каждого удара'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'ВЫБОР СЕЗОНА',
        message: 'Добавьте сезоны для измерения эффективности ударов'
      },
      step2: {
        title: 'КЛЮЧЕВЫЕ ПЕРЕДАЧИ СВОЕЙ ИЛИ СОПЕРНИКА',
        message: 'Выберите, хотите ли вы видеть карту ключевых передач команды или всех ее соперников'
      },
      step3: {
        title: 'МЕСТОПОЛОЖЕНИЕ КЛЮЧЕВОЙ ПЕРЕДАЧИ',
        message: 'Выберите, хотите ли вы видеть точное местоположение ключевой передачи (круг) или по зонам области и поля (квадраты)'
      },
      step4: {
        title: 'ТИП ЗАВЕРШЕНИЯ ПОСЛЕ ПЕРЕДАЧИ',
        message: 'Фильтруйте по типу удара, стратегии, зоне или части тела, выполненным после ключевой передачи'
      },
      step5: {
        title: 'ФИЛЬТР ПО МИНУТАМ',
        message: 'Полоса минут для выбора ударов и голов, забитых в определенные периоды матча'
      },
      step6: {
        title: 'ФОРМАТЫ СКАЧИВАНИЯ ИЗОБРАЖЕНИЙ',
        message: 'Доступны три формата скачивания: png, svg и embed'
      },
      step7: {
        title: 'КАРТА УДАРОВ',
        message: 'Карта интерактивна. Наведите курсор на каждый круг, чтобы узнать xA каждой передачи'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'ПОСЛЕДНИЕ МАТЧИ',
        message: 'Просмотрите результаты, владение, xG и процент побед всех матчей команды'
      }
    },
    teamTransfers: {
      step1: {
        title: 'ПРИБЫТИЯ',
        message: 'Просмотрите все прибытия (покупки + трансферы) за календарный год'
      },
      step2: {
        title: 'УХОДЫ',
        message: 'Просмотрите все уходы (продажи + трансферы) по календарному году'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'ТРЕНДЫ',
        message: 'Запросите форму команды через серии, победы, сухие матчи, возвращения, периоды с голами или типы голов'
      },
      step2: {
        title: 'СТАНДАРТЫ',
        message: 'Сравните производительность команды между стандартными положениями и игрой в открытую и получите подробный обзор стандартов'
      },
      step3: {
        title: 'ЗАМЕНЫ',
        message: 'Посмотрите, когда команда делает замены и какие игроки заменяются чаще всего'
      },
      step4: {
        title: 'СВЯЗИ',
        message: 'Просмотрите наиболее распространенные связи между игроками. Фильтруйте по сезону и типу игры'
      },
      step5: {
        title: 'АТАКУЮЩИЕ ЗОНЫ',
        message: 'Откройте атакующие зоны команды и фильтруйте по сезону или типу атаки'
      },
      step6: {
        title: 'РАССТАНОВКИ',
        message: 'Проверьте наиболее используемые расстановки и их процент побед, ничьих и поражений с каждой из них'
      },
      step7: {
        title: 'ЗОНЫ УДАРОВ',
        message: 'Фильтруйте по сезону, команде или сопернику, способу визуализации карты, типам ударов или минутам'
      },
      step8: {
        title: 'НАВЕСЫ',
        message: 'Запросите и фильтруйте по сезону, типу отображения, успешным или неуспешным, откуда они начинаются и заканчиваются или включая угловые'
      },
      step9: {
        title: 'ИГРОКИ',
        message: 'Фильтруйте по сезону, типу отображения, успешным или неуспешным, откуда они начинаются и заканчиваются или включая угловые'
      }
    },
    teamOnOff: {
      step1: {
        title: 'СЕЗОНЫ И МАТЧИ',
        message: 'Фильтруйте по сезону, матчам или домашним или гостевых играм'
      },
      step2: {
        title: 'ИГРОКИ',
        message: 'Просмотрите производительность всех игроков в составе через множество метрик'
      }
    }
  },
  alerts: {
    numPlayers: 'Количество игроков',
    newPlayersLastWeek: 'Новые игроки на прошлой неделе',
    subtitle: 'Получайте уведомления, когда новые игроки соответствуют вашим критериям поиска',
    generalSubtitle: 'Получайте уведомления о новых игроках на основе ваших критериев и новости о ваших любимых игроках',
    subtitlePlayer: 'Получайте уведомления, когда у нас есть новости о ваших любимых игроках',
    subtitleSearch: 'Получайте уведомления, когда новые игроки соответствуют вашим критериям поиска',
    favorite: 'Избранное',
    newEventCalendar: 'Новое событие',
    updatedEventCalendar: 'Обновленное событие',
    newShareFrom: 'Новый обмен от',
    injuryAlert: 'Уведомление о травме',
    contractAlert: 'Уведомление о контракте',
    teamAlert: 'Уведомление о подписании',
    marketValueAlert: 'Уведомление о рыночной стоимости',
    gameAlert: 'Уведомление об игре'
  },
  videoEvents: {
    highlights: 'Хайлайты',
    fullGame: 'Полный матч',
    autoplay: 'Автовоспроизведение',
    searchBarPlaceholder: 'Поиск игрока, матча или команды...',
    subtitle: 'Анализируйте события через видео',
    successful: 'Успех',
    unsuccessful: 'Неудача',
    playing: 'Играет',
    games: 'Матчи',
    moreFilters: 'Больше фильтров...',
    startArea: 'Начальная зона',
    endArea: 'Конечная зона',
    select: 'Выбрать',
    selectLastXGames: 'Выбрать последние {0} матчей',
    advancedFilters: 'Расширенные фильтры',
    freeKicks: 'Штрафные',
    cornerKicks: 'Угловые',
    allShots: 'Все удары',
    generateZip: 'Скачать видео',
    zippedModalMessage: 'Мы создаем ваш список видео и отправим его на вашу электронную почту в ближайшее время',
    clickToSeeVideo: 'Нажмите, чтобы посмотреть видео'
  },
  videoUpload: {
    subtitle: 'Загрузите видео и создайте новый матч',
    uploadVideo: 'Загрузить видео',
    selectPeriod: 'Выберите период',
    gameData: 'Данные матча',
    venue: 'Место проведения',
    matchType: 'Тип матча',
    matchGroup: 'Группа матча',
    roundType: 'Тип раунда',
    roundNumber: 'Номер раунда',
    offsetFh: 'Смещение первого тайма',
    offsetSh: 'Смещение второго тайма',
    offsetFhOT: 'Смещение первого тайма овертайма',
    offsetShOT: 'Смещение второго тайма овертайма',
    homeLineup: 'Состав дома',
    awayLineup: 'Состав в гостях',
    existingPlayer: 'Существующий игрок',
    newPlayer: 'Новый игрок',
    startingTeam: 'Стартовый',
    saveAndUpload: 'Сохранить и загрузить',
    existingGame: 'Матч уже существует',
    sendToKora: 'Отправить',
    invalidForm: 'Неверная форма',
    warningModalTitle: 'Обнаружены аномалии',
    noScoreSheetWarning: 'Протокол не прикреплен',
    onlyOnePartUploadedWarning: 'Прикреплен только один тайм',
    continueQuestion: 'продолжить?',
    slaLimit: 'Вы загрузили {0} матчей с {1}. Ваш лимит {2}',
    requestedGames: 'Запрошенные матчи',
    limitClose: 'Осталось запросить только {0} матчей',
    limitReached: 'Вы достигли лимита загрузки видео. Загрузка дополнительных матчей может привести к дополнительным расходам.',
    seasonFinishedWarning: 'Это создаст матч в сезоне, который уже закончился. Пожалуйста, проверьте, что это правильно.',
    teamCountryWarning: 'Эта команда из другой страны, чем выбранная лига. Пожалуйста, проверьте, что это правильно.',
    uploading: 'Загрузка',
    doNotNavigateAway: 'Пожалуйста, не закрывайте эту вкладку, не обновляйте страницу и не уходите с нее во время загрузки.',
    severalMinutes: 'Этот процесс может занять несколько минут.'
  },
  videoPlaylists: {
    subtitle: 'Коллекции фильтров видео хайлайтов',
    savePlaylist: 'Сохранить плейлист',
    seeAllPlaylists: 'Посмотреть все плейлисты'
  },
  videoHighlights: {
    recap: 'Обзор',
    homeCondensed: 'Сжатый матч дома',
    awayCondensed: 'Сжатый матч в гостях',
    selectedActions: 'Выбранные действия',
    noActions: 'Нет действий, соответствующих указанным критериям фильтра',
    noGames: 'Матчи еще не загружены',
    attackingActions: 'Атакующие действия',
    defensiveActions: 'Защитные действия',
    groundDuels: 'Единоборства на земле',
    penaltiesProvoked: 'Спровоцированные пенальти',
    goalkeeperActions: 'Действия вратаря',
    addSomeGames: 'Начните с добавления матчей!',
    goToVideoUploadTool: 'Перейти к инструменту загрузки видео',
    ballInPlay: 'Мяч в игре',
    filterSeasons: 'Фильтр сезонов',
    streaming: 'Потоковое вещание',
    clips: 'Клипы',
    qualifiers: {
      Pass: 'Передача',
      Save: 'Спасение',
      'Saved Shot': 'Спасенный удар',
      Shot: 'Удар',
      Goal: 'Гол',
      'Missed Shot': 'Мимо ворот',
      'Shot on Post': 'Удар в штангу',
      Error: 'Ошибка',
      Clearance: 'Вынос',
      Aerial: 'Игра в воздухе',
      Challenge: 'Проигранное единоборство на земле',
      Dispossessed: 'Потеря владения',
      Foul: 'Фол',
      Card: 'Карточка',
      'Offside Pass': 'Передача в офсайд',
      Claim: 'Захват навеса',
      'Keeper Pickup': 'Подбор вратарем',
      'Ball Touch': 'Касание мяча',
      Dribble: 'Дриблинг',
      Interception: 'Перехват',
      Tackle: 'Отбор',
      'Ball Recovery': 'Подбор мяча',
      Takeon: 'Дриблинг'
    },
    qualifierIds: {
      1: 'Длинная передача',
      2: 'Навес',
      5: 'Выполнен штрафной',
      6: 'Выполнен угловой',
      9: 'Пенальти',
      15: 'Головой',
      20: 'Правой ногой',
      21: 'Другой частью тела',
      22: 'Обычная игра',
      23: 'Быстрый прорыв',
      24: 'Стандарт',
      25: 'С углового',
      26: 'Штрафной',
      28: 'Автогол',
      29: 'С передачей',
      31: 'Желтая карточка',
      32: 'Вторая желтая карточка',
      33: 'Красная карточка',
      72: 'Левой ногой',
      73: 'Слева',
      82: 'Спасенный удар (без ВР)',
      94: 'Блок защитника',
      123: 'Вбрасывание вратарем',
      124: 'Удар от ворот',
      160: 'Вбрасывание со стандарта',
      170: 'Привело к голу',
      173: 'Отбито безопасно',
      174: 'Отбито опасно',
      177: 'Захвачено',
      178: 'Стоя',
      179: 'В падении',
      182: 'Руками',
      183: 'Ногами',
      185: 'Заблокированный навес',
      210: 'Передача',
      215: 'Индивидуальная игра',
      279: 'Начало матча',
      285: 'Защитный',
      286: 'Атакующий'
    },
    areas: {
      goalArea: 'Зона ворот',
      boxLeft: 'Штрафная слева',
      boxCenter: 'Штрафная центр',
      boxRight: 'Штрафная справа',
      outBoxDeepLeft: 'Вне штрафной глубоко слева',
      outBoxDeepRight: 'Вне штрафной глубоко справа',
      outBoxLeft: 'Вне штрафной слева',
      outBoxCentreLeft: 'Вне штрафной центр-слева',
      outBoxCentre: 'Вне штрафной центр',
      outBoxCentreRight: 'Вне штрафной центр-справа',
      outBoxRight: 'Вне штрафной справа',
      midfieldLeft35: 'Центр поля слева',
      midfieldCentreLeft35: 'Центр поля центр-слева',
      midfieldCentre35: 'Центр поля центр',
      midfieldCentreRight35: 'Центр поля центр-справа',
      midfieldRight35: 'Центр поля справа',
      ownGoalArea: 'Своя зона ворот',
      ownBoxLeft: 'Своя штрафная слева',
      ownBoxCenter: 'Своя штрафная центр',
      ownBoxRight: 'Своя штрафная справа',
      ownFieldOutOfBoxDeepLeft: 'Свое поле вне штрафной глубоко слева',
      ownFieldOutOfBoxDeepRight: 'Свое поле вне штрафной глубоко справа',
      ownFieldOutOfBoxLeft: 'Свое поле вне штрафной слева',
      ownFieldOutOfBoxCentreLeft: 'Свое поле вне штрафной центр-слева',
      ownFieldOutOfBoxCentre: 'Свое поле вне штрафной центр',
      ownFieldOutOfBoxCentreRight: 'Свое поле вне штрафной центр-справа',
      ownFieldOutOfBoxRight: 'Свое поле вне штрафной справа',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Успех',
      fail: 'Неудача',
      possessionWon: 'Владение выиграно',
      possessionNotWon: 'Владение не выиграно',
      received: 'Получено',
      provoked: 'Спровоцировано'
    },
    homePlayerHighlights: 'Лучшие моменты домашних игроков',
    awayPlayerHighlights: 'Лучшие моменты игроков на выезде'
  },
  share: {
    shareTo: 'Отправить',
    viaApp: 'Приложение (Driblab Message)',
    viaEmail: 'Электронная почта',
    description: 'Описание',
    titleTab: 'Обмены',
    toMe: 'Получено',
    fromMe: 'Отправлено',
    typeInternal: 'Внутренний',
    typeExternal: 'Внешний',
    title: 'Общие',
    subtitle: 'Обзор элементов в вашем списке обмена и ваших обменов',
    selectUser: 'Выберите пользователя',
    expired: 'Истек',
    limitReached: 'Ссылка достигла лимита использований'
  },
  homeStats: {
    data: 'Доступные данные',
    players: 'игроков',
    totalPlayers: 'всего игроков',
    teams: 'команд',
    totalTeams: 'всего команд',
    leagues: 'лиг',
    totalLeagues: 'всего лиг',
    seasons: 'сезонов',
    totalSeasons: 'всего сезонов',
    games: 'матчей',
    totalGames: 'всего матчей'
  },
  scoutingCalendar: {
    subtitle: 'Создавайте и организуйте свои задачи разведки',
    myCalendars: 'Приватный календарь',
    publicCalendars: 'Публичные календари',
    otherCalendars: 'Другие календари',
    calendarSettings: 'Настройки календаря',
    moreInfo: 'Больше информации',
    individualScouting: 'Индивидуальная разведка',
    matchScouting: 'Разведка матча',
    calendarView: {
      type: 'Тип календаря',
      month: 'Месяц',
      week: 'Неделя',
      day: 'День'
    },
    weekView: {
      type: 'Тип недели',
      monSun: 'Понедельник - Воскресенье',
      sunSat: 'Воскресенье - Суббота',
      monFri: 'Понедельник - Пятница'
    },
    tasks: {
      addNew: 'Добавить новую задачу',
      myTasks: 'Мои задачи',
      filterTasks: 'Фильтровать задачи',
      sharedWithMe: 'Общие со мной',
      createTask: 'Создать задачу',
      newTask: 'Новая задача',
      taskName: 'Название задачи',
      allDay: 'Весь день',
      startDate: 'Дата начала',
      endDate: 'Дата окончания',
      startHour: 'Час начала',
      endHour: 'Час окончания',
      assignedTo: 'Назначено',
      assignedToMe: 'Назначено мне',
      color: 'Цвет',
      scoutingType: 'Тип разведки',
      taskLocation: 'Местоположение задачи',
      selectLeague: 'Выберите лигу',
      selectMatch: 'Выберите матч',
      useMatchdate: 'Использовать дату матча',
      stadium: 'Стадион',
      travel: 'Поездка',
      hotel: 'Отель',
      tickets: 'Билеты',
      taskNotes: 'Введите описательные заметки или комментарии, связанные с задачей',
      states: {
        toDo: 'К выполнению',
        inProgress: 'В процессе',
        done: 'Выполнено'
      },
      type: {
        player: 'Оценка игрока',
        team: 'Оценка команды',
        other: 'Другое'
      },
      location: {
        stadium: 'На стадионе',
        video: 'Видео'
      },
      accommodation: {
        accommodationDetails: 'Детали размещения',
        ownArrangement: 'Собственное размещение',
        required: 'Требуется',
        notRequired: 'Не требуется',
        booked: 'Забронировано'
      },
      assignToMe: 'Назначить мне',
      addOther: 'Добавить другого',
      deleteTask: 'Удалить задачу',
      deleteTaskMessage: 'Задача будет удалена, вы уверены?',
      cancelUpdate: 'Отменить обновление',
      cancelUpdateMessage: 'Изменения не будут сохранены, вы уверены?',
      selectGame: 'Пожалуйста, выберите матч для добавления файлов',
      noData: 'Нет данных. Начните с добавления задач!',
      widgetSubtitle: 'Проверьте свои следующие задачи',
      scoutingDetails: 'Детали разведки',
      taskDetails: 'Детали задачи',
      playerDocuments: 'Документы игрока',
      teamDocuments: 'Документы команды',
      gameDocuments: 'Документы матча',
      taskDocuments: 'Документы задачи',
      task: 'Задача'
    },
    nextGames: 'Следующие матчи'
  },
  scoutingTasksBoard: {
    period: {
      week: 'На этой неделе',
      month: 'В этом месяце',
      year: 'В этом году'
    },
    noTasks: 'Создайте новые задачи или перетащите одну сюда!',
    goToBoard: 'Перейти к доске'
  },
  profile: {
    title: 'Профиль',
    subtitle: 'Настройте свой аккаунт и детали подписки'
  },
  hub: {
    onlyHub: 'Доступно только в Driblab Hub',
    blue: 'синий',
    purple: 'фиолетовый',
    orange: 'апельсин',
    grey: 'серый',
    indigo: 'индиго',
    teal: 'бирюзовый',
    lightBlue: 'светло-голубой',
    brown: 'коричневый'
  },
  uploadedGames: {
    subtitle: 'Все загруженные матчи',
    timeRequested: 'Время запроса',
    timeReceived: 'Когда получено',
    diffHours: 'Разница в часах',
    collectionCompleted: 'Сбор завершен',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    goToUploadedGames: 'Перейти к загруженным матчам',
    sla: 'Соглашение об уровне сервиса',
    matchDate: 'Дата матча',
    rejectedGame: 'Отклонено',
    reviewed: 'Проверено',
    requested: 'Запрошено',
    koraStatus: 'Статус Kora',
    aws: 'AWS',
    fullVideo: 'Полное видео',
    offset: 'Смещение',
    updateFullVideo: 'Обновить полное видео?'
  },
  gameMap: {
    title: 'Карта матчей',
    subtitle: 'Исследуйте матчи на ближайшие дни',
    warning: 'Время и место могут быть неточными. Пожалуйста, подтвердите эту информацию.',
    taskAdded: 'Задача успешно создана. Проверьте календарь разведки.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Успешно уведомлено',
    notPermissions: 'У вас нет разрешений на просмотр',
    notPermissionsLeague: 'У вас нет разрешений на просмотр этой лиги',
    notPermissionsGame: 'У вас нет разрешений на просмотр этого матча',
    requestAccessTo: 'Запросить доступ к',
    sendRequest: 'Отправить запрос'
  },
  videoTeams: {
    subtitle: 'Найдите последние матчи, помеченные по команде',
    noGamesUploaded: 'Матчи еще не загружены'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Анализ разведки',
    scoutingAnalyses: 'Анализы разведки',
    playerScoutingAnalyses: 'Анализы разведки игроков',
    gameScoutingAnalyses: 'Анализы разведки матчей',
    analyses: 'Анализы',
    addReport: 'Добавить анализ',
    technical: 'Технический',
    tactical: 'Тактический',
    physical: 'Физический',
    mental: 'Психологический',
    technicalNotes: 'Технические заметки',
    tacticalNotes: 'Тактические заметки',
    physicalNotes: 'Физические заметки',
    mentalNotes: 'Психологические заметки',
    conclusion: 'Заключение',
    charactersMax: 'Макс 1000 символов',
    globalRating: 'Общая оценка',
    noData: 'Нет данных. Начните с добавления анализов разведки!',
    deleteAnalysis: 'Удалить анализ разведки',
    deleteAnalysisMessage: 'Анализ будет удален навсегда. Вы уверены?',
    avgTooltip: 'Среднее на основе итоговых оценок анализов, видимых вам',
    avgOverallScoreTooltip: 'Среднее на основе общих оценок игрока, видимых вам',
    scouter: 'Скаут',
    lastEdited: 'Последнее редактирование',
    analysisFilters: 'Фильтры анализа',
    generalFilters: 'Общие фильтры',
    widgetSubtitle: 'Последние добавленные анализы',
    addPlayerReport: 'Добавить анализ разведки игрока',
    seeReports: 'Посмотреть отчеты',
    addGameReport: 'Добавить анализ разведки матча',
    keyPlayers: 'Ключевые игроки',
    formation: 'Расстановка',
    inPossession: 'Во владении',
    notesIP: 'Заметки во владении',
    outOfPossession: 'Без владения',
    notesOP: 'Заметки без владения',
    transitions: 'Переходы',
    notesTransitions: 'Заметки о переходах',
    notesSP: 'Заметки о стандартах',
    finalRating: 'Итоговая оценка',
    gameNotesPlaceholder: 'Введите описательные заметки или комментарии, связанные с матчем',
    avgPotentialTooltip: 'Среднее значение, основанное на возможностях видимых вам анализов',
    potential: 'Потенциал',
    tags: 'Теги',
    tagsPlaceholder: 'Добавьте несколько тегов',
    tagsHint: 'Введите и нажмите Enter, чтобы добавить тег',
    exampleTags: {
      leadership: 'Лидерство',
      resilience: 'Устойчивость',
      competitiveMindset: 'Конкурентное мышление',
      calmUnderPressure: 'Спокойствие под давлением',
      focus: 'Фокус',
      discipline: 'Дисциплина',
      coachability: 'обучаемость',
      poorBodyLanguage: 'Плохой язык тела',
      lowConfidence: 'Низкая уверенность',
      easilyFrustrated: 'Легко разочаровывается'
    }
  },
  addPlayerForm: {
    noLeague: 'Создание команды без лиги может негативно повлиять на ее индексацию и последующий поиск в приложении.'
  },
  expenses: {
    expense: 'Расход',
    expenses: 'Расходы',
    addExpense: 'Добавить расход',
    transportation: 'Транспорт',
    accommodation: 'Размещение',
    dietary: 'Питание',
    eventTicket: 'Билет на событие',
    expenseType: 'Тип расхода',
    amount: 'Сумма',
    expenseDate: 'Дата расхода',
    expenseFilters: 'Фильтры расходов',
    noData: 'Нет данных. Начните с добавления расходов!',
    deleteExpense: 'Удалить расход',
    deleteExpenseMessage: 'Расход будет удален навсегда. Вы уверены?'
  },
  disabledTooltips: {
    general: 'Эта функция в настоящее время отключена',
    youth: 'Должен быть молодежным, чтобы установить возраст',
    unit: 'Статистика должна быть Пробежки, HSR или SPR',
    seasonsWithout60MinsGames: 'Игрок не сыграл более 60 минут в одном матче в выбранном сезоне(ах)',
    notEditable: 'Это нельзя редактировать',
    noMatchdate: 'Дата матча недоступна',
    selectGame: 'Сначала выберите матч',
    selectPlayer: 'Сначала выберите игрока',
    selectTeam: 'Сначала выберите команду',
    selectBoxes: 'Должна быть выбрана визуализация квадратами',
    selectYear: 'Сначала выберите год',
    pdScoreNotAvailable: 'Оценка недоступна для игроков, которые не достигли 60 минут игры в матче',
    pdSeasonNotAvailable: 'Физические данные недоступны для этого сезона',
    pdGameNotAvailable: 'Физические данные недоступны для этого матча'
  },
  leagueTypes: {
    regular: 'Обычная',
    continental: 'Континентальная',
    nationalTeam: 'Сборная',
    countryCup: 'Кубок страны',
    qualifier: 'Квалификация',
    playOff: 'Плей-офф',
    regionalLeague: 'Региональная лига',
    friendly: 'Товарищеский',
    nationalFriendly: 'Товарищеский сборной',
    nationaQualifier: 'Квалификация сборной'
  },
  playerSides: {
    'Left/Right': 'Слева/Справа',
    'Left/Centre/Right': 'Слева/Центр/Справа',
    Right: 'Справа',
    Centre: 'Центр',
    'Centre/Right': 'Центр/Справа',
    Left: 'Слева',
    'Left/Centre': 'Слева/Центр'
  },
  areaSelector: {
    selectAreas: 'Выбрать зоны',
    filterAreas: 'Фильтровать зоны'
  },
  spatialCoverage: {
    lastDefenderDist: 'Дистанция последнего защитника',
    defensiveLineDist: 'Дистанция защитной линии',
    fullBackAvgDist: 'Средняя дистанция фулбека',
    offensiveLineDist: 'Дистанция атакующей линии',
    distanceToGoal: 'Дистанция до ворот',
    avgLineWidth: 'Сред. ширина линии',
    leagueAvgDistanceToGoal: 'Сред. дистанция лиги до ворот',
    leagueAvgLineWidth: 'Сред. ширина линии лиги',
    avgShort: 'Сред.',
    meters: 'метров',
    leagueAvgDist: 'Сред. дистанция лиги',
    distance: 'Дистанция',
    avgPositionYAxis: 'Сред. расстояние на поле (Y)',
    leagueAvgPositionYAxis: 'Сред. расстояние лиги на поле (Y)',
    lbRbDistanceSeparation: 'Расстояние LB–RB',
    leagueAvgLbRbDistanceSeparation: 'Сред. расстояние лиги LB–RB',
    legendTeam: 'Команда',
    legendLeagueAvg: 'Сред. лиги',
    maxLength: 'Максимальная длина',
    maxWidth: 'Максимальная ширина',
    avgBlockDistance: 'Среднее расстояние блока'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Интеллектуальные данные',
    passesUnderPressureSubtitle: 'Анализируйте процент успешных передач, сделанных под давлением защиты.',
    onBallPressureSubtitle: 'Анализируйте события давления на мяч и их успешность по зонам поля',
    ballReceiptsInSpaceSubtitle: 'Анализируйте передачи, полученные в космосе, по зонам поля',
    ballReceipts: 'квитанции',
    totalBallReceipts: 'Всего Приёмов Мяча',
    totalBallReceiptsCompleted: 'Всего Приёмов Мяча Завершено',
    completed: 'Завершено',
    lineBreakingPassesSubtitle: 'Анализируйте передачи, которые ломают линии и создают преимущества',
    bypassed: 'Обводка',
    oppsBypassed: 'Обойденные соперники',
    passer: 'Пасующий',
    passedTo: 'Передать',
    receivedFrom: 'Получено от',
    distanceToNearestDefender: 'Расстояние до ближайшего защитника',
    lineBreaking: 'Проникающий {0}',
    keyPass: 'Ключевая передача',
    receiver: 'Принимающий',
    dynamicTracking: 'Динамическое отслеживание',
    eventLockTooltip: 'Некоторых игроков не было видно во время игры.',
    bypassedPlayers: '{0} обыгранных игроков',
    playersCount: '{0} игроков',
    bothTeams: 'Обе команды',
    matchesCount: '{0} матчей',
    lbpType: {
      F: 'Атака',
      M: 'Полузащита',
      B: 'Оборона',
      MF: 'Полузащита и атака',
      BM: 'Оборона и полузащита',
      BF: 'Оборона и атака',
      BMF: 'Оборона, полузащита и атака'
    },
    lbpCategory: {
      'G-IN-T': 'По земле внутри (ломает линию обороны)',
      'G-IN-NT': 'По земле внутри (не ломает линию обороны)',
      'G-OUT-T': 'По земле снаружи (ломает линию обороны)',
      'G-OUT-NT': 'По земле снаружи (не ломает линию обороны)',
      'O-IN-T': 'Навесом внутри (ломает линию обороны)',
      'O-IN-NT': 'Навесом внутри (не ломает линию обороны)',
      'O-OUT-T': 'Навесом снаружи (ломает линию обороны)',
      'O-OUT-NT': 'Навесом снаружи (не ломает линию обороны)',
      ground: 'По земле',
      over: 'Навесом',
      inside: 'Внутри',
      outside: 'Снаружи',
      through: 'Ломает линию обороны',
      notThrough: 'Не ломает линию обороны',
      throughAbbr: 'Нарушение защиты. линия',
      notThroughAbbr: 'Не нарушая защиты. линия'
    },
    lbpCategorySplit: {
      G: 'Земля: проход был заземлен.',
      O: 'Овер: Мяч отлетел в воздух',
      OUT: 'Снаружи: пропуск вышел наружу',
      IN: 'Внутри: пропуск вошел внутрь',
      T: 'Ломает линию обороны: передача ломает линию обороны изнутри',
      NT: 'Не ломает линию обороны: передача не ломает её изнутри; обходит снаружи'
    },
    obrType: {
      OL: 'Перекрытие',
      UL: 'Подбегание',
      RA: 'Забегание вперед',
      RB: 'Забегание назад',
      CR: 'Прием навеса',
      SP: 'Поддержка',
      CS: 'Короткий забег'
    },
    visualization: 'Визуализация',
    points: 'Круги',
    zones: 'Тепловая карта',
    pressureIntensity: 'Интенсивность давления',
    pressureOutcome: 'Результат давления',
    passesOutcome: 'Результат передач',
    strong: 'Сильный',
    light: 'Легкий',
    normal: 'Нормальный',
    successful: 'Успешный',
    unsuccessful: 'Неуспешный',
    presses: 'Давления',
    passes: 'Проходит',
    passUnder: 'Пройти под',
    successRate: 'Уровень успеха',
    pressureOn: 'Давление на',
    pressureOf: 'Давление',
    pressure: 'Давление',
    totalLabel: 'общее',
    totalPasses: 'Всего проходов',
    unknown: 'неизвестно',
    selectGameToViewMap: 'Выберите игру, чтобы посмотреть карту давления',
    noEventsFoundForGame: 'Не найдено событий давления для этой игры',
    noEventsFoundForTeamAndSeason: 'Не найдено событий давления для этой команды и сезона',
    noEventsFoundForPlayerAndSeason: 'Не найдено событий давления для этого игрока и сезона',
    noEventsMatchFilters: 'Не найдено событий, соответствующих текущим фильтрам',
    totalEventsAvailable: 'общее количество событий',
    passType: {
      P: 'Проходить',
      A: 'Помощь',
      KP: 'Ключевой пропуск',
      PiOB: 'Перейдите в Опп. Коробка',
      PiFT: 'Переход в финальную треть',
      SoPP: 'Переключение Play Pass'
    },
    minFrom: 'Мин. от',
    minTo: 'Мин до',
    secondFrom: 'Сегментировать из',
    secondTo: 'Сегментировать',
    positionPlayed: 'Сыгранная позиция',
    highlight: 'Выделять',
    passTypeLabel: 'Тип пропуска',
    offBallRunSubtitle: 'Анализируйте движения без мяча',
    insights: 'Информация',
    insightsSubtitle: 'Рейтинг лучших с помощью расширенной аналитики Arrigo',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Чем я могу помочь вам сегодня?',
    chatSubtext: 'Спросите что-нибудь о футбольных данных!',
    thinking: 'Думая...',
    giveFeedback: 'Оставить отзыв',
    disclaimer: 'DriblabAI может ошибаться. Пожалуйста, обязательно проверьте информацию.',
    recent: 'Недавний',
    noConversations: 'Здесь вы увидите ваши недавние разговоры!',
    rename: 'Переименовать',
    deleteConversation: 'Удалить разговор',
    confirmDelete: 'Вы уверены, что хотите удалить этот разговор?',
    feedback: 'Обратная связь',
    feedbackQuestion: 'Был ли этот ответ полезен?',
    feedbackComments: 'Дополнительные комментарии',
    feedbackPlaceholder: 'Расскажите нам, что было полезно или что можно улучшить...',
    errorMessage: 'Сообщение не удалось обработать. Пожалуйста, попробуйте еще раз.',
    newConversation: 'Новый чат',
    write: 'Напишите сообщение...'
  },
  periodId: {
    1: 'Первая половина',
    2: 'Вторая половина',
    3: 'Дополнительное время – 1°',
    4: 'Дополнительное время – 2º',
    5: 'Серия пенальти',
    6: 'На постоянной основе',
    7: 'Предматчевый матч',
    8: 'Заброшенный',
    9: 'Жить',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Другой'
  }
};



// WEBPACK FOOTER //
// ./src/utils/translations/ru.js